/**
 * SEO 配置 - common
 * 自动从 seo.ts 拆分生成
 */

export default {
    en: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI lets you create AI videos and images instantly using text, photos, or clips. Try it free today.',
        home: {
            h1: '微鲤AI - Free AI Video & Image Generator Platform',
            title: '微鲤AI - Free AI Video Generator & Image Tools (Kling, Flux, Veo)',
            description: `Stop juggling subscriptions. Access the world's best AI models—Kling AI, Google Veo, Sora, and Flux—all in one free dashboard. Create professional videos, swap faces, and upscale images instantly.`,
            keywords: 'AI video generator, AI image generator, text to video, image to video, AI video creation, AI image creation, video generation, image generation, AI content creation,Kling, Flux, Veo,微鲤AI',
            og_title: '微鲤AI - The All-in-One AI Creative Platform',
            og_description: 'Generate stunning videos with Kling & Flux. Text-to-Video, Face Swap, and Upscaling tools. Try it free.',
            twitter_title: '微鲤AI - Free AI Video Generator',
            twitter_description: 'Access Kling, Veo, and Flux in one place. Generate AI video & art instantly.',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'An AI-powered creative platform acting as an aggregator for top models like Kling AI, Google Veo, Sora, and Flux. Features include Text-to-Video, Face Swap, and Upscaling.',
            software_feature: 'Kling AI Integration, Text to Video, AI Face Swap, 4K Video Upscaler, Image to Video, Lip Sync, Background Remover',
            faq: [
                {
                    question: 'Why is 微鲤AI better than using models separately?',
                    answer: '微鲤AI acts as an aggregator. Instead of paying separate subscriptions for Kling, Midjourney, or Runway, you get access to all top-tier models (Kling 2.5, Flux Pro, Google Veo) in a single dashboard. It saves you money and streamlines your workflow.',
                },
                {
                    question: 'Is 微鲤AI truly free?',
                    answer: 'Yes. We offer generous daily free credits that let you test drive our Text-to-Video, Face Swap, and Image Generator tools. No credit card is needed to start. For heavy usage and no-watermark downloads, flexible paid plans are available.',
                },
                {
                    question: 'Can I use Kling AI and Flux on this platform?',
                    answer: 'Absolutely. 微鲤AI integrates the latest versions of Kling (for realistic video), Flux (for high-fidelity images), and Google Veo. We update our model library weekly so you always have access to the cutting edge.',
                },
                {
                    question: 'How can I improve my low-quality videos?',
                    answer: `Use our AI Video Upscaler. It automatically removes noise/blur and upscales footage to 4K resolution. It's perfect for restoring old family videos or improving social media clips.`,
                },
                {
                    question: 'Do I own the commercial rights to my creations?',
                    answer: 'If you are on a paid plan, yes. You own full commercial rights to all assets generated on 微鲤AI, making them safe for YouTube monetization, client work, and marketing campaigns.',
                },
            ],
        },
        homePage: {
            title: 'Home | 微鲤AI',
            description: 'Generate stunning videos and images from text, photos, or clips using 微鲤AI — the all-in-one AI video and image generator. Try it free today.',
            keywords: 'AI video generator, AI image generator, text to video, image to video, AI video creation, AI image creation, video generation, image generation, AI content creation, 微鲤AI',
        },
        aiTools: {
            title: 'Editor Toolkits - All Top AI Tools Collection | 微鲤AI',
            description: 'Explore all top AI tools collection for video and image generation. Create stunning videos and images with cutting-edge AI technology.',
            keywords: 'AI tools, video generation tools, image generation tools, AI video tools, AI image tools, 微鲤AI',
        },
        myCreations: {
            title: 'My Creations | 微鲤AI',
            description: 'View all your creations, including videos and images. Manage your creations using 微鲤AI to create high-quality visual content.',
            keywords: 'my creations, video creations, image creations, creation management, 微鲤AI',
        },
        aiImage: {
            title: 'AI Image Generator - Create Stunning Images with AI | 微鲤AI',
            description: 'Create professional AI-generated images with 微鲤AI. Transform text to image, generate creative visuals, and bring your imagination to life with advanced AI technology.',
            keywords: 'AI image generator, text to image, AI art, image creation, AI photos, digital art generator',
        },
        aiVideo: {
            title: 'AI Video Generator - Create Amazing Videos with AI | 微鲤AI',
            description: 'Generate stunning AI videos with 微鲤AI. Create videos from text, images, or videos with cutting-edge AI models like Sora, Veo, and more.',
            keywords: 'AI video generator, text to video, video creation, AI videos, video generation, Sora, Veo',
        },
        aiMusic: {
            title: 'AI Music Generator - Vocal & Instrumental Tracks | 微鲤AI',
            description: 'Create AI music in seconds with 微鲤AI: generate vocal songs or instrumentals, explore styles like Pop, Rock, Electronic, Jazz, and remix community creations.',
            keywords: 'AI music generator, AI music generator free, AI music generator with vocals, vocal song generator, instrumental music generator, text to music, make similar music, remix AI music, music styles, royalty-free music, 微鲤AI',
        },
        pricing: {
            title: 'Plans & Pricing | 微鲤AI – AI Image & Video Generation Subscription',
            description: 'Explore 微鲤AI’s flexible pricing plans for AI image and video generation. Get more monthly credits, priority processing, and access to advanced AI models. Compare Basic, Standard, and Pro plans.',
            keywords: '微鲤AI pricing, AI generator pricing, AI subscription plans, AI credits, image generation pricing, video generation pricing',
            og_title: '微鲤AI Pricing – AI Image & Video Generation Plans',
            og_description: 'Choose the best AI image and video generation plan. Access advanced models, monthly credits, and priority features. Compare 微鲤AI plans now.',
            twitter_title: '微鲤AI Pricing – Flexible AI Plans & Credits',
            twitter_description: 'Select the right plan for AI image and video generation. Includes free credits, Pro features, and priority access.',
            faq: [
                {
                    question: 'What payment methods do you accept?',
                    answer: 'We accept major credit cards including Visa, MasterCard, American Express, and more.',
                },
                {
                    question: 'How are my credits deducted for image or video generation?',
                    answer: 'Credits are deducted based on factors such as the AI model selected, video duration, output quantity, and image/video resolution.',
                },
                {
                    question: 'Do unused credits roll over to the next billing cycle?',
                    answer: 'Yes, unused credits automatically roll over to the next billing cycle and can be used anytime.',
                },
                {
                    question: 'What if I need more credits?',
                    answer: 'Free and Lite users may upgrade to higher plans. Pro users can purchase additional credits through the credit slider on the pricing page.',
                },
                {
                    question: 'How do I check my credit status?',
                    answer: 'You can view remaining credits in the top-right corner of the dashboard or on the Billing page.',
                },
                {
                    question: 'Are there any hidden fees?',
                    answer: 'No. The price shown is the final price with no hidden fees.',
                },
                {
                    question: 'What is your refund policy?',
                    answer: 'Users may request a refund within 3 days of their first purchase, provided fewer than 50 credits have been used. See the Refund Policy page for details.',
                },
            ],
            ogImage: 'https://static.weryai.com/growth/image/5ed1c0b849f436c693443b28e2068002.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/5ed1c0b849f436c693443b28e2068002.jpg',
            ogImageAlt: '微鲤AI Pricing Plans',
            twitterImageAlt: '微鲤AI Plans & Pricing',
        },
        faq: {
            title: '微鲤AI FAQs | Frequently Asked Questions About AI Video & Image Tools',
            description: 'Find answers to the most common questions about 微鲤AI’s AI video generator, AI image generator, subscriptions, credits, commercial use, payments, cancellations, and more. Learn how 微鲤AI supports creators of all levels.',
            keywords: '微鲤AI FAQ, 微鲤AI help center, 微鲤AI support, AI video generator FAQ, AI image generator FAQ, subscription questions, 微鲤AI credits, 微鲤AI commercial use',
            og_title: '微鲤AI Frequently Asked Questions',
            og_description: 'Get answers about 微鲤AI features, pricing, credits, payments, cancellations, and commercial usage. Supporting creators with AI video & image tools.',
            twitter_title: '微鲤AI FAQs — Answers for AI Video & Image Tools',
            twitter_description: 'Explore answers to 微鲤AI questions about credits, billing, commercial use, subscriptions, and more.',
            faq: [
                {
                    question: 'What is 微鲤AI?',
                    answer: '微鲤AI is a one-stop AI video and image creation platform that helps users produce high-quality content with ease. It offers tools for AI-powered video and image generation, face swapping, and character animation — enabling creators to generate professional visuals quickly and creatively.',
                },
                {
                    question: 'Is 微鲤AI suitable for beginners?',
                    answer: 'Yes. 微鲤AI is designed for creators of all skill levels. Its user-friendly interface makes it simple for both beginners and professionals to create and enhance content on PC or mobile devices anytime, anywhere.',
                },
                {
                    question: 'Can I use 微鲤AI for free? What are the benefits of paid subscriptions?',
                    answer: `Yes, 微鲤AI offers a free plan that includes some credits for all platform features. Paid subscriptions provide more credits, faster generation speeds, additional concurrent tasks, and access to advanced tools. You can view and upgrade plans via the 'Upgrade' button on the site.`,
                },
                {
                    question: 'What payment methods does 微鲤AI accept?',
                    answer: '微鲤AI uses Creem to process payments securely. You can choose from multiple supported payment options during checkout based on your location.',
                },
                {
                    question: 'How do I cancel my subscription?',
                    answer: `You can cancel your subscription anytime through the billing page by clicking 'Cancel Subscription'. Once canceled, your plan will not renew at the next billing cycle, and you will retain access until the end of the current period.`,
                },
                {
                    question: 'When will my subscription renew?',
                    answer: `Your subscription renews automatically every month on the same date you initially subscribed. Annual plan credits reset monthly on the same date. You can review all billing details under 'Billing and Payments'.`,
                },
                {
                    question: 'Can I use my creations for personal and commercial purposes?',
                    answer: 'Yes. You retain rights to your creations. Personal use is allowed for all users, while commercial use is available for Standard, Professional, and Premium plan subscribers. Please avoid using copyrighted or trademarked materials to ensure legal and ethical compliance.',
                },
                {
                    question: `What is 微鲤AI's refund policy?`,
                    answer: `Due to high computational costs, including GPU processing time for AI tasks, 微鲤AI cannot provide refunds once credits are used. This aligns with our providers' non-refundable GPU usage terms. We recommend exploring our free plan to ensure the service meets your needs before upgrading.`,
                },
            ],
            ogImage: 'https://static.weryai.com/growth/image/6b945e7a97f247d6c58938c6479d29c9.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/6b945e7a97f247d6c58938c6479d29c9.jpg',
            ogImageAlt: '微鲤AI FAQ',
            twitterImageAlt: '微鲤AI Help Center',
        },
        aboutUs: {
            title: 'About 微鲤AI | AI Video, Image & Digital Human Creation Platform',
            description: '微鲤AI is a next-generation AI content creation platform specializing in AI video generation, AI image generation, and digital human technology. Discover how 微鲤AI empowers millions of creators with advanced multimodal tools, innovative AI models, and seamless creative workflows.',
            keywords: 'About 微鲤AI, AI content creation platform, AI video generator, AI image generator, digital human AI, multimodal AI platform',
            og_title: 'About 微鲤AI — AI Video, Image & Digital Human Creation Platform',
            og_description: 'Learn about 微鲤AI, a next-generation AI platform powering millions of creators with advanced AI models for video, image, and digital human generation.',
            twitter_title: 'About 微鲤AI | AI Video & Image Creation Platform',
            twitter_description: 'Explore WeryAI’s mission and technology—powering creators with AI-generated videos, images, and digital human innovation.',
            ogImage: 'https://static.weryai.com/growth/image/1dd1b8e08699f6a3aa7daa8e3e4078f4.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/1dd1b8e08699f6a3aa7daa8e3e4078f4.jpg',
            ogImageAlt: 'About 微鲤AI',
            twitterImageAlt: '微鲤AI Company Overview',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy covering refund eligibility, application procedures, subscription rules, processing timelines, and dispute resolution.',
            keywords: '微鲤AI refund policy, refund rules, subscription refund, policy terms, 微鲤AI terms',
            og_title: 'Refund Policy | 微鲤AI',
            og_description: 'Read the official 微鲤AI Refund Policy, including refund conditions, application process, timelines, and subscription refund rules.',
            twitter_title: 'Refund Policy | 微鲤AI',
            twitter_description: 'View the official 微鲤AI Refund Policy, including eligibility, processing rules, and subscription refund guidelines.',
            ogImage: 'https://static.weryai.com/growth/image/72724c8b91d14b3230917832a88d2e05.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/72724c8b91d14b3230917832a88d2e05.jpg',
            ogImageAlt: '微鲤AI Refund Policy',
            twitterImageAlt: '微鲤AI Refund Policy Page',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy to learn how we collect, use, store, and protect your personal data. Review user rights, data security, third-party sharing rules, and compliance information.',
            keywords: '微鲤AI privacy policy, data protection, user privacy, data collection, privacy terms',
            og_title: 'Privacy Policy | 微鲤AI',
            og_description: 'Learn how 微鲤AI collects, uses, and protects your personal information. Review user rights, data security measures, and compliance rules.',
            twitter_title: 'Privacy Policy | 微鲤AI',
            twitter_description: 'Review the official 微鲤AI Privacy Policy covering data collection, storage, processing, and user rights.',
            ogImage: 'https://static.weryai.com/growth/image/cf1b252ca192789e5708af2765c5c701.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/cf1b252ca192789e5708af2765c5c701.jpg',
            ogImageAlt: 'Privacy Policy | 微鲤AI',
            twitterImageAlt: '微鲤AI Privacy Policy Page',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions governing access, use of services, user responsibilities, intellectual property rights, payment terms, suspensions, and legal compliance.',
            keywords: '微鲤AI terms, Terms and Conditions, service agreement, user agreement, legal terms',
            og_title: 'Terms and Conditions | 微鲤AI',
            og_description: 'Review the official Terms and Conditions for 微鲤AI, including service scope, user obligations, intellectual property rights, payment rules, restrictions, and dispute resolution.',
            twitter_title: 'Terms and Conditions | 微鲤AI',
            twitter_description: 'Read the official 微鲤AI Terms and Conditions detailing service rules, user responsibilities, and legal terms.',
            ogImage: 'https://static.weryai.com/growth/image/095615a570addb67ad68df70b8f1ca2b.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/095615a570addb67ad68df70b8f1ca2b.jpg',
            ogImageAlt: '微鲤AI Terms and Conditions',
            twitterImageAlt: '微鲤AI Terms Page',
        },
        videoModels: {
            title: 'AI Video Models - Veo, Sora, Kling AI & More | 微鲤AI',
            description: 'Explore our collection of advanced AI video generation models including Veo 3.1, Sora 2, Kling AI, Runway and more. Create stunning videos with cutting-edge AI technology.',
            keywords: 'AI video models, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, video generation models, AI video technology',
        },
        imageModels: {
            title: 'AI Image Models - FLUX, Nano Banana, Imagen & More | 微鲤AI',
            description: 'Explore our collection of advanced AI image generation models including FLUX, Nano Banana, Imagen, GPT-4o and more. Create professional images with state-of-the-art AI models.',
            keywords: 'AI image models, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, image generation models, AI image technology',
        },
        ugcDetailImage: {
            title: 'Free AI Image Generator | Create Your Own | 微鲤AI',
            description: `Check out this amazing AI-generated image and create your own for free! 微鲤AI's powerful AI generator turns your ideas into stunning visuals in seconds. Try it now!`,
            keywords: 'AI image generator, free AI art, AI generated image, text to image, create AI images, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Free AI Video Generator | Create Your Own | 微鲤AI',
            description: `Check out this amazing AI-generated video and create your own for free! 微鲤AI's powerful AI generator turns your ideas into stunning videos in seconds. Try it now!`,
            keywords: 'AI video generator, free AI video, AI generated video, text to video, create AI videos, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Free AI Music Generator | Create Your Own Music | 微鲤AI',
            description: `Listen to this amazing AI-generated music and create your own for free! 微鲤AI's powerful AI music generator turns your ideas into unique songs in seconds. Try it now!`,
            keywords: 'AI music generator, free AI music, AI generated music, text to music, create AI songs, royalty-free music, 微鲤AI',
            og_title: 'Free AI Music Generator | Create Your Own Music | 微鲤AI',
            og_description: `Listen to this amazing AI-generated music and create your own for free! 微鲤AI's powerful AI music generator turns your ideas into unique songs in seconds.`,
            twitter_title: 'Free AI Music Generator | 微鲤AI',
            twitter_description: `Create amazing AI-generated music for free! Turn your ideas into unique songs in seconds with 微鲤AI's AI music generator.`,
        },
        characters: {
            title: 'AI Characters - Chat with AI Characters & Virtual Companions | 微鲤AI',
            description: 'Chat with thousands of AI characters on 微鲤AI. Discover anime characters, virtual companions, and interactive AI personalities. Start conversations with AI characters for free.',
            keywords: 'AI characters, AI chat, virtual companions, anime characters, AI personality, character chat, AI conversation, virtual friends, 微鲤AI',
            og_title: 'AI Characters - Chat with AI Characters & Virtual Companions | 微鲤AI',
            og_description: 'Explore thousands of AI characters and start meaningful conversations. Chat with anime characters, virtual companions, and interactive AI personalities for free.',
            twitter_title: 'AI Characters - Chat with AI Characters | 微鲤AI',
            twitter_description: 'Discover and chat with thousands of AI characters. Anime characters, virtual companions, and interactive personalities—all free on 微鲤AI.',
        },
        characterToImage: {
            title: 'AI Character to Image - Create Photos with Any Character | 微鲤AI',
            description: 'Upload your own character photos or choose from the 微鲤AI platform to generate high-quality photos of you and the character together with AI.',
            keywords: 'AI character to image, character consistency, AI character generator, interactive character photos, 微鲤AI character',
            og_title: 'AI Character to Image - Create Photos with Any Character | 微鲤AI',
            og_description: 'Create high-quality interactive photos with any AI character. Upload your own character or choose from 微鲤AI to generate stunning character images.',
            twitter_title: 'AI Character to Image - Create Photos with Any Character | 微鲤AI',
            twitter_description: 'Generate photos of you and your favorite characters. Upload or select characters on 微鲤AI to create interactive character art.',
            faq: [
                {
                    question: 'What is 微鲤AI Character to Image?',
                    answer: '微鲤AI Character to Image is an AI-powered tool that allows you to generate images featuring specific characters while maintaining their visual consistency. You can upload your own character photos or choose from our pre-defined character library.',
                },
                {
                    question: 'Can I generate photos of myself with a character?',
                    answer: 'Yes! By providing a description (prompt) of yourself and the character, the AI can generate realistic or artistic photos of you interacting with the chosen character.',
                },
                {
                    question: 'How many characters can I choose from?',
                    answer: '微鲤AI offers a vast library of characters from anime, games, and original designs. You can also upload your own character photos to create unique interactions.',
                },
                {
                    question: 'Does it support high resolution?',
                    answer: 'Absolutely. We support up to 4K high-resolution image generation to ensure your character photos look professional and detailed.',
                },
                {
                    question: 'How do I maintain character consistency?',
                    answer: 'Our advanced AI models are trained to recognize and preserve character features, ensuring that the generated images look exactly like the reference character you selected or uploaded.',
                },
            ],
        },
        characterToVideo: {
            title: 'AI Character to Video - Generate Interactive Character Videos | 微鲤AI',
            description: 'Create amazing videos with any AI character. Upload character photos or select from 微鲤AI to generate interactive videos of you and characters together.',
            keywords: 'AI character to video, character video generator, interactive AI video, character consistency video, 微鲤AI',
            og_title: 'AI Character to Video - Generate Interactive Character Videos | 微鲤AI',
            og_description: 'Transform your ideas into interactive videos with any AI character. Upload or choose characters on 微鲤AI to generate realistic character motion.',
            twitter_title: 'AI Character to Video - Create Interactive Character Videos | 微鲤AI',
            twitter_description: 'Generate high-quality videos featuring your favorite characters. Upload or select characters on 微鲤AI for interactive AI video creation.',
            page: {
                title1: 'Free AI Character to Video Generator',
                title2: `Bring your favorite characters to life! Upload a photo of any character or choose from 微鲤AI's diverse library to generate stunning interactive videos. Simply describe the interaction you want in your prompt, and watch as you and the character come together in a cinematic AI video.`,
                consistency: 'Experience industry-leading character consistency. Our advanced AI ensures that characters maintain their unique features and appearance throughout the entire video sequence.',
                interactive: 'Create meaningful interactions. From walking together in a park to sharing a conversation, the possibilities for character-driven storytelling are endless.',
                faq: [
                    {
                        question: 'How do I create a video with a specific character?',
                        answer: 'Upload a photo of the character or select one from the 微鲤AI platform. Then, enter a prompt describing the interaction or scene you want to generate.',
                    },
                    {
                        question: 'Can I use any character photo?',
                        answer: 'Yes, you can upload photos of any character you have the rights to use, and our AI will animate them based on your instructions.',
                    },
                    {
                        question: 'Is there a limit to the video duration?',
                        answer: 'Character videos currently support durations from 5 to 10 seconds, depending on the AI model and your subscription plan.',
                    },
                    {
                        question: 'How do I ensure the character looks consistent?',
                        answer: '微鲤AI uses specialized character-consistency algorithms that analyze the reference image to maintain stable visual features across all video frames.',
                    },
                    {
                        question: 'Is it free to try?',
                        answer: 'Yes, you can generate character videos using your daily free credits on 微鲤AI.',
                    },
                ],
            },
            faq: [
                {
                    question: 'What is 微鲤AI Character to Video?',
                    answer: 'It is an advanced tool that generates videos featuring specific characters. You can upload a photo of a character or pick one from our library to create dynamic, interactive video content.',
                },
                {
                    question: 'How does character consistency work in video?',
                    answer: `Our AI utilizes character-specific training to ensure the character's appearance remains stable and recognizable throughout the entire video clip.`,
                },
                {
                    question: 'Can I make a video of me and a character together?',
                    answer: 'Yes, you can describe interactions between yourself and the character in the prompt, and the AI will generate a video showing those interactions.',
                },
                {
                    question: 'What AI models are used for character videos?',
                    answer: 'We use the latest high-performance video models like Kling and Google Veo, optimized for character consistency and realistic movement.',
                },
                {
                    question: 'What is the maximum duration of character videos?',
                    answer: 'Depending on your plan, you can generate character videos ranging from 5 seconds to 10 seconds, with high-definition quality.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Share with friends | 微鲤AI',
            description: 'Share with friends, invite friends to register 微鲤AI, you and your friends will get rewards.',
            keywords: 'social back, share with friends, invite friends to register 微鲤AI, you and your friends will get rewards, 微鲤AI',
        },
    },
    zh: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '使用微鲤AI，一站式 AI 视频和图像创作平台。通过文本提示、图像或视频，快速生成高分辨率的 AI 视频与图像内容。',
        home: {
            h1: '免费 AI 视频与图像生成器，文生视频、图生视频、特效模板、超分修复与一站式创作平台',
            product_desc: '一站式 AI 驱动的创意平台，支持通过文本、照片或片段生成和编辑视频与图像，快速生成高分辨率的 AI 创作内容。',
            title: '一站式 AI 创作平台-免费 AI 视频与图像生成器，AI 特效模板、AI 工具 | 微鲤AI',
            description: '在一个免费面板完成文生视频、图生视频、视频特效、超分修复与画质提升，支持多种风格与分辨率导出。无需复杂流程，几步生成高质量视频与图像，用于营销、社媒与创作。立即免费试用，畅享便捷 AI 创作体验，一键开启。',
            ogDescription: '在一个免费面板完成文生视频、图生视频、视频特效、超分修复与画质提升，支持多种风格与分辨率导出。无需复杂流程，几步生成高质量视频与图像，用于营销、社媒与创作。',
            keywords: 'AI视频生成器, AI图像生成器, 文本转视频, 图像转视频, AI视频特效, 视频超分, 画质提升, AI内容创作, 微鲤AI',
            software_desc: '一站式 AI 创意平台，提供文生视频、图生视频、视频特效与画质提升等功能。',
            software_feature: '文本转视频, 图像转视频, AI 视频特效, 4K 视频超分, 口型同步, 背景移除',
            og_title: '微鲤AI - 一站式 AI 创意平台',
            og_description: '一站式 AI 视频与图像创作平台，支持文生视频、图生视频、视频特效与超分增强。立即免费试用。',
            twitter_title: '微鲤AI - 免费 AI 视频生成器',
            twitter_description: '在一个平台完成 AI 视频与图像创作，快速生成高质量作品。',
            faq: [
                {
                    question: '为什么 微鲤AI 比分别使用各个模型更好？',
                    answer: '微鲤AI 是一个聚合平台。你不需要分别订阅 Kling、Midjourney 或 Runway 等服务，而是在一个面板中就能使用顶尖模型（如 Kling 2.5、Flux Pro、Google Veo）。这能节省成本并让工作流更顺畅。',
                },
                {
                    question: '微鲤AI 真的是免费的吗？',
                    answer: '是的。我们提供每日免费积分，让你可以体验文生视频、换脸、图像生成等工具。开始使用无需信用卡。对于高频使用与去水印下载，我们也提供灵活的付费计划。',
                },
                {
                    question: '我可以在这个平台上使用 Kling AI 和 Flux 吗？',
                    answer: '当然可以。WeryAI 集成了最新版本的 Kling（更真实的视频）、Flux（高保真图像）以及 Google Veo。我们会持续更新模型库，让你随时用到最新能力。',
                },
                {
                    question: '如何提升低画质视频？',
                    answer: '使用我们的 AI 视频超分工具。它会自动去噪、减轻模糊并将视频提升到最高 4K 分辨率，非常适合修复老旧家庭录像或提升社媒视频质量。',
                },
                {
                    question: '我拥有作品的商用权吗？',
                    answer: '如果你使用付费计划，是的。你对在微鲤AI生成的内容拥有完整商用权，可用于 YouTube 变现、客户项目与营销投放。',
                },
            ],
        },
        homePage: {
            title: '首页 - 一站式 AI 视频和图像创作平台 | 微鲤AI',
            description: '使用 WeryAI，免费、一站式、一体化的 AI 图像和视频生成器，通过文本提示、图像或视频创建图像/视频。将您的想法转化为高分辨率和高质量的图像和视频。',
            keywords: 'AI视频生成器, AI图像生成器, 文本转视频, 图像转视频, AI视频创作, AI图像创作, 视频生成, 图像生成, AI内容创作, 微鲤AI',
        },
        aiTools: {
            title: 'AI 编辑工具 - 所有顶尖的AI工具集合 | 微鲤AI',
            description: '汇集常用 AI 工具与创作能力：文生视频、图生视频、文生图、图生图、视频特效、换脸、去水印、字幕处理与画质提升等一站式入口。支持快速试用与高质量导出，适用于电商、营销、社媒与内容创作；无需来回切换多个网站，打开一个面板即可完成创作流程。',
            keywords: 'AI工具, AI工具箱, 视频生成工具, 图像生成工具, 视频特效, 换脸, 去水印, 字幕翻译, 字幕擦除, 画质提升, 微鲤AI',
        },
        myCreations: {
            title: '我的创作 | 微鲤AI',
            description: '查看您的所有创作，包括视频和图像。管理您的创作使用微鲤AI 创建高质量的视觉内容。',
            keywords: '我的创作, 视频创作, 图像创作, 创作管理, 微鲤AI',
        },
        aiImage: {
            title: 'AI 图像生成器 - 用 AI 创建精美图像 | 微鲤AI',
            description: '使用微鲤AI一键生成高质量 AI 图像：支持文生图、图生图与局部重绘，提供扩图、去背景、修复增强与高清放大等工具，支持多风格与高分辨率导出。适用于电商主图、海报设计、社媒配图与创意素材制作，立即免费试用。',
            keywords: 'AI图像生成器, 文生图, 图生图, 局部重绘, 扩图, 去背景, 图像修复, 高清放大, AI绘画, AI照片, 设计素材, 微鲤AI',
        },
        aiVideo: {
            title: 'AI 视频生成器 - 用 AI 创建精彩视频 | 微鲤AI',
            description: '使用微鲤AI生成高质量 AI 视频：支持文生视频、图生视频与视频转视频，一键上手；提供视频特效、口型同步、背景移除、超分修复与画质提升，支持多风格、多分辨率导出，适用于营销投放、社媒内容与创意制作。立即免费试用。',
            keywords: 'AI视频生成器, 文生视频, 图生视频, 视频转视频, 文本转视频, 视频特效, 口型同步, 背景移除, 视频超分, 画质提升, 微鲤AI',
        },
        aiMusic: {
            title: 'AI 音乐生成 - 人声/纯音乐一键创作 | 微鲤AI',
            description: '在微鲤AI快速生成 AI 音乐：支持人声歌曲与纯音乐，可按风格、氛围与时长创作，并支持参考音频与歌词模式。轻松制作适用于短视频、直播、游戏与广告的配乐；社区作品一键做同款，支持下载与分享，高效产出可用音乐素材，立即免费试用。',
            keywords: 'AI音乐生成器, 文生音乐, 人声歌曲生成, 纯音乐生成, 参考音频, 歌词生成音乐, 配乐制作, 做同款音乐, 免版税音乐, 微鲤AI',
        },
        pricing: {
            title: '定价方案 - 实惠的 AI 视频和图像创作 | 微鲤AI',
            description: '选择最适合您需求的方案。WeryAI 提供灵活的 AI 视频和图像生成定价。提供免费试用。',
            keywords: 'AI定价, 视频生成定价, 图像生成定价, 订阅方案',
        },
        faq: {
            title: '常见问题 - 微鲤AI 帮助中心',
            description: '查找关于微鲤AI AI 视频和图像生成平台的常见问题答案。获取功能、定价等方面的帮助。',
            keywords: 'AI常见问题, WeryAI帮助, 视频生成帮助, 图像生成指南',
        },
        aboutUs: {
            title: '关于我们 - 微鲤AI AI 创作平台',
            description: '了解 WeryAI，领先的 AI 视频和图像创作平台。探索我们让 AI 内容创作民主化的使命。',
            keywords: '关于WeryAI, AI平台, 公司信息, AI技术',
        },
        refund: {
            title: '退款政策 | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: '隐私政策 | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: '服务条款 | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'AI 视频模型 - Veo、Sora、Kling AI 等 | 微鲤AI',
            description: '探索我们的高级 AI 视频生成模型集合，包括 Veo 3.1、Sora 2、Kling AI、Runway 等。使用尖端 AI 技术创建精彩视频。',
            keywords: 'AI视频模型, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, 视频生成模型, AI视频技术',
        },
        imageModels: {
            title: 'AI 图像模型 - FLUX、Nano Banana、Imagen 等 | 微鲤AI',
            description: '探索我们的高级 AI 图像生成模型集合，包括 FLUX、Nano Banana、Imagen、GPT-4o 等。使用最先进的 AI 模型创建专业图像。',
            keywords: 'AI图像模型, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, 图像生成模型, AI图像技术',
        },
        ugcDetailImage: {
            title: '免费 AI 图像生成器 | 创建你的专属作品 | 微鲤AI',
            description: '看看这张令人惊艳的 AI 生成图像，免费创建你自己的作品！WeryAI 强大的 AI 生成器能在几秒钟内将你的想法变成精美图像。立即体验！',
            keywords: 'AI图像生成器, 免费AI绘画, AI生成图像, 文字转图像, 创建AI图像, 微鲤AI',
        },
        ugcDetailVideo: {
            title: '免费 AI 视频生成器 | 创建你的专属作品 | 微鲤AI',
            description: '看看这个令人惊艳的 AI 生成视频，免费创建你自己的作品！WeryAI 强大的 AI 生成器能在几秒钟内将你的想法变成精彩视频。立即体验！',
            keywords: 'AI视频生成器, 免费AI视频, AI生成视频, 文字转视频, 创建AI视频, 微鲤AI',
        },
        ugcDetailMusic: {
            title: '免费 AI 音乐生成器 | 创建你的专属音乐 | 微鲤AI',
            description: '聆听这首令人惊艳的 AI 生成音乐，免费创建你自己的作品！WeryAI 强大的 AI 音乐生成器能在几秒钟内将你的想法变成独特歌曲。立即体验！',
            keywords: 'AI音乐生成器, 免费AI音乐, AI生成音乐, 文字转音乐, 创建AI歌曲, 免版税音乐, 微鲤AI',
            og_title: '免费 AI 音乐生成器 | 创建你的专属音乐 | 微鲤AI',
            og_description: '聆听这首令人惊艳的 AI 生成音乐，免费创建你自己的作品！WeryAI 强大的 AI 音乐生成器能在几秒钟内将你的想法变成独特歌曲。',
            twitter_title: '免费 AI 音乐生成器 | 微鲤AI',
            twitter_description: '免费创建 AI 生成音乐！WeryAI 强大的 AI 音乐生成器能在几秒钟内将你的想法变成独特歌曲。',
        },
        characters: {
            title: 'AI 角色 - 与 AI 角色和虚拟伴侣聊天 | 微鲤AI',
            description: '在微鲤AI上与数千个 AI 角色聊天，体验沉浸式互动。探索丰富的动漫角色、贴心的虚拟伴侣和独特的 AI 人格，随时随地开启对话。无论你是寻找情感陪伴、角色扮演还是创意灵感，微鲤AI都能满足你的需求，立即免费开始你的 AI 社交之旅。',
            keywords: 'AI角色, AI聊天, 虚拟伴侣, 动漫角色, AI人格, 角色聊天, AI对话, 虚拟朋友, 微鲤AI',
            og_title: 'AI 角色 - 与 AI 角色和虚拟伴侣聊天 | 微鲤AI',
            og_description: '探索数千个 AI 角色并开始有意义的对话。免费与动漫角色、虚拟伴侣和互动 AI 人格聊天。',
            twitter_title: 'AI 角色 - 与 AI 角色和虚拟伴侣聊天 | 微鲤AI',
            twitter_description: '发现并与数千个 AI 角色聊天。动漫角色、虚拟伴侣和互动人格——在微鲤AI上全部免费。',
        },
        characterToImage: {
            title: 'AI 角色生图 - 生成你与角色的合影图片 | 微鲤AI',
            description: '上传角色照片或从微鲤AI角色库选择人物，输入互动场景提示词即可生成合影与角色互动图片。支持角色一致性、多风格与高清导出，覆盖写实、插画与二次元等风格，适用于头像、同人创作、社媒配图与故事分镜，立即免费试用。',
            keywords: 'AI角色生图, 角色一致性, 角色互动合影, 合影生成, 同人创作, 社媒配图, 高清导出, 微鲤AI',
            og_title: 'AI 角色生图 - 生成你与角色的合影图片 | 微鲤AI',
            og_description: '上传角色照片或从微鲤AI角色库选择人物，输入互动场景提示词即可生成合影与角色互动图片。支持角色一致性、多风格与高清导出，覆盖写实、插画与二次元等风格，适用于头像、同人创作、社媒配图与故事分镜，立即免费试用。',
            twitter_title: 'AI 角色生图 - 生成你与角色的合影图片 | 微鲤AI',
            twitter_description: '上传角色照片或从微鲤AI角色库选择人物，输入互动场景提示词即可生成合影与角色互动图片。支持角色一致性、多风格与高清导出，覆盖写实、插画与二次元等风格，适用于头像、同人创作、社媒配图与故事分镜，立即免费试用。',
            faq: [
                {
                    question: '什么是微鲤AI角色生图？',
                    answer: '微鲤AI角色生图是一款 AI 驱动的工具，允许你在保持角色视觉特征一致的前提下，生成包含特定角色的图像。你可以上传自己的角色照片，也可以从我们的预设角色库中选择。',
                },
                {
                    question: '我可以生成我与角色的合影吗？',
                    answer: '当然可以！通过提供关于你和角色的互动描述（提示词），AI 可以生成你与所选角色互动的写实或艺术风格合影。',
                },
                {
                    question: '我可以选择多少种角色？',
                    answer: '微鲤AI拥有海量的角色库，涵盖动漫、游戏及原创设计。你还可以上传任意角色的照片，开启独一无二的创意互动。',
                },
                {
                    question: '它支持高分辨率吗？',
                    answer: '是的。我们支持高达 4K 的高分辨率图像生成，确保你的角色合影细节丰富、画质清晰。',
                },
                {
                    question: '如何保持角色的视觉一致性？',
                    answer: '我们先进的 AI 模型经过专门训练，能够识别并保留角色的核心特征，确保生成的图像与你提供或选择的参考角色完全一致。',
                },
            ],
        },
        characterToVideo: {
            title: 'AI 角色生视频 - 创作你与角色的互动视频 | 微鲤AI',
            description: '上传角色照片或从微鲤AI角色库选择人物，输入互动提示词即可生成角色互动短视频。支持角色一致性、镜头运动、分辨率与时长选择，并可续写延长，适用于社媒短片、剧情片段与创意剪辑；支持一键导出与分享，快速产出可发布内容，立即免费试用。',
            keywords: 'AI角色生视频, 角色互动视频, 角色一致性视频, 镜头运动, 视频延长, 社媒短片, 创意剪辑, 微鲤AI',
            og_title: 'AI 角色生视频 - 创作你与角色的互动视频 | 微鲤AI',
            og_description: '上传角色照片或从微鲤AI角色库选择人物，输入互动提示词即可生成角色互动短视频。支持角色一致性、镜头运动、分辨率与时长选择，并可续写延长，适用于社媒短片、剧情片段与创意剪辑；支持一键导出与分享，快速产出可发布内容，立即免费试用。',
            twitter_title: 'AI 角色生视频 - 创作你与角色的互动视频 | 微鲤AI',
            twitter_description: '上传角色照片或从微鲤AI角色库选择人物，输入互动提示词即可生成角色互动短视频。支持角色一致性、镜头运动、分辨率与时长选择，并可续写延长，适用于社媒短片、剧情片段与创意剪辑；支持一键导出与分享，快速产出可发布内容，立即免费试用。',
            page: {
                title1: '免费 AI 角色生视频生成器',
                title2: '让你喜爱的角色动起来！上传任意角色的照片或从微鲤AI丰富的角色库中选择，生成惊艳的互动视频。只需在提示词中描述你想要的互动场景，就能看到你与角色在电影级 AI 视频中共同演绎。',
                consistency: '体验行业领先的角色一致性。我们先进的 AI 确保角色在整个视频序列中保持其独特的特征和外观。',
                interactive: '创造有意义的互动。从在公园一起散步到分享对话，角色驱动的故事创作可能性无穷无尽。',
                faq: [
                    {
                        question: '如何创建包含特定角色的视频？',
                        answer: '上传角色照片或从微鲤AI平台选择一个角色。然后，输入描述你想要生成的互动或场景的提示词。',
                    },
                    {
                        question: '我可以使用任何角色照片吗？',
                        answer: '可以，你可以上传任何你有权使用的角色照片，我们的 AI 会根据你的指令为其制作动画。',
                    },
                    {
                        question: '视频时长有限制吗？',
                        answer: '角色视频目前支持 5 到 10 秒的时长，具体取决于 AI 模型和你的订阅计划。',
                    },
                    {
                        question: '如何确保角色看起来一致？',
                        answer: '微鲤AI使用专门的角色一致性算法，分析参考图像以在所有视频帧中保持稳定的视觉特征。',
                    },
                    {
                        question: '可以免费试用吗？',
                        answer: '可以，你可以使用微鲤AI的每日免费积分生成角色视频。',
                    },
                ],
            },
            faq: [
                {
                    question: '什么是微鲤AI角色生视频？',
                    answer: '这是一款先进的 AI 工具，可以生成包含特定角色的动态视频。你可以上传角色照片或从库中选择，创建你与角色共同互动的精彩视频内容。',
                },
                {
                    question: '视频中的角色一致性是如何实现的？',
                    answer: '我们的 AI 使用了针对角色特征优化的训练技术，确保角色的外貌在整个视频片段中保持稳定、可辨识。',
                },
                {
                    question: '我可以制作我与角色在一起的视频吗？',
                    answer: '可以。你只需在提示词中描述你与角色的互动场景，AI 就会生成展现这些互动过程的连贯视频。',
                },
                {
                    question: '角色生视频使用了哪些 AI 模型？',
                    answer: '我们使用了目前最先进的高性能视频模型（如 Kling、Google Veo），并针对角色一致性和真实动作进行了深度优化。',
                },
                {
                    question: '生成的角色视频最长是多少秒？',
                    answer: '根据你的计划，你可以生成时长在 5 到 10 秒之间的高清角色视频。',
                },
            ],
        },
        social_back: {
            title: '福利中心 - 与好友分享 | 微鲤AI',
            description: '与好友分享，邀请好友注册 WeryAI，你和你的好友都将获得奖励。',
            keywords: '福利中心, 与好友分享, 邀请好友注册 微鲤AI, 获得奖励, 微鲤AI',
        },
    },
    ja: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: 'WeryAIは、テキスト、画像、動画から高品質なAIビジュアルコンテンツを生成できるオールインワンAI動画・画像作成プラットフォームです。',
        home: {
            title: '微鲤AI - 無料AI動画ジェネレーター＆画像ツール（Kling、Flux、Veo）',
            description: '複数のサブスクを行き来する必要はありません。Kling AI、Google Veo、Sora、Fluxなど世界最高クラスのAIモデルを、無料のダッシュボード一つで利用。プロ品質の動画生成、フェイススワップ、アップスケールをすぐに。',
            ogDescription: 'Kling & Fluxで美しい動画と画像を生成。テキスト→動画、フェイススワップ、アップスケールに対応。今すぐ無料で試す。',
            keywords: 'AI動画ジェネレーター, AI画像ジェネレーター, テキストから動画, 画像から動画, AI動画作成, AI画像作成, 動画生成, 画像生成, AIコンテンツ作成, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'Kling AI、Google Veo、Sora、Flux などのトップモデルを統合するAIクリエイティブプラットフォーム。Text-to-Video、フェイススワップ、アップスケールなどに対応。',
            software_feature: 'Kling AI 連携, テキスト→動画, AIフェイススワップ, 4K動画アップスケーラー, 画像→動画, リップシンク, 背景除去',
            og_title: '微鲤AI - オールインワンAIクリエイティブプラットフォーム',
            og_description: 'Kling & Fluxで驚くほど美しい動画を生成。テキスト→動画、フェイススワップ、アップスケール対応。無料で試す。',
            twitter_title: '微鲤AI - 無料AI動画ジェネレーター',
            twitter_description: 'Kling、Veo、Fluxを一か所で。AI動画＆AIアートをすぐ生成。',
            faq: [
                {
                    question: 'なぜ 微鲤AI はモデルを個別に使うより優れているのですか？',
                    answer: '微鲤AI はアグリゲーター（統合プラットフォーム）です。Kling、Midjourney、Runway などを別々に契約する代わりに、Kling 2.5、Flux Pro、Google Veo などのトップモデルを一つのダッシュボードで利用できます。コストを抑え、制作フローも効率化できます。',
                },
                {
                    question: '微鲤AI は本当に無料ですか？',
                    answer: 'はい。毎日付与される無料クレジットで、テキスト→動画、フェイススワップ、画像生成などを試せます。開始にクレジットカードは不要です。大量利用や透かしなしダウンロードには、柔軟な有料プランも用意しています。',
                },
                {
                    question: 'このプラットフォームで Kling AI と Flux を使えますか？',
                    answer: 'もちろんです。WeryAI は最新の Kling（リアルな動画）、Flux（高精細な画像）、Google Veo を統合しています。モデルライブラリは継続的に更新し、常に最先端を提供します。',
                },
                {
                    question: '低品質な動画を改善するにはどうすればいいですか？',
                    answer: 'AI Video Upscaler（動画アップスケーラー）をご利用ください。ノイズやぼけを自動で軽減し、最大 4K 解像度まで高画質化します。古い家庭用動画の復元や、SNS動画の品質向上に最適です。',
                },
                {
                    question: '生成物の商用権は自分にありますか？',
                    answer: '有料プランをご利用の場合は、はい。WeryAI で生成したすべての素材に対して商用利用権を持てるため、YouTube 収益化、クライアント案件、マーケティング用途にも安心して使えます。',
                },
            ],
        },
        homePage: {
            title: 'ホーム | 微鲤AI',
            description: 'WeryAIを使用して、無料で究極のオールインワンAI画像・動画ジェネレーターで、テキストプロンプト、画像、または動画から画像・動画を作成します。高解像度・高品質の画像と動画にアイデアを変換します。',
            keywords: 'AI動画ジェネレーター, AI画像ジェネレーター, テキストから動画, 画像から動画, AI動画作成, AI画像作成, 動画生成, 画像生成, AIコンテンツ作成, 微鲤AI',
        },
        aiTools: {
            title: '編集ツールキット - トップAIツール総合集 | 微鲤AI',
            description: '最高の AI ツールコレクションを探索し、ビデオと画像生成に使用します。最先端の AI 技術で驚くべきビデオと画像を作成します。',
            keywords: 'AIツール, ビデオ生成ツール, 画像生成ツール, AIビデオツール, AI画像ツール, 微鲤AI',
        },
        myCreations: {
            title: '私の作品 | 微鲤AI',
            description: 'すべての作品を表示し、ビデオと画像を管理します。WeryAIを使用して、高品質なビジュアルコンテンツを作成します。',
            keywords: '私の作品, ビデオ作品, 画像作品, 作品管理, 微鲤AI',
        },
        aiImage: {
            title: 'AI画像ジェネレーター - AIで素晴らしい画像を作成 | 微鲤AI',
            description: 'WeryAIでプロフェッショナルなAI生成画像を作成。テキストを画像に変換し、クリエイティブなビジュアルを生成し、高度なAI技術で想像を実現します。',
            keywords: 'AI画像ジェネレーター, テキストから画像, AIアート, 画像作成, AI写真, デジタルアートジェネレーター',
        },
        aiVideo: {
            title: 'AI動画ジェネレーター - AIで素晴らしい動画を作成 | 微鲤AI',
            description: 'WeryAIで驚くべきAI動画を生成。テキスト、画像、または動画から、Sora、Veoなどの最先端AIモデルで動画を作成します。',
            keywords: 'AI動画ジェネレーター, テキストから動画, 動画作成, AI動画, 動画生成, Sora, Veo',
        },
        aiMusic: {
            title: 'AI音楽生成 - ボーカル/インストを簡単作成 | 微鲤AI',
            description: 'WeryAIでAI音楽を数秒で生成。ボーカル曲とインストに対応し、ポップ、ロック、エレクトロニック、ジャズなどのスタイルを探索し、コミュニティ作品をワンクリックでリミックス。',
            keywords: 'AI音楽ジェネレーター, AI音楽ジェネレーター無料, AI音楽ジェネレーターボーカル, ボーカル曲生成, インストゥルメンタル生成, テキストから音楽, 類似音楽作成, AI音楽リミックス, 音楽スタイル, 著作権フリー音楽, 微鲤AI',
        },
        pricing: {
            title: '料金プラン - 手頃なAI動画・画像作成 | 微鲤AI',
            description: 'ニーズに最適なプランを選択。WeryAIの柔軟なAI動画・画像生成料金。無料トライアルあり。',
            keywords: 'AI料金, 動画生成料金, 画像生成料金, サブスクリプションプラン',
        },
        faq: {
            title: 'よくある質問 - WeryAIヘルプセンター',
            description: '微鲤AI AI動画・画像生成プラットフォームに関するよくある質問の答えを見つけます。機能、料金などのヘルプを入手します。',
            keywords: 'AIよくある質問, WeryAIヘルプ, 動画生成ヘルプ, 画像生成ガイド',
        },
        aboutUs: {
            title: '会社概要 - 微鲤AI AI作成プラットフォーム',
            description: '主要なAI動画・画像作成プラットフォームWeryAIについて学びます。AIコンテンツ作成の民主化という私たちの使命を発見します。',
            keywords: 'WeryAIについて, AIプラットフォーム, 会社情報, AI技術',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'AI動画モデル - Veo、Sora、Kling AI など | 微鲤AI',
            description: 'Veo 3.1、Sora 2、Kling AI、Runwayなどの高度なAI動画生成モデルのコレクションを探索。最先端のAI技術で素晴らしい動画を作成。',
            keywords: 'AI動画モデル, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, 動画生成モデル, AI動画技術',
        },
        imageModels: {
            title: 'AI画像モデル - FLUX、Nano Banana、Imagen など | 微鲤AI',
            description: 'FLUX、Nano Banana、Imagen、GPT-4oなどの高度なAI画像生成モデルのコレクションを探索。最先端のAIモデルでプロフェッショナルな画像を作成。',
            keywords: 'AI画像モデル, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, 画像生成モデル, AI画像技術',
        },
        ugcDetailImage: {
            title: '無料AIイメージジェネレーター | あなただけの作品を作成 | 微鲤AI',
            description: 'この素晴らしいAI生成画像をチェックして、無料であなた自身の作品を作成しましょう！WeryAIの強力なAIジェネレーターが、あなたのアイデアを数秒で素晴らしいビジュアルに変換します。今すぐお試しください！',
            keywords: 'AI画像生成, 無料AIアート, AI生成画像, テキストから画像, AI画像作成, 微鲤AI',
        },
        ugcDetailVideo: {
            title: '無料AI動画ジェネレーター | あなただけの作品を作成 | 微鲤AI',
            description: 'この素晴らしいAI生成動画をチェックして、無料であなた自身の作品を作成しましょう！WeryAIの強力なAIジェネレーターが、あなたのアイデアを数秒で素晴らしい動画に変換します。今すぐお試しください！',
            keywords: 'AI動画生成, 無料AI動画, AI生成動画, テキストから動画, AI動画作成, 微鲤AI',
        },
        ugcDetailMusic: {
            title: '無料AI音楽ジェネレーター | あなただけの音楽を作成 | 微鲤AI',
            description: 'この素晴らしいAI生成音楽を聴いて、無料であなた自身の作品を作成しましょう！WeryAIの強力なAI音楽ジェネレーターが、あなたのアイデアを数秒でユニークな楽曲に変換します。今すぐお試しください！',
            keywords: 'AI音楽生成, 無料AI音楽, AI生成音楽, テキストから音楽, AI楽曲作成, ロイヤリティフリー音楽, 微鲤AI',
            og_title: '無料AI音楽ジェネレーター | あなただけの音楽を作成 | 微鲤AI',
            og_description: 'この素晴らしいAI生成音楽を聴いて、無料であなた自身の作品を作成しましょう！WeryAIの強力なAI音楽ジェネレーターが、あなたのアイデアを数秒でユニークな楽曲に変換します。',
            twitter_title: '無料AI音楽ジェネレーター | 微鲤AI',
            twitter_description: 'AI生成音楽を聴いて、無料であなた自身の作品を作成しましょう！',
        },
        characters: {
            title: 'AIキャラクター - AIキャラクターとチャット & バーチャルコンパニオン | 微鲤AI',
            description: 'WeryAIで数千のAIキャラクターとチャット。アニメキャラクター、バーチャルコンパニオン、インタラクティブなAI人格を発見。無料でAIキャラクターとの会話を始めましょう。',
            keywords: 'AIキャラクター, AIチャット, バーチャルコンパニオン, アニメキャラクター, AI人格, キャラクターチャット, AI会話, バーチャルフレンド, 微鲤AI',
            og_title: 'AIキャラクター - AIキャラクターとチャット & バーチャルコンパニオン | 微鲤AI',
            og_description: '数千のAIキャラクターを探索し、意味のある会話を始めましょう。アニメキャラクター、バーチャルコンパニオン、インタラクティブなAI人格と無料でチャット。',
            twitter_title: 'AIキャラクター - AIキャラクターとチャット | 微鲤AI',
            twitter_description: '数千のAIキャラクターを発見してチャット。アニメキャラクター、バーチャルコンパニオン、インタラクティブな人格—すべてWeryAIで無料。',
        },
        characterToImage: {
            title: 'AIキャラクター画像生成 - あなただけのキャラクター画像を作成 | 微鲤AI',
            description: 'WeryAIでキャラクターを選び、プロンプトを入力して生成をクリックするだけで、あなただけのキャラクター画像を作成できます。',
            keywords: 'AIキャラクター画像生成, AIキャラクター, キャラクター画像生成, キャラクター画像, 微鲤AI',
            og_title: 'AIキャラクター画像生成 - あなただけのキャラクター画像を作成 | 微鲤AI',
            og_description: 'WeryAIでキャラクターを選び、プロンプトを入力して生成をクリックするだけで、あなただけのキャラクター画像を作成できます。',
            twitter_title: 'AIキャラクター画像生成 - あなただけのキャラクター画像を作成 | 微鲤AI',
            twitter_description: 'WeryAIでキャラクターを選び、プロンプトを入力して生成をクリックするだけで、あなただけのキャラクター画像を作成できます。',
        },
        characterToVideo: {
            title: 'AIキャラクター→動画 - インタラクティブなキャラクター動画生成 | 微鲤AI',
            description: '好きなAIキャラクターで驚きの動画を作成。キャラクター写真をアップロード、またはWeryAIから選択して、あなたとキャラクターのインタラクティブ動画を生成できます。',
            keywords: 'AIキャラクター動画, キャラクター動画生成, インタラクティブAI動画, キャラクター一貫性, 微鲤AI',
            og_title: 'AIキャラクター→動画 - インタラクティブなキャラクター動画生成 | 微鲤AI',
            og_description: 'アイデアをインタラクティブなAIキャラクター動画に。キャラクターをアップロード/選択して、リアルな動きの動画を生成。',
            twitter_title: 'AIキャラクター→動画 - インタラクティブなキャラクター動画生成 | 微鲤AI',
            twitter_description: 'アイデアをインタラクティブなAIキャラクター動画に。キャラクターをアップロード/選択して、リアルな動きの動画を生成。',
            page: {
                title1: '無料AIキャラクター→動画ジェネレーター',
                title2: 'お気に入りのキャラクターを動かそう！キャラクター写真をアップロードするか、WeryAIのライブラリから選び、驚くほど自然なインタラクティブ動画を生成できます。プロンプトでシーンややり取りを説明するだけ。',
                consistency: '業界トップクラスのキャラクター一貫性。先進AIが、動画全体を通して特徴と見た目を安定して保ちます。',
                interactive: '意味のあるインタラクションを作成。公園で一緒に歩く、会話するなど、物語表現の可能性は無限です。',
                faq: [
                    {
                        question: '特定のキャラクターで動画を作るには？',
                        answer: 'キャラクター写真をアップロードするか、WeryAIから選択します。その後、生成したいシーンややり取りをプロンプトに入力して生成してください。',
                    },
                    {
                        question: 'どんなキャラクター写真でも使えますか？',
                        answer: 'はい。使用権限のあるキャラクター写真であればアップロードできます。AIが指示に沿ってアニメーション化します。',
                    },
                    {
                        question: '動画の長さに制限はありますか？',
                        answer: 'モデルとプランにより異なりますが、通常は5〜10秒の範囲に対応しています。',
                    },
                    {
                        question: 'キャラクターを一貫して見せるには？',
                        answer: '参照画像を解析し、全フレームで特徴を保つキャラクター一貫性アルゴリズムを使用しています。',
                    },
                    {
                        question: '無料で試せますか？',
                        answer: 'はい。毎日の無料クレジットでAIキャラクター動画を試せます。',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI キャラクター→動画とは？',
                    answer: '特定キャラクターを含む動画を生成できる高度なAIツールです。写真をアップロードまたは選択して、ダイナミックなインタラクティブ動画を作成できます。',
                },
                {
                    question: '動画でのキャラクター一貫性はどう実現しますか？',
                    answer: 'キャラクター特化の最適化により、外見を安定して認識可能な状態で保つように設計されています。',
                },
                {
                    question: '自分とキャラクターが一緒にいる動画も作れますか？',
                    answer: 'はい。プロンプトであなたとキャラクターのやり取りを説明すると、その内容に沿った動画を生成します。',
                },
                {
                    question: 'どのAIモデルを使っていますか？',
                    answer: 'KlingやGoogle Veoなどの高性能動画モデルを使用し、キャラクター一貫性と自然な動きに最適化しています。',
                },
                {
                    question: '最大で何秒まで生成できますか？',
                    answer: 'プランにより異なりますが、一般的に5〜10秒の高画質動画を生成できます。',
                },
            ],
        },
        social_back: {
            title: 'ソーシャルバック - 友達と共有 | 微鲤AI',
            description: '友達と共有し、友達をWeryAIに招待すると、あなたと友達の両方が報酬を受け取れます。',
            keywords: 'ソーシャルバック, 友達と共有, WeryAIに招待, 報酬獲得, 微鲤AI',
        },
    },
    ko: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: 'WeryAI는 텍스트, 이미지 또는 비디오를 기반으로 고품질의 AI 비디오 및 이미지를 생성할 수 있는 올인원 AI 콘텐츠 제작 플랫폼입니다.',
        home: {
            title: '微鲤AI - 무료 AI 비디오 생성기 & 이미지 도구(Kling, Flux, Veo)',
            description: '여러 구독을 오가며 쓰지 마세요. Kling AI, Google Veo, Sora, Flux 등 세계 최고 수준의 AI 모델을 하나의 무료 대시보드에서 이용할 수 있습니다. 전문가급 영상 생성, 얼굴 스왑, 업스케일을 즉시 해보세요.',
            ogDescription: 'Kling & Flux로 멋진 영상과 이미지를 생성하세요. 텍스트-투-비디오, 얼굴 스왑, 업스케일 지원. 지금 무료로 사용해보세요.',
            keywords: 'AI 비디오 생성기, AI 이미지 생성기, 텍스트에서 비디오로, 이미지에서 비디오로, AI 비디오 제작, AI 이미지 제작, 비디오 생성, 이미지 생성, AI 콘텐츠 제작, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'Kling AI, Google Veo, Sora, Flux 등 최상급 모델을 한곳에 모은 AI 크리에이티브 플랫폼. 텍스트-투-비디오, 얼굴 스왑, 업스케일 기능을 제공합니다.',
            software_feature: 'Kling AI 통합, 텍스트를 비디오로, AI 얼굴 스왑, 4K 비디오 업스케일러, 이미지에서 비디오로, 립싱크, 배경 제거',
            og_title: '微鲤AI - 올인원 AI 크리에이티브 플랫폼',
            og_description: 'Kling & Flux로 멋진 영상과 이미지를 생성하세요. 텍스트-투-비디오, 얼굴 스왑, 업스케일 지원. 지금 무료로 사용해보세요.',
            twitter_title: '微鲤AI - 무료 AI 비디오 생성기',
            twitter_description: 'Kling, Veo, Flux를 한 곳에서. AI 비디오와 AI 아트를 즉시 생성하세요.',
            faq: [
                {
                    question: '왜 WeryAI가 모델을 각각 쓰는 것보다 더 좋나요?',
                    answer: 'WeryAI는 여러 모델을 한 곳에 모은 통합 플랫폼입니다. Kling, Midjourney, Runway 등을 각각 구독하는 대신, Kling 2.5, Flux Pro, Google Veo 같은 최상급 모델을 하나의 대시보드에서 사용할 수 있어 비용을 절감하고 작업 흐름을 단순화합니다.',
                },
                {
                    question: 'WeryAI는 정말 무료인가요?',
                    answer: '네. 매일 제공되는 무료 크레딧으로 텍스트-투-비디오, 얼굴 스왑, 이미지 생성 도구를 테스트할 수 있습니다. 시작할 때 신용카드는 필요 없습니다. 더 많은 사용량과 워터마크 없는 다운로드를 위해 유연한 유료 플랜도 제공됩니다.',
                },
                {
                    question: '이 플랫폼에서 Kling AI와 Flux를 사용할 수 있나요?',
                    answer: '물론입니다. WeryAI는 최신 Kling(리얼한 영상), Flux(고충실도 이미지), Google Veo를 통합합니다. 모델 라이브러리를 지속적으로 업데이트해 항상 최신 기술을 제공합니다.',
                },
                {
                    question: '저화질 영상을 개선하려면 어떻게 하나요?',
                    answer: 'AI Video Upscaler를 사용하세요. 노이즈/블러를 자동으로 줄이고 최대 4K 해상도까지 업스케일합니다. 오래된 가족 영상 복원이나 SNS 영상 품질 개선에 적합합니다.',
                },
                {
                    question: '생성물의 상업적 권리를 제가 가지나요?',
                    answer: '유료 플랜이라면, 네. WeryAI에서 생성한 모든 자산에 대한 상업적 권리를 보유하여 유튜브 수익화, 클라이언트 작업, 마케팅 캠페인에 안전하게 사용할 수 있습니다.',
                },
            ],
        },
        homePage: {
            title: '홈 | 微鲤AI',
            description: 'WeryAI를 사용하면 텍스트, 이미지 또는 비디오 프롬프트를 통해 고해상도 AI 비디오와 이미지를 손쉽게 생성할 수 있습니다. 아이디어를 시각적인 현실로 만들어 보세요.',
            keywords: 'AI 비디오 생성기, AI 이미지 생성기, 텍스트에서 비디오로, 이미지에서 비디오로, AI 비디오 제작, AI 이미지 제작, 비디오 생성, 이미지 생성, AI 콘텐츠 제작, 微鲤AI',
        },
        aiTools: {
            title: '편집 툴킷 - 최고의 AI 도구 모음 | 微鲤AI',
            description: '최고의 AI 도구 컬렉션을 탐색하여 비디오와 이미지 생성에 사용합니다. 최첨단 AI 기술로 놀라운 비디오와 이미지를 만듭니다.',
            keywords: 'AI 도구, 비디오 생성 도구, 이미지 생성 도구, AI 비디오 도구, AI 이미지 도구, 微鲤AI',
        },
        myCreations: {
            title: '내 작품 | 微鲤AI',
            description: '모든 작품을 확인하고 비디오와 이미지를 관리합니다. WeryAI를 사용하여 고품질의 시각적 콘텐츠를 만듭니다.',
            keywords: '내 작품, 비디오 작품, 이미지 작품, 작품 관리, 微鲤AI',
        },
        aiImage: {
            title: 'AI 이미지 생성기 - AI로 멋진 이미지 만들기 | 微鲤AI',
            description: 'WeryAI로 전문 AI 생성 이미지를 만듭니다. 텍스트를 이미지로 변환하고 창의적인 비주얼을 생성하며 첨단 AI 기술로 상상을 실현합니다.',
            keywords: 'AI 이미지 생성기, 텍스트를 이미지로, AI 아트, 이미지 제작, AI 사진, 디지털 아트 생성기',
        },
        aiVideo: {
            title: 'AI 비디오 생성기 - AI로 놀라운 비디오 만들기 | 微鲤AI',
            description: 'WeryAI로 놀라운 AI 비디오를 생성합니다. 텍스트, 이미지 또는 비디오에서 Sora, Veo 등 최첨단 AI 모델로 비디오를 만듭니다.',
            keywords: 'AI 비디오 생성기, 텍스트를 비디오로, 비디오 제작, AI 비디오, 비디오 생성, Sora, Veo',
        },
        aiMusic: {
            title: 'AI 음악 생성 - 보컬/인스트를 손쉽게 | 微鲤AI',
            description: 'WeryAI에서 몇 초 만에 AI 음악을 생성하세요. 보컬 곡과 인스트를 지원하며 팝, 록, 일렉트로닉, 재즈 등 다양한 스타일을 탐색하고 커뮤니티 작품을 원클릭으로 리믹스할 수 있습니다.',
            keywords: 'AI 음악 생성기, AI 음악 생성기 무료, AI 음악 생성기 보컬, 보컬 곡 생성, 인스트루멘탈 생성, 텍스트 음악 생성, 유사 음악 만들기, AI 음악 리믹스, 음악 스타일, 저작권 무료 음악, 微鲤AI',
        },
        pricing: {
            title: '가격 요금제 - 저렴한 AI 비디오 및 이미지 제작 | 微鲤AI',
            description: '필요에 맞는 완벽한 요금제를 선택하세요. WeryAI의 유연한 AI 비디오 및 이미지 생성 가격. 무료 체험 가능.',
            keywords: 'AI 가격, 비디오 생성 가격, 이미지 생성 가격, 구독 요금제',
        },
        faq: {
            title: '자주 묻는 질문 - 微鲤AI 도움말 센터',
            description: '微鲤AI AI 비디오 및 이미지 생성 플랫폼에 대한 일반적인 질문에 대한 답변을 찾으세요. 기능, 가격 등에 대한 도움을 받으세요.',
            keywords: 'AI 자주 묻는 질문, 微鲤AI 도움말, 비디오 생성 도움말, 이미지 생성 가이드',
        },
        aboutUs: {
            title: '회사 소개 - 微鲤AI AI 제작 플랫폼',
            description: '선도적인 AI 비디오 및 이미지 제작 플랫폼 WeryAI에 대해 알아보세요. AI 콘텐츠 제작 민주화라는 우리의 사명을 발견하세요.',
            keywords: '微鲤AI 소개, AI 플랫폼, 회사 정보, AI 기술',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'AI 비디오 모델 - Veo, Sora, Kling AI 등 | 微鲤AI',
            description: 'Veo 3.1, Sora 2, Kling AI, Runway 등을 포함한 고급 AI 비디오 생성 모델 컬렉션을 탐색하세요. 최첨단 AI 기술로 멋진 비디오를 만드세요.',
            keywords: 'AI 비디오 모델, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, 비디오 생성 모델, AI 비디오 기술',
        },
        imageModels: {
            title: 'AI 이미지 모델 - FLUX, Nano Banana, Imagen 등 | 微鲤AI',
            description: 'FLUX, Nano Banana, Imagen, GPT-4o 등을 포함한 고급 AI 이미지 생성 모델 컬렉션을 탐색하세요. 최첨단 AI 모델로 전문 이미지를 만드세요.',
            keywords: 'AI 이미지 모델, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, 이미지 생성 모델, AI 이미지 기술',
        },
        ugcDetailImage: {
            title: '무료 AI 이미지 생성기 | 나만의 작품 만들기 | 微鲤AI',
            description: '이 놀라운 AI 생성 이미지를 확인하고 무료로 나만의 작품을 만들어보세요! WeryAI의 강력한 AI 생성기가 몇 초 만에 당신의 아이디어를 멋진 비주얼로 변환합니다. 지금 바로 체험하세요!',
            keywords: 'AI 이미지 생성기, 무료 AI 아트, AI 생성 이미지, 텍스트를 이미지로, AI 이미지 만들기, 微鲤AI',
        },
        ugcDetailVideo: {
            title: '무료 AI 비디오 생성기 | 나만의 작품 만들기 | 微鲤AI',
            description: '이 놀라운 AI 생성 비디오를 확인하고 무료로 나만의 작품을 만들어보세요! WeryAI의 강력한 AI 생성기가 몇 초 만에 당신의 아이디어를 멋진 비디오로 변환합니다. 지금 바로 체험하세요!',
            keywords: 'AI 비디오 생성기, 무료 AI 비디오, AI 생성 비디오, 텍스트를 비디오로, AI 비디오 만들기, 微鲤AI',
        },
        ugcDetailMusic: {
            title: '무료 AI 음악 생성기 | 나만의 음악 만들기 | 微鲤AI',
            description: '이 놀라운 AI 생성 음악을 들어보고 무료로 나만의 작품을 만들어보세요! WeryAI의 강력한 AI 음악 생성기가 몇 초 만에 당신의 아이디어를 독특한 노래로 변환합니다. 지금 바로 체험하세요!',
            keywords: 'AI 음악 생성기, 무료 AI 음악, AI 생성 음악, 텍스트를 음악으로, AI 노래 만들기, 로열티 프리 음악, 微鲤AI',
            og_title: '무료 AI 음악 생성기 | 나만의 음악 만들기 | 微鲤AI',
            og_description: '이 놀라운 AI 생성 음악을 들어보고 무료로 나만의 작품을 만들어보세요! WeryAI의 강력한 AI 음악 생성기가 몇 초 만에 당신의 아이디어를 독특한 노래로 변환합니다.',
            twitter_title: '무료 AI 음악 생성기 | 微鲤AI',
            twitter_description: 'AI 생성 음악을 들어보고 무료로 나만의 작품을 만들어보세요!',
        },
        characters: {
            title: 'AI 캐릭터 - AI 캐릭터와 채팅 & 가상 동반자 | 微鲤AI',
            description: 'WeryAI에서 수천 개의 AI 캐릭터와 채팅하세요. 애니메이션 캐릭터, 가상 동반자, 인터랙티브 AI 인격을 발견하세요. 무료로 AI 캐릭터와 대화를 시작하세요.',
            keywords: 'AI 캐릭터, AI 채팅, 가상 동반자, 애니메이션 캐릭터, AI 인격, 캐릭터 채팅, AI 대화, 가상 친구, 微鲤AI',
            og_title: 'AI 캐릭터 - AI 캐릭터와 채팅 & 가상 동반자 | 微鲤AI',
            og_description: '수천 개의 AI 캐릭터를 탐색하고 의미 있는 대화를 시작하세요. 애니메이션 캐릭터, 가상 동반자, 인터랙티브 AI 인격과 무료로 채팅하세요.',
            twitter_title: 'AI 캐릭터 - AI 캐릭터와 채팅 | 微鲤AI',
            twitter_description: '수천 개의 AI 캐릭터를 발견하고 채팅하세요. 애니메이션 캐릭터, 가상 동반자, 인터랙티브 인격—모두 WeryAI에서 무료.',
        },
        characterToImage: {
            title: 'AI 캐릭터 이미지 생성 - 나만의 캐릭터 이미지 만들기 | 微鲤AI',
            description: 'WeryAI에서 캐릭터를 선택하고 프롬프트를 입력한 뒤 생성 버튼을 누르면, 나만의 캐릭터 이미지를 만들 수 있습니다.',
            keywords: 'AI 캐릭터 이미지 생성, AI 캐릭터, 캐릭터 이미지 생성, 캐릭터 이미지, 微鲤AI',
            og_title: 'AI 캐릭터 이미지 생성 - 나만의 캐릭터 이미지 만들기 | 微鲤AI',
            og_description: 'WeryAI에서 캐릭터를 선택하고 프롬프트를 입력한 뒤 생성 버튼을 누르면, 나만의 캐릭터 이미지를 만들 수 있습니다.',
            twitter_title: 'AI 캐릭터 이미지 생성 - 나만의 캐릭터 이미지 만들기 | 微鲤AI',
            twitter_description: 'WeryAI에서 캐릭터를 선택하고 프롬프트를 입력한 뒤 생성 버튼을 누르면, 나만의 캐릭터 이미지를 만들 수 있습니다.',
        },
        characterToVideo: {
            title: 'AI 캐릭터→비디오 - 인터랙티브 캐릭터 영상 생성 | 微鲤AI',
            description: '어떤 AI 캐릭터로도 멋진 영상을 만들 수 있습니다. 캐릭터 사진을 업로드하거나 WeryAI에서 선택해, 당신과 캐릭터가 함께하는 인터랙티브 영상을 생성하세요.',
            keywords: 'AI 캐릭터 비디오, 캐릭터 영상 생성기, 인터랙티브 AI 영상, 캐릭터 일관성, 微鲤AI',
            og_title: 'AI 캐릭터→비디오 - 인터랙티브 캐릭터 영상 생성 | 微鲤AI',
            og_description: '아이디어를 인터랙티브 캐릭터 영상으로. 캐릭터를 업로드/선택하고, 자연스러운 움직임의 영상을 생성해 보세요.',
            twitter_title: 'AI 캐릭터→비디오 - 인터랙티브 캐릭터 영상 생성 | 微鲤AI',
            twitter_description: '아이디어를 인터랙티브 캐릭터 영상으로. 캐릭터를 업로드/선택하고, 자연스러운 움직임의 영상을 생성해 보세요.',
            page: {
                title1: '무료 AI 캐릭터→비디오 생성기',
                title2: '좋아하는 캐릭터를 살아 움직이게 하세요! 캐릭터 사진을 업로드하거나 微鲤AI 라이브러리에서 선택해 멋진 인터랙티브 영상을 생성합니다. 프롬프트로 장면과 상호작용을 설명하기만 하면 됩니다.',
                consistency: '업계 수준의 캐릭터 일관성. 고급 AI가 영상 전체에서 캐릭터의 고유한 특징과 외형을 안정적으로 유지합니다.',
                interactive: '의미 있는 상호작용을 만들어 보세요. 공원 산책부터 대화 장면까지, 스토리텔링 가능성은 무궁무진합니다.',
                faq: [
                    {
                        question: '특정 캐릭터로 영상을 만들려면?',
                        answer: '캐릭터 사진을 업로드하거나 WeryAI에서 선택한 뒤, 원하는 장면/상호작용을 프롬프트에 입력하고 생성하세요.',
                    },
                    {
                        question: '어떤 캐릭터 사진이든 사용할 수 있나요?',
                        answer: '네. 사용 권한이 있는 사진이라면 업로드할 수 있으며, AI가 지시에 따라 애니메이션을 생성합니다.',
                    },
                    {
                        question: '영상 길이 제한이 있나요?',
                        answer: '모델과 요금제에 따라 다르지만, 일반적으로 5~10초 길이를 지원합니다.',
                    },
                    {
                        question: '캐릭터가 일관되게 보이게 하려면?',
                        answer: '참조 이미지를 분석해 프레임 전반에서 특징을 유지하는 캐릭터 일관성 알고리즘을 사용합니다.',
                    },
                    {
                        question: '무료로 체험할 수 있나요?',
                        answer: '네. 매일 제공되는 무료 크레딧으로 캐릭터 영상을 생성해 볼 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI 캐릭터→비디오는 무엇인가요?',
                    answer: '특정 캐릭터가 등장하는 영상을 생성하는 고급 AI 도구입니다. 사진을 업로드하거나 라이브러리에서 선택해 인터랙티브 영상을 만들 수 있습니다.',
                },
                {
                    question: '영상에서 캐릭터 일관성은 어떻게 유지되나요?',
                    answer: '캐릭터 특징에 최적화된 학습과 추적을 통해, 영상 전체에서 외형을 안정적으로 유지하도록 설계되었습니다.',
                },
                {
                    question: '나와 캐릭터가 함께 나오는 영상도 만들 수 있나요?',
                    answer: '네. 프롬프트에 상호작용을 설명하면, 그 내용에 맞는 장면을 생성합니다.',
                },
                {
                    question: '어떤 AI 모델을 사용하나요?',
                    answer: 'Kling, Google Veo 등 최신 고성능 비디오 모델을 사용하며, 캐릭터 일관성과 자연스러운 움직임에 최적화합니다.',
                },
                {
                    question: '최대 몇 초까지 생성할 수 있나요?',
                    answer: '요금제에 따라 다르지만, 일반적으로 5~10초의 고화질 영상을 생성할 수 있습니다.',
                },
            ],
        },
        social_back: {
            title: '소셜 백 - 친구와 공유 | 微鲤AI',
            description: '친구와 공유하고 친구를 WeryAI에 초대하면 귀하와 친구 모두 보상을 받을 수 있습니다.',
            keywords: '소셜 백, 친구와 공유, 微鲤AI 초대, 보상 받기, 微鲤AI',
        },
    },
    es: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI es una plataforma todo en uno que permite generar videos e imágenes con inteligencia artificial a partir de texto, imágenes o videos, ofreciendo resultados de alta calidad.',
        home: {
            title: '微鲤AI - Generador de Video IA Gratis y Herramientas de Imagen (Kling, Flux, Veo)',
            description: 'Deja de pagar y cambiar entre suscripciones. Accede a los mejores modelos de IA del mundo—Kling AI, Google Veo, Sora y Flux—en un solo panel gratuito. Crea videos profesionales, haz face swap y mejora la calidad al instante.',
            ogDescription: 'Genera videos increíbles con Kling y Flux. Text-to-Video, Face Swap y Upscaling. Pruébalo gratis.',
            keywords: 'generador de videos con IA, generador de imágenes con IA, texto a video, imagen a video, creación de videos con IA, creación de imágenes con IA, generación de videos, generación de imágenes, creación de contenido con IA, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'Plataforma creativa con IA que actúa como agregador de modelos líderes como Kling AI, Google Veo, Sora y Flux. Incluye Text-to-Video, Face Swap y Upscaling.',
            software_feature: 'Integración de Kling AI, Texto a video, Face Swap con IA, Upscaler de video 4K, Imagen a video, Sincronización labial, Eliminador de fondo',
            og_title: '微鲤AI - La Plataforma Creativa Todo en Uno',
            og_description: 'Genera videos increíbles con Kling y Flux. Text-to-Video, Face Swap y Upscaling. Pruébalo gratis.',
            twitter_title: '微鲤AI - Generador de Video IA Gratis',
            twitter_description: 'Accede a Kling, Veo y Flux en un solo lugar. Genera videos y arte con IA al instante.',
            faq: [
                {
                    question: '¿Por qué 微鲤AI es mejor que usar los modelos por separado?',
                    answer: '微鲤AI actúa como un agregador. En lugar de pagar suscripciones separadas para Kling, Midjourney o Runway, obtienes acceso a los mejores modelos (Kling 2.5, Flux Pro, Google Veo) en un solo panel. Ahorras dinero y agilizas tu flujo de trabajo.',
                },
                {
                    question: '¿WeryAI es realmente gratis?',
                    answer: 'Sí. Ofrecemos generosos créditos diarios gratuitos para probar Text-to-Video, Face Swap y el Generador de Imágenes. No necesitas tarjeta para empezar. Para uso intensivo y descargas sin marca de agua, hay planes de pago flexibles.',
                },
                {
                    question: '¿Puedo usar Kling AI y Flux en esta plataforma?',
                    answer: 'Por supuesto. 微鲤AI integra las últimas versiones de Kling (video realista), Flux (imágenes de alta fidelidad) y Google Veo. Actualizamos nuestra biblioteca con frecuencia para que siempre tengas acceso a lo más nuevo.',
                },
                {
                    question: '¿Cómo puedo mejorar videos de baja calidad?',
                    answer: 'Usa nuestro AI Video Upscaler. Elimina ruido/desenfoque y mejora la resolución hasta 4K automáticamente. Ideal para restaurar videos familiares antiguos o mejorar clips para redes sociales.',
                },
                {
                    question: '¿Tengo derechos comerciales sobre mis creaciones?',
                    answer: 'Si tienes un plan de pago, sí. Conservas los derechos comerciales completos de los recursos generados en 微鲤AI, seguros para monetizar en YouTube, trabajo con clientes y campañas de marketing.',
                },
            ],
        },
        homePage: {
            title: 'Inicio | 微鲤AI',
            description: 'Crie vídeos e imagens com IA de forma simples e gratuita. Transforme texto, imagens ou vídeos em conteúdo visual de alta resolução com 微鲤AI.',
            keywords: 'gerador de vídeos com IA, gerador de imagens com IA, texto para vídeo, imagem para vídeo, criação de vídeos com IA, criação de imagens com IA, IA generativa, conteúdo visual com IA, 微鲤AI',
        },
        aiTools: {
            title: 'Kits de edición - Colección de las mejores herramientas de IA | 微鲤AI',
            description: 'Explora nuestra colección de herramientas AI de alta calidad para la generación de videos e imágenes. Crea videos y imágenes impresionantes con tecnología AI de vanguardia.',
            keywords: 'herramientas AI, herramientas de generación de videos, herramientas de generación de imágenes, herramientas AI para videos, herramientas AI para imágenes, 微鲤AI',
        },
        myCreations: {
            title: 'Mis Creaciones | 微鲤AI',
            description: 'Mira todas tus creaciones, incluyendo videos e imágenes. Administra tus creaciones usando 微鲤AI para crear contenido visual de alta calidad.',
            keywords: 'mis creaciones, creaciones de videos, creaciones de imágenes, gestión de creaciones, 微鲤AI',
        },
        aiImage: {
            title: 'Generador de Imágenes con IA - Crea Imágenes Impresionantes con IA | 微鲤AI',
            description: 'Crea imágenes profesionales generadas por IA con 微鲤AI. Transforma texto en imagen, genera visuales creativos y da vida a tu imaginación con tecnología IA avanzada.',
            keywords: 'generador de imágenes con IA, texto a imagen, arte con IA, creación de imágenes, fotos con IA, generador de arte digital',
        },
        aiVideo: {
            title: 'Generador de Videos con IA - Crea Videos Increíbles con IA | 微鲤AI',
            description: 'Genera videos impresionantes con IA usando 微鲤AI. Crea videos desde texto, imágenes o videos con modelos de IA de vanguardia como Sora, Veo y más.',
            keywords: 'generador de videos con IA, texto a video, creación de videos, videos con IA, generación de videos, Sora, Veo',
        },
        aiMusic: {
            title: 'Generador de Música IA - Vocal e Instrumental | 微鲤AI',
            description: 'Crea música con IA en segundos en 微鲤AI: genera canciones con voz o instrumentales, explora estilos como pop, rock, electrónica y jazz, y remezcla creaciones de la comunidad con un clic.',
            keywords: 'generador de música IA, generador de música IA gratis, generador de música IA con voz, generador de canciones vocales, generador de música instrumental, texto a música, crear música similar, remix música IA, estilos musicales, música libre de derechos, 微鲤AI',
        },
        pricing: {
            title: 'Precios y Planes - Creación de Videos e Imágenes con IA Asequible | 微鲤AI',
            description: 'Elige el plan perfecto para tus necesidades. Precios flexibles para generación de videos e imágenes con IA con 微鲤AI. Prueba gratuita disponible.',
            keywords: 'precios de IA, precios de generación de videos, precios de generación de imágenes, planes de suscripción',
        },
        faq: {
            title: 'Preguntas Frecuentes - Centro de Ayuda 微鲤AI',
            description: 'Encuentra respuestas a preguntas comunes sobre la plataforma de generación de videos e imágenes con IA de 微鲤AI. Obtén ayuda con funciones, precios y más.',
            keywords: 'preguntas frecuentes IA, ayuda 微鲤AI, ayuda generación videos, guía generación imágenes',
        },
        aboutUs: {
            title: 'Sobre Nosotros - Plataforma de Creación con IA 微鲤AI',
            description: 'Conoce 微鲤AI, la plataforma líder de creación de videos e imágenes con IA. Descubre nuestra misión de democratizar la creación de contenido con IA.',
            keywords: 'sobre 微鲤AI, plataforma IA, información empresa, tecnología IA',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'Modelos de Video IA - Veo, Sora, Kling AI y Más | 微鲤AI',
            description: 'Explora nuestra colección de modelos avanzados de generación de video IA, incluyendo Veo 3.1, Sora 2, Kling AI, Runway y más. Crea videos impresionantes con tecnología IA de vanguardia.',
            keywords: 'modelos de video IA, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, modelos generación video, tecnología video IA',
        },
        imageModels: {
            title: 'Modelos de Imagen IA - FLUX, Nano Banana, Imagen y Más | 微鲤AI',
            description: 'Explora nuestra colección de modelos avanzados de generación de imagen IA, incluyendo FLUX, Nano Banana, Imagen, GPT-4o y más. Crea imágenes profesionales con modelos IA de última generación.',
            keywords: 'modelos de imagen IA, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, modelos generación imagen, tecnología imagen IA',
        },
        ugcDetailImage: {
            title: 'Generador de Imágenes IA Gratis | Crea Tu Propia Obra | 微鲤AI',
            description: '¡Mira esta increíble imagen generada por IA y crea la tuya gratis! El potente generador de IA de 微鲤AI convierte tus ideas en impresionantes visuales en segundos. ¡Pruébalo ahora!',
            keywords: 'generador de imágenes IA, arte IA gratis, imagen generada por IA, texto a imagen, crear imágenes IA, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Generador de Videos IA Gratis | Crea Tu Propia Obra | 微鲤AI',
            description: '¡Mira este increíble video generado por IA y crea el tuyo gratis! El potente generador de IA de 微鲤AI convierte tus ideas en impresionantes videos en segundos. ¡Pruébalo ahora!',
            keywords: 'generador de videos IA, video IA gratis, video generado por IA, texto a video, crear videos IA, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Generador de Música IA Gratis | Crea Tu Propia Música | 微鲤AI',
            description: '¡Escucha esta increíble música generada por IA y crea la tuya gratis! El potente generador de música IA de 微鲤AI convierte tus ideas en canciones únicas en segundos. ¡Pruébalo ahora!',
            keywords: 'generador de música IA, música IA gratis, música generada por IA, texto a música, crear canciones IA, música libre de regalías, 微鲤AI',
            og_title: 'Generador de Música IA Gratis | Crea Tu Propia Música | 微鲤AI',
            og_description: '¡Escucha esta increíble música generada por IA y crea la tuya gratis! El potente generador de música IA de 微鲤AI convierte tus ideas en canciones únicas en segundos.',
            twitter_title: 'Generador de Música IA Gratis | 微鲤AI',
            twitter_description: '¡Escucha música generada por IA y crea la tuya gratis!',
        },
        characters: {
            title: 'Personajes IA - Chatea con Personajes IA y Compañeros Virtuales | 微鲤AI',
            description: 'Chatea con miles de personajes IA en 微鲤AI. Descubre personajes de anime, compañeros virtuales y personalidades IA interactivas. Inicia conversaciones con personajes IA gratis.',
            keywords: 'personajes IA, chat IA, compañeros virtuales, personajes anime, personalidad IA, chat de personajes, conversación IA, amigos virtuales, 微鲤AI',
            og_title: 'Personajes IA - Chatea con Personajes IA y Compañeros Virtuales | 微鲤AI',
            og_description: 'Explora miles de personajes IA y comienza conversaciones significativas. Chatea con personajes de anime, compañeros virtuales y personalidades IA interactivas gratis.',
            twitter_title: 'Personajes IA - Chatea con Personajes IA | 微鲤AI',
            twitter_description: 'Descubre y chatea con miles de personajes IA. Personajes de anime, compañeros virtuales y personalidades interactivas—todo gratis en 微鲤AI.',
        },
        characterToImage: {
            title: 'Imagen de Personaje con IA - Crea tus Imágenes de Personaje | 微鲤AI',
            description: 'Elige tu personaje en 微鲤AI, escribe un prompt y haz clic en Generar para crear tus propias imágenes de personaje.',
            keywords: 'imagen de personaje con IA, personaje con IA, generador de imágenes de personaje, imágenes de personaje, 微鲤AI',
            og_title: 'Imagen de Personaje con IA - Crea tus Imágenes de Personaje | 微鲤AI',
            og_description: 'Elige tu personaje en 微鲤AI, escribe un prompt y haz clic en Generar para crear tus propias imágenes de personaje.',
            twitter_title: 'Imagen de Personaje con IA - Crea tus Imágenes de Personaje | 微鲤AI',
            twitter_description: 'Elige tu personaje en 微鲤AI, escribe un prompt y haz clic en Generar para crear tus propias imágenes de personaje.',
        },
        characterToVideo: {
            title: 'AI Personaje a Video - Genera videos interactivos con personajes | 微鲤AI',
            description: 'Crea videos increíbles con cualquier personaje de IA. Sube fotos del personaje o elige uno en 微鲤AI para generar videos interactivos contigo y el personaje.',
            keywords: 'personaje a video IA, generador de video de personaje, video interactivo IA, consistencia de personaje, 微鲤AI',
            og_title: 'AI Personaje a Video - Genera videos interactivos con personajes | 微鲤AI',
            og_description: 'Convierte tus ideas en videos interactivos con personajes. Sube o elige personajes en 微鲤AI y genera movimiento realista.',
            twitter_title: 'AI Personaje a Video - Crea videos interactivos con personajes | 微鲤AI',
            twitter_description: 'Genera videos de alta calidad con tus personajes favoritos. Sube o elige personajes en 微鲤AI para crear videos interactivos.',
            page: {
                title1: 'Generador gratis de personaje→video con IA',
                title2: '¡Dale vida a tus personajes favoritos! Sube una foto de cualquier personaje o elige uno de la biblioteca de 微鲤AI para generar videos interactivos. Describe la escena en tu prompt y mira cómo tú y el personaje aparecen juntos en un video cinematográfico.',
                consistency: 'Consistencia de personaje líder del sector. Nuestra IA mantiene rasgos y apariencia a lo largo de todo el video.',
                interactive: 'Crea interacciones significativas: desde caminar juntos hasta conversar. Las posibilidades son infinitas.',
                faq: [
                    {
                        question: '¿Cómo creo un video con un personaje específico?',
                        answer: 'Sube una foto del personaje o elige uno en 微鲤AI. Luego escribe un prompt describiendo la escena o interacción y genera el video.',
                    },
                    {
                        question: '¿Puedo usar cualquier foto de personaje?',
                        answer: 'Sí, siempre que tengas derecho a usarla. La IA animará el personaje según tus instrucciones.',
                    },
                    {
                        question: '¿Hay límite de duración?',
                        answer: 'Depende del modelo y tu plan, normalmente entre 5 y 10 segundos.',
                    },
                    {
                        question: '¿Cómo aseguro que el personaje se vea consistente?',
                        answer: 'Usamos algoritmos de consistencia que analizan la imagen de referencia para mantener rasgos estables en todos los fotogramas.',
                    },
                    {
                        question: '¿Se puede probar gratis?',
                        answer: 'Sí, puedes generar videos con tus créditos diarios gratuitos.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Qué es 微鲤AI Personaje a Video?',
                    answer: 'Es una herramienta avanzada que genera videos con personajes específicos. Sube una foto o elige uno de la biblioteca para crear contenido interactivo.',
                },
                {
                    question: '¿Cómo funciona la consistencia en video?',
                    answer: 'La IA analiza rasgos del personaje y los mantiene estables durante todo el clip para que se vea reconocible.',
                },
                {
                    question: '¿Puedo crear un video mío con un personaje?',
                    answer: 'Sí, describe la interacción en el prompt y la IA generará el video con ambos.',
                },
                {
                    question: '¿Qué modelos se usan?',
                    answer: 'Usamos modelos de video de alto rendimiento como Kling y Google Veo, optimizados para movimiento realista y consistencia.',
                },
                {
                    question: '¿Cuál es la duración máxima?',
                    answer: 'Según tu plan, normalmente entre 5 y 10 segundos en alta definición.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Comparte con amigos | 微鲤AI',
            description: 'Comparte con amigos, invita a tus amigos a registrarse en 微鲤AI, y tú y tus amigos recibirán recompensas.',
            keywords: 'social back, compartir con amigos, invitar amigos a 微鲤AI, recibir recompensas, 微鲤AI',
        },
    },
    fr: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: `微鲤AI est une plateforme tout-en-un qui permet de générer des vidéos et images à l'aide de l'intelligence artificielle à partir de texte, d'images ou de vidéos, avec une qualité professionnelle.`,
        home: {
            title: '微鲤AI - Générateur de Vidéo IA Gratuit & Outils Image (Kling, Flux, Veo)',
            description: `Ne jonglez plus entre plusieurs abonnements. Accédez aux meilleurs modèles d'IA—Kling AI, Google Veo, Sora et Flux—dans un seul tableau de bord gratuit. Créez des vidéos pro, faites du face swap et améliorez la qualité instantanément.`,
            ogDescription: 'Générez des vidéos époustouflantes avec Kling & Flux. Text-to-Video, Face Swap et Upscaling. Essayez gratuitement.',
            keywords: 'générateur vidéo IA, générateur image IA, texte vers vidéo, image vers vidéo, création vidéo IA, création image IA, génération vidéo, génération image, création contenu IA, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'Plateforme créative propulsée par l’IA, agrégateur de modèles de pointe comme Kling AI, Google Veo, Sora et Flux. Fonctions : Text-to-Video, Face Swap, Upscaling.',
            software_feature: 'Intégration Kling AI, Texte→Vidéo, Face Swap IA, Upscaler vidéo 4K, Image→Vidéo, Lip Sync, Suppression d’arrière-plan',
            og_title: '微鲤AI - La Plateforme Créative Tout-en-Un',
            og_description: 'Générez des vidéos époustouflantes avec Kling & Flux. Text-to-Video, Face Swap et Upscaling. Essayez gratuitement.',
            twitter_title: '微鲤AI - Générateur de Vidéo IA Gratuit',
            twitter_description: 'Accédez à Kling, Veo et Flux au même endroit. Générez des vidéos et de l’art IA instantanément.',
            faq: [
                {
                    question: 'Pourquoi 微鲤AI est-il meilleur que d’utiliser les modèles séparément ?',
                    answer: '微鲤AI agit comme un agrégateur. Au lieu de payer des abonnements séparés pour Kling, Midjourney ou Runway, vous accédez à des modèles de pointe (Kling 2.5, Flux Pro, Google Veo) dans un seul tableau de bord. Vous économisez et simplifiez votre workflow.',
                },
                {
                    question: '微鲤AI est-il vraiment gratuit ?',
                    answer: 'Oui. Nous offrons des crédits gratuits quotidiens généreux pour tester Text-to-Video, Face Swap et le générateur d’images. Aucune carte bancaire n’est nécessaire pour commencer. Pour un usage intensif et des téléchargements sans filigrane, des plans payants flexibles sont disponibles.',
                },
                {
                    question: 'Puis-je utiliser Kling AI et Flux sur cette plateforme ?',
                    answer: 'Absolument. 微鲤AI intègre les dernières versions de Kling (vidéo réaliste), Flux (images haute fidélité) et Google Veo. Nous mettons régulièrement à jour la bibliothèque de modèles pour rester à la pointe.',
                },
                {
                    question: 'Comment améliorer des vidéos de faible qualité ?',
                    answer: 'Utilisez notre AI Video Upscaler. Il réduit automatiquement le bruit/le flou et upscale la vidéo jusqu’à la résolution 4K. Parfait pour restaurer de vieilles vidéos familiales ou améliorer des clips pour les réseaux sociaux.',
                },
                {
                    question: 'Est-ce que je possède les droits commerciaux sur mes créations ?',
                    answer: 'Si vous êtes sur un plan payant, oui. Vous conservez les droits commerciaux complets sur les contenus générés sur 微鲤AI, adaptés à la monétisation YouTube, au travail client et aux campagnes marketing.',
                },
            ],
        },
        homePage: {
            title: 'Accueil | 微鲤AI',
            description: 'Générez des vidéos et des images avec IA de manière simple et gratuite. Transformez du texte, des images ou des vidéos en contenu visuel de haute qualité avec 微鲤AI.',
            keywords: `générateur de vidéos avec IA, générateur d'images avec IA, texte vers vidéo, image vers vidéo, création de vidéos avec IA, création d'images avec IA, IA générative, contenu visuel avec IA, 微鲤AI`,
        },
        aiTools: {
            title: `Kits d'édition - Collection des meilleurs outils d'IA | 微鲤AI`,
            description: `Explorez notre collection d'outils AI de haute qualité pour la génération de vidéos et images. Créez des vidéos et images impressionnantes avec une technologie IA de pointe.`,
            keywords: `outils AI, outils de génération de vidéos, outils de génération d'images, outils AI pour vidéos, outils AI pour images, 微鲤AI`,
        },
        myCreations: {
            title: 'Mes Créations | 微鲤AI',
            description: 'Voir toutes vos créations, y compris des vidéos et des images. Gérez vos créations en utilisant 微鲤AI pour créer un contenu visuel de haute qualité.',
            keywords: `mes créations, créations de vidéos, créations d'images, gestion de créations, 微鲤AI`,
        },
        aiImage: {
            title: `Générateur d'Images IA - Créez des Images Époustouflantes avec l'IA | 微鲤AI`,
            description: 'Créez des images professionnelles générées par IA avec 微鲤AI. Transformez du texte en image, générez des visuels créatifs et donnez vie à votre imagination avec une technologie IA avancée.',
            keywords: 'générateur image IA, texte vers image, art IA, création images, photos IA, générateur art numérique',
        },
        aiVideo: {
            title: `Générateur de Vidéos IA - Créez des Vidéos Incroyables avec l'IA | 微鲤AI`,
            description: `Générez des vidéos IA époustouflantes avec 微鲤AI. Créez des vidéos à partir de texte, d'images ou de vidéos avec des modèles IA de pointe comme Sora, Veo et plus.`,
            keywords: 'générateur vidéo IA, texte vers vidéo, création vidéo, vidéos IA, génération vidéo, Sora, Veo',
        },
        aiMusic: {
            title: 'Générateur de Musique IA - Vocal & Instrumental | 微鲤AI',
            description: 'Créez de la musique IA en quelques secondes avec 微鲤AI : chansons vocales ou instrumentales, explorez pop, rock, électronique, jazz, et remixez des créations de la communauté en un clic.',
            keywords: 'générateur de musique IA, générateur de musique IA gratuit, générateur de musique IA avec voix, générateur de chansons vocales, générateur de musique instrumentale, texte en musique, créer musique similaire, remix musique IA, styles musicaux, musique libre de droits, 微鲤AI',
        },
        pricing: {
            title: 'Tarifs et Plans - Création de Vidéos et Images IA Abordable | 微鲤AI',
            description: 'Choisissez le plan parfait pour vos besoins. Tarifs flexibles pour la génération de vidéos et images IA avec 微鲤AI. Essai gratuit disponible.',
            keywords: 'tarifs IA, tarifs génération vidéo, tarifs génération image, plans abonnement',
        },
        faq: {
            title: `Questions Fréquentes - Centre d'Aide 微鲤AI`,
            description: `Trouvez des réponses aux questions courantes sur la plateforme de génération de vidéos et images IA de 微鲤AI. Obtenez de l'aide sur les fonctionnalités, les tarifs et plus.`,
            keywords: 'FAQ IA, aide 微鲤AI, aide génération vidéo, guide génération image',
        },
        aboutUs: {
            title: 'À Propos - Plateforme de Création IA 微鲤AI',
            description: 'Découvrez 微鲤AI, la plateforme leader de création de vidéos et images IA. Découvrez notre mission de démocratiser la création de contenu IA.',
            keywords: 'à propos 微鲤AI, plateforme IA, informations entreprise, technologie IA',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'Modèles Vidéo IA - Veo, Sora, Kling AI et Plus | 微鲤AI',
            description: 'Explorez notre collection de modèles avancés de génération vidéo IA, y compris Veo 3.1, Sora 2, Kling AI, Runway et plus. Créez des vidéos époustouflantes avec une technologie IA de pointe.',
            keywords: 'modèles vidéo IA, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, modèles génération vidéo, technologie vidéo IA',
        },
        imageModels: {
            title: 'Modèles Image IA - FLUX, Nano Banana, Imagen et Plus | 微鲤AI',
            description: `Explorez notre collection de modèles avancés de génération d'image IA, y compris FLUX, Nano Banana, Imagen, GPT-4o et plus. Créez des images professionnelles avec des modèles IA de pointe.`,
            keywords: 'modèles image IA, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, modèles génération image, technologie image IA',
        },
        ugcDetailImage: {
            title: `Générateur d'Images IA Gratuit | Créez Votre Propre Œuvre | 微鲤AI`,
            description: 'Découvrez cette incroyable image générée par IA et créez la vôtre gratuitement ! Le puissant générateur IA de 微鲤AI transforme vos idées en visuels époustouflants en quelques secondes. Essayez maintenant !',
            keywords: `générateur d'images IA, art IA gratuit, image générée par IA, texte en image, créer images IA, 微鲤AI`,
        },
        ugcDetailVideo: {
            title: 'Générateur de Vidéos IA Gratuit | Créez Votre Propre Œuvre | 微鲤AI',
            description: 'Découvrez cette incroyable vidéo générée par IA et créez la vôtre gratuitement ! Le puissant générateur IA de 微鲤AI transforme vos idées en vidéos époustouflantes en quelques secondes. Essayez maintenant !',
            keywords: 'générateur de vidéos IA, vidéo IA gratuite, vidéo générée par IA, texte en vidéo, créer vidéos IA, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Générateur de Musique IA Gratuit | Créez Votre Propre Musique | 微鲤AI',
            description: 'Écoutez cette incroyable musique générée par IA et créez la vôtre gratuitement ! Le puissant générateur de musique IA de 微鲤AI transforme vos idées en chansons uniques en quelques secondes. Essayez maintenant !',
            keywords: 'générateur de musique IA, musique IA gratuite, musique générée par IA, texte en musique, créer chansons IA, musique libre de droits, 微鲤AI',
            og_title: 'Générateur de Musique IA Gratuit | Créez Votre Propre Musique | 微鲤AI',
            og_description: 'Écoutez cette incroyable musique générée par IA et créez la vôtre gratuitement ! Le puissant générateur de musique IA de 微鲤AI transforme vos idées en chansons uniques en quelques secondes.',
            twitter_title: 'Générateur de Musique IA Gratuit | 微鲤AI',
            twitter_description: 'Écoutez de la musique générée par IA et créez la vôtre gratuitement !',
        },
        characters: {
            title: 'characters Génération Vidéo et Image IA | 微鲤AI',
            description: 'Experience characters on 微鲤AI. High-quality results.',
            keywords: 'characters, AI, 微鲤AI',
        },
        characterToImage: {
            title: 'Image de Personnage IA - Créez vos Images de Personnage | 微鲤AI',
            description: 'Choisissez votre personnage sur 微鲤AI, saisissez un prompt, puis cliquez sur Générer pour créer vos propres images de personnage.',
            keywords: 'image de personnage IA, personnage IA, génération d’images de personnage, images de personnage, 微鲤AI',
            og_title: 'Image de Personnage IA - Créez vos Images de Personnage | 微鲤AI',
            og_description: 'Choisissez votre personnage sur 微鲤AI, saisissez un prompt, puis cliquez sur Générer pour créer vos propres images de personnage.',
            twitter_title: 'Image de Personnage IA - Créez vos Images de Personnage | 微鲤AI',
            twitter_description: 'Choisissez votre personnage sur 微鲤AI, saisissez un prompt, puis cliquez sur Générer pour créer vos propres images de personnage.',
        },
        characterToVideo: {
            title: 'IA Personnage vers Vidéo - Générez des vidéos interactives | 微鲤AI',
            description: 'Créez des vidéos incroyables avec n’importe quel personnage IA. Importez une photo du personnage ou choisissez-en un sur 微鲤AI pour générer des vidéos interactives avec vous et le personnage.',
            keywords: 'personnage vers vidéo IA, générateur vidéo de personnage, vidéo IA interactive, cohérence de personnage, 微鲤AI',
            og_title: 'IA Personnage vers Vidéo - Générez des vidéos interactives | 微鲤AI',
            og_description: 'Transformez vos idées en vidéos interactives avec des personnages IA. Importez ou choisissez un personnage sur 微鲤AI et générez un mouvement réaliste.',
            twitter_title: 'IA Personnage vers Vidéo - Créez des vidéos interactives | 微鲤AI',
            twitter_description: 'Générez des vidéos de haute qualité avec vos personnages préférés. Importez ou choisissez un personnage sur 微鲤AI pour créer des vidéos interactives.',
            page: {
                title1: 'Générateur gratuit Personnage→Vidéo IA',
                title2: 'Donnez vie à vos personnages préférés ! Importez une photo ou choisissez un personnage dans la bibliothèque 微鲤AI pour générer une vidéo interactive. Décrivez la scène dans votre prompt et regardez le résultat cinématographique.',
                consistency: 'Cohérence de personnage de niveau professionnel : l’IA conserve les traits et l’apparence tout au long de la vidéo.',
                interactive: 'Créez des interactions significatives : marcher ensemble, discuter… les possibilités sont infinies.',
                faq: [
                    {
                        question: 'Comment créer une vidéo avec un personnage précis ?',
                        answer: 'Importez une photo du personnage ou choisissez-en un sur 微鲤AI, puis saisissez un prompt décrivant la scène ou l’interaction.',
                    },
                    {
                        question: 'Puis-je utiliser n’importe quelle photo ?',
                        answer: 'Oui, si vous avez le droit de l’utiliser. L’IA animera le personnage selon vos instructions.',
                    },
                    {
                        question: 'Y a-t-il une limite de durée ?',
                        answer: 'Selon le modèle et votre abonnement, généralement entre 5 et 10 secondes.',
                    },
                    {
                        question: 'Comment garder le personnage cohérent ?',
                        answer: 'Nous analysons l’image de référence et maintenons les traits stables sur tous les frames.',
                    },
                    {
                        question: 'Puis-je essayer gratuitement ?',
                        answer: 'Oui, vous pouvez générer des vidéos avec vos crédits gratuits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Qu’est-ce que Personnage vers Vidéo sur 微鲤AI ?',
                    answer: 'C’est un outil avancé qui génère des vidéos avec un personnage spécifique. Importez une photo ou choisissez-en un pour créer une vidéo interactive.',
                },
                {
                    question: 'Comment fonctionne la cohérence en vidéo ?',
                    answer: 'L’IA s’appuie sur l’image de référence pour conserver une apparence stable et reconnaissable pendant tout le clip.',
                },
                {
                    question: 'Puis-je créer une vidéo de moi avec un personnage ?',
                    answer: 'Oui. Décrivez l’interaction dans le prompt et l’IA générera la vidéo correspondante.',
                },
                {
                    question: 'Quels modèles sont utilisés ?',
                    answer: 'Nous utilisons des modèles vidéo performants comme Kling et Google Veo, optimisés pour la cohérence et le mouvement réaliste.',
                },
                {
                    question: 'Quelle est la durée maximale ?',
                    answer: 'Selon votre plan, vous pouvez générer des vidéos HD d’environ 5 à 10 secondes.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Partager avec des amis | 微鲤AI',
            description: `Partagez avec des amis, invitez des amis à s'inscrire sur 微鲤AI, vous et vos amis recevrez des récompenses.`,
            keywords: 'social back, partager avec des amis, inviter des amis sur 微鲤AI, recevoir des récompenses, 微鲤AI',
        },
    },
    de: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI ist eine All-in-One-Plattform zur Erstellung von KI-generierten Videos und Bildern. Erstellen Sie hochwertige visuelle Inhalte aus Text, Bildern oder Videos – schnell und einfach.',
        home: {
            title: '微鲤AI - Kostenloser KI-Videogenerator & Bild-Tools (Kling, Flux, Veo)',
            description: 'Keine Abo-Jonglage mehr. Greifen Sie in einem kostenlosen Dashboard auf die besten KI-Modelle der Welt zu—Kling AI, Google Veo, Sora und Flux. Erstellen Sie professionelle Videos, tauschen Sie Gesichter und verbessern Sie die Qualität sofort.',
            ogDescription: 'Erzeugen Sie beeindruckende Videos mit Kling & Flux. Text-to-Video, Face Swap und Upscaling. Jetzt kostenlos testen.',
            keywords: 'KI-Videogenerator, KI-Bildgenerator, Text zu Video, Bild zu Video, KI-Videoerstellung, KI-Bilderstellung, Videogenerierung, Bildgenerierung, KI-Content-Erstellung, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'KI-gestützte Kreativplattform als Aggregator für Top-Modelle wie Kling AI, Google Veo, Sora und Flux. Enthält Text-to-Video, Face Swap und Upscaling.',
            software_feature: 'Kling-AI-Integration, Text zu Video, KI-Face-Swap, 4K-Video-Upscaler, Bild zu Video, Lip-Sync, Hintergrund-Entferner',
            og_title: '微鲤AI - Die All-in-One KI-Kreativplattform',
            og_description: 'Erzeugen Sie beeindruckende Videos mit Kling & Flux. Text-to-Video, Face Swap und Upscaling. Jetzt kostenlos testen.',
            twitter_title: '微鲤AI - Kostenloser KI-Videogenerator',
            twitter_description: 'Kling, Veo und Flux an einem Ort. Erstellen Sie KI-Videos & KI-Kunst sofort.',
            faq: [
                {
                    question: 'Warum ist 微鲤AI besser als Modelle einzeln zu nutzen?',
                    answer: '微鲤AI fungiert als Aggregator. Statt separate Abos für Kling, Midjourney oder Runway zu bezahlen, erhalten Sie Zugriff auf Top-Modelle (Kling 2.5, Flux Pro, Google Veo) in einem einzigen Dashboard. Das spart Geld und vereinfacht Ihren Workflow.',
                },
                {
                    question: 'Ist 微鲤AI wirklich kostenlos?',
                    answer: 'Ja. Wir bieten großzügige tägliche Gratis-Credits, mit denen Sie Text-to-Video, Face Swap und den Image Generator testen können. Keine Kreditkarte nötig. Für Vielnutzer und Downloads ohne Wasserzeichen gibt es flexible bezahlte Pläne.',
                },
                {
                    question: 'Kann ich Kling AI und Flux auf dieser Plattform nutzen?',
                    answer: 'Absolut. 微鲤AI integriert die neuesten Versionen von Kling (realistische Videos), Flux (hochfidele Bilder) und Google Veo. Wir aktualisieren unsere Modellbibliothek regelmäßig, damit Sie immer Zugriff auf das Neueste haben.',
                },
                {
                    question: 'Wie kann ich Videos mit niedriger Qualität verbessern?',
                    answer: 'Nutzen Sie unseren AI Video Upscaler. Er reduziert automatisch Rauschen/Unschärfe und skaliert Material bis 4K hoch. Perfekt zum Restaurieren alter Familienvideos oder zum Verbessern von Social-Media-Clips.',
                },
                {
                    question: 'Besitze ich die kommerziellen Rechte an meinen Kreationen?',
                    answer: 'Wenn Sie einen bezahlten Plan haben, ja. Sie besitzen die vollen kommerziellen Rechte an allen in 微鲤AI generierten Assets—sicher für YouTube-Monetarisierung, Kundenarbeit und Marketingkampagnen.',
                },
            ],
        },
        homePage: {
            title: 'Startseite | 微鲤AI',
            description: 'Erstellen Sie mit 微鲤AI beeindruckende KI-Videos und -Bilder. Einfach, schnell und in höchster Qualität – Ihre kreative All-in-One-Plattform.',
            keywords: 'KI-Videogenerator, KI-Bildgenerator, Text zu Video, Bild zu Video, KI-Videoerstellung, KI-Bilderstellung, Videogenerierung, Bildgenerierung, KI-Content-Erstellung, 微鲤AI',
        },
        aiTools: {
            title: 'Editor-Toolkits - Sammlung der besten KI-Tools | 微鲤AI',
            description: 'Mit 微鲤AI erstellen Sie mühelos hochwertige KI-Videos und -Bilder aus Text, Bildern oder Videos. Verwandeln Sie Ihre Ideen in beeindruckende visuelle Inhalte – kostenlos und intuitiv.',
            keywords: 'KI-Videogenerator, KI-Bildgenerator, Text zu Video, Bild zu Video, KI-Videoerstellung, KI-Bilderstellung, Videogenerierung, Bildgenerierung, KI-Content-Erstellung, 微鲤AI',
        },
        myCreations: {
            title: 'Meine Creations | 微鲤AI',
            description: 'Sehen Sie alle Ihre Creations, einschließlich Videos und Bilder. Verwalten Sie Ihre Creations mit 微鲤AI, um hochwertige visuelle Inhalte zu erstellen.',
            keywords: 'meine creations, creations von videos, creations von bildern, creations verwaltung, 微鲤AI',
        },
        aiImage: {
            title: 'KI-Bildgenerator - Erstellen Sie Atemberaubende Bilder mit KI | 微鲤AI',
            description: 'Erstellen Sie professionelle KI-generierte Bilder mit 微鲤AI. Verwandeln Sie Text in Bilder, generieren Sie kreative Visualisierungen und erwecken Sie Ihre Vorstellungskraft mit fortschrittlicher KI-Technologie zum Leben.',
            keywords: 'KI-Bildgenerator, Text zu Bild, KI-Kunst, Bilderstellung, KI-Fotos, digitaler Kunstgenerator',
        },
        aiVideo: {
            title: 'KI-Videogenerator - Erstellen Sie Erstaunliche Videos mit KI | 微鲤AI',
            description: 'Generieren Sie atemberaubende KI-Videos mit 微鲤AI. Erstellen Sie Videos aus Text, Bildern oder Videos mit modernsten KI-Modellen wie Sora, Veo und mehr.',
            keywords: 'KI-Videogenerator, Text zu Video, Videoerstellung, KI-Videos, Videogenerierung, Sora, Veo',
        },
        aiMusic: {
            title: 'KI-Musikgenerator - Vocal & Instrumental | 微鲤AI',
            description: 'Erzeuge KI-Musik in Sekunden mit 微鲤AI: vokale Songs oder Instrumentals, entdecke Pop, Rock, Electronic, Jazz und remixe Community-Kreationen mit einem Klick.',
            keywords: 'KI-Musikgenerator, KI-Musikgenerator kostenlos, KI-Musikgenerator mit Gesang, Gesangssong-Generator, Instrumentalmusik-Generator, Text zu Musik, ähnliche Musik erstellen, KI-Musik Remix, Musikstile, lizenzfreie Musik, 微鲤AI',
        },
        pricing: {
            title: 'Preise & Pläne - Erschwingliche KI-Video- und Bilderstellung | 微鲤AI',
            description: 'Wählen Sie den perfekten Plan für Ihre Bedürfnisse. Flexible Preise für KI-Video- und Bildgenerierung mit 微鲤AI. Kostenlose Testversion verfügbar.',
            keywords: 'KI-Preise, Videogenerierungspreise, Bildgenerierungspreise, Abonnementpläne',
        },
        faq: {
            title: 'Häufig gestellte Fragen - 微鲤AI Hilfecenter',
            description: 'Finden Sie Antworten auf häufige Fragen zur KI-Video- und Bildgenerierungsplattform von 微鲤AI. Erhalten Sie Hilfe zu Funktionen, Preisen und mehr.',
            keywords: 'KI-FAQ, 微鲤AI-Hilfe, Videogenerierungshilfe, Bildgenerierungsanleitung',
        },
        aboutUs: {
            title: 'Über Uns - 微鲤AI KI-Erstellungsplattform',
            description: 'Erfahren Sie mehr über 微鲤AI, die führende KI-Video- und Bilderstellungsplattform. Entdecken Sie unsere Mission, die KI-Content-Erstellung zu demokratisieren.',
            keywords: 'über 微鲤AI, KI-Plattform, Unternehmensinformationen, KI-Technologie',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'KI-Videomodelle - Veo, Sora, Kling AI & Mehr | 微鲤AI',
            description: 'Erkunden Sie unsere Sammlung fortschrittlicher KI-Videogenerierungsmodelle, darunter Veo 3.1, Sora 2, Kling AI, Runway und mehr. Erstellen Sie atemberaubende Videos mit modernster KI-Technologie.',
            keywords: 'KI-Videomodelle, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, Videogenerierungsmodelle, KI-Videotechnologie',
        },
        imageModels: {
            title: 'KI-Bildmodelle - FLUX, Nano Banana, Imagen & Mehr | 微鲤AI',
            description: 'Erkunden Sie unsere Sammlung fortschrittlicher KI-Bildgenerierungsmodelle, darunter FLUX, Nano Banana, Imagen, GPT-4o und mehr. Erstellen Sie professionelle Bilder mit hochmodernen KI-Modellen.',
            keywords: 'KI-Bildmodelle, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, Bildgenerierungsmodelle, KI-Bildtechnologie',
        },
        ugcDetailImage: {
            title: 'Kostenloser KI-Bildgenerator | Erstellen Sie Ihr Eigenes | 微鲤AI',
            description: 'Sehen Sie sich dieses erstaunliche KI-generierte Bild an und erstellen Sie kostenlos Ihr eigenes! Der leistungsstarke KI-Generator von 微鲤AI verwandelt Ihre Ideen in Sekunden in atemberaubende Bilder. Jetzt ausprobieren!',
            keywords: 'KI-Bildgenerator, kostenlose KI-Kunst, KI-generiertes Bild, Text zu Bild, KI-Bilder erstellen, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Kostenloser KI-Videogenerator | Erstellen Sie Ihr Eigenes | 微鲤AI',
            description: 'Sehen Sie sich dieses erstaunliche KI-generierte Video an und erstellen Sie kostenlos Ihr eigenes! Der leistungsstarke KI-Generator von 微鲤AI verwandelt Ihre Ideen in Sekunden in atemberaubende Videos. Jetzt ausprobieren!',
            keywords: 'KI-Videogenerator, kostenloses KI-Video, KI-generiertes Video, Text zu Video, KI-Videos erstellen, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Kostenloser KI-Musikgenerator | Erstellen Sie Ihre Eigene Musik | 微鲤AI',
            description: 'Hören Sie sich diese erstaunliche KI-generierte Musik an und erstellen Sie kostenlos Ihre eigene! Der leistungsstarke KI-Musikgenerator von 微鲤AI verwandelt Ihre Ideen in Sekunden in einzigartige Songs. Jetzt ausprobieren!',
            keywords: 'KI-Musikgenerator, kostenlose KI-Musik, KI-generierte Musik, Text zu Musik, KI-Songs erstellen, lizenzfreie Musik, 微鲤AI',
            og_title: 'Kostenloser KI-Musikgenerator | Erstellen Sie Ihre Eigene Musik | 微鲤AI',
            og_description: 'Hören Sie sich diese erstaunliche KI-generierte Musik an und erstellen Sie kostenlos Ihre eigene! Der leistungsstarke KI-Musikgenerator von 微鲤AI verwandelt Ihre Ideen in Sekunden in einzigartige Songs.',
            twitter_title: 'Kostenloser KI-Musikgenerator | 微鲤AI',
            twitter_description: 'Hören Sie KI-generierte Musik und erstellen Sie kostenlos Ihre eigene!',
        },
        characters: {
            title: 'KI-Charaktere - Chatten Sie mit KI-Charakteren & Virtuellen Begleitern | 微鲤AI',
            description: 'Chatten Sie mit Tausenden von KI-Charakteren auf 微鲤AI. Entdecken Sie Anime-Charaktere, virtuelle Begleiter und interaktive KI-Persönlichkeiten. Beginnen Sie kostenlos Gespräche mit KI-Charakteren.',
            keywords: 'KI-Charaktere, KI-Chat, virtuelle Begleiter, Anime-Charaktere, KI-Persönlichkeit, Charakter-Chat, KI-Konversation, virtuelle Freunde, 微鲤AI',
            og_title: 'KI-Charaktere - Chatten Sie mit KI-Charakteren & Virtuellen Begleitern | 微鲤AI',
            og_description: 'Erkunden Sie Tausende von KI-Charakteren und beginnen Sie bedeutsame Gespräche. Chatten Sie kostenlos mit Anime-Charakteren, virtuellen Begleitern und interaktiven KI-Persönlichkeiten.',
            twitter_title: 'KI-Charaktere - Chatten Sie mit KI-Charakteren | 微鲤AI',
            twitter_description: 'Entdecken und chatten Sie mit Tausenden von KI-Charakteren. Anime-Charaktere, virtuelle Begleiter und interaktive Persönlichkeiten—alle kostenlos auf 微鲤AI.',
        },
        characterToImage: {
            title: 'KI-Charakterbilder - Erstelle deine eigenen Charakterbilder | 微鲤AI',
            description: 'Wähle deinen Charakter auf 微鲤AI, gib einen Prompt ein und klicke auf Generieren, um deine eigenen Charakterbilder zu erstellen.',
            keywords: 'KI-Charakterbilder, KI-Charakter, Charakterbilder erstellen, Charakterbild, 微鲤AI',
            og_title: 'KI-Charakterbilder - Erstelle deine eigenen Charakterbilder | 微鲤AI',
            og_description: 'Wähle deinen Charakter auf 微鲤AI, gib einen Prompt ein und klicke auf Generieren, um deine eigenen Charakterbilder zu erstellen.',
            twitter_title: 'KI-Charakterbilder - Erstelle deine eigenen Charakterbilder | 微鲤AI',
            twitter_description: 'Wähle deinen Charakter auf 微鲤AI, gib einen Prompt ein und klicke auf Generieren, um deine eigenen Charakterbilder zu erstellen.',
        },
        characterToVideo: {
            title: 'KI Charakter zu Video - Interaktive Charaktervideos erstellen | 微鲤AI',
            description: 'Erstelle beeindruckende Videos mit jedem KI-Charakter. Lade Charakterfotos hoch oder wähle einen Charakter auf 微鲤AI aus, um interaktive Videos von dir und dem Charakter zu generieren.',
            keywords: 'KI Charakter zu Video, Charaktervideo Generator, interaktives KI Video, Charakterkonsistenz, 微鲤AI',
            og_title: 'KI Charakter zu Video - Interaktive Charaktervideos erstellen | 微鲤AI',
            og_description: 'Verwandle Ideen in interaktive Charaktervideos. Lade einen Charakter hoch oder wähle ihn aus und erzeuge realistische Bewegungen.',
            twitter_title: 'KI Charakter zu Video - Interaktive Charaktervideos | 微鲤AI',
            twitter_description: 'Generiere hochwertige Videos mit deinen Lieblingscharakteren. Lade hoch oder wähle auf 微鲤AI und erstelle interaktive KI-Videos.',
            page: {
                title1: 'Kostenloser KI Charakter→Video Generator',
                title2: 'Erwecke deine Lieblingscharaktere zum Leben! Lade ein Foto hoch oder wähle aus der 微鲤AI-Bibliothek und erstelle beeindruckende interaktive Videos. Beschreibe die Szene im Prompt – fertig.',
                consistency: 'Führende Charakterkonsistenz: Unsere KI hält Merkmale und Look über die gesamte Videosequenz stabil.',
                interactive: 'Erstelle sinnvolle Interaktionen – vom Spaziergang bis zum Gespräch. Die Möglichkeiten sind grenzenlos.',
                faq: [
                    {
                        question: 'Wie erstelle ich ein Video mit einem bestimmten Charakter?',
                        answer: 'Lade ein Charakterfoto hoch oder wähle einen Charakter auf 微鲤AI. Gib dann einen Prompt mit Szene/Interaktion ein und generiere das Video.',
                    },
                    {
                        question: 'Kann ich jedes Charakterfoto verwenden?',
                        answer: 'Ja, sofern du die Rechte daran hast. Die KI animiert den Charakter gemäß deinen Anweisungen.',
                    },
                    {
                        question: 'Gibt es ein Limit für die Videolänge?',
                        answer: 'Je nach Modell und Abo typischerweise 5–10 Sekunden.',
                    },
                    {
                        question: 'Wie bleibt der Charakter konsistent?',
                        answer: 'Wir analysieren das Referenzbild und bewahren die visuellen Merkmale über alle Frames hinweg.',
                    },
                    {
                        question: 'Ist es kostenlos testbar?',
                        answer: 'Ja, du kannst mit täglichen Gratis-Credits Charaktervideos erstellen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Was ist 微鲤AI Charakter zu Video?',
                    answer: 'Ein fortschrittliches Tool, das Videos mit einem bestimmten Charakter erzeugt. Lade ein Foto hoch oder wähle aus der Bibliothek für interaktive Inhalte.',
                },
                {
                    question: 'Wie funktioniert Charakterkonsistenz im Video?',
                    answer: 'Die KI hält Aussehen und Erkennbarkeit stabil, indem sie Charaktermerkmale aus dem Referenzbild über die Sequenz hinweg verfolgt.',
                },
                {
                    question: 'Kann ich ein Video von mir und einem Charakter zusammen erstellen?',
                    answer: 'Ja. Beschreibe die Interaktion im Prompt, und die KI generiert die Szene entsprechend.',
                },
                {
                    question: 'Welche Modelle werden verwendet?',
                    answer: 'Wir nutzen leistungsstarke Videomodelle wie Kling und Google Veo, optimiert für Konsistenz und realistische Bewegung.',
                },
                {
                    question: 'Wie lang kann das Video maximal sein?',
                    answer: 'Je nach Plan typischerweise 5–10 Sekunden in hoher Qualität.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Mit Freunden teilen | 微鲤AI',
            description: 'Teile mit Freunden, lade Freunde ein, sich bei 微鲤AI zu registrieren, und du und deine Freunde erhalten Belohnungen.',
            keywords: 'social back, mit Freunden teilen, Freunde zu 微鲤AI einladen, Belohnungen erhalten, 微鲤AI',
        },
    },
    ru: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI — это универсальная платформа на основе ИИ для создания видео и изображений. Генерируйте визуальный контент высокого качества из текста, изображений или видео — просто и быстро.',
        home: {
            title: '微鲤AI — бесплатный генератор AI-видео и инструменты для изображений (Kling, Flux, Veo)',
            description: 'Хватит платить за множество подписок. Получите доступ к лучшим AI-моделям мира — Kling AI, Google Veo, Sora и Flux — в одном бесплатном дашборде. Создавайте профессиональные видео, делайте face swap и улучшайте качество в один клик.',
            ogDescription: 'Создавайте потрясающие видео с Kling и Flux. Text-to-Video, Face Swap и Upscaling. Попробуйте бесплатно.',
            keywords: 'генератор видео с ИИ, генератор изображений с ИИ, текст в видео, изображение в видео, создание видео с ИИ, создание изображений с ИИ, генерация контента с ИИ, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'AI-креативная платформа-агрегатор топ-моделей Kling AI, Google Veo, Sora и Flux. Функции: Text-to-Video, Face Swap, Upscaling.',
            software_feature: 'Интеграция Kling AI, Текст в видео, AI Face Swap, 4K видео апскейлер, Изображение в видео, Липсинк, Удаление фона',
            og_title: '微鲤AI — универсальная AI-креативная платформа',
            og_description: 'Создавайте потрясающие видео с Kling и Flux. Text-to-Video, Face Swap и Upscaling. Попробуйте бесплатно.',
            twitter_title: '微鲤AI — бесплатный генератор AI-видео',
            twitter_description: 'Kling, Veo и Flux в одном месте. Создавайте AI-видео и AI-арт мгновенно.',
            faq: [
                {
                    question: 'Почему 微鲤AI лучше, чем использовать модели по отдельности?',
                    answer: '微鲤AI работает как агрегатор. Вместо отдельных подписок на Kling, Midjourney или Runway вы получаете доступ к топовым моделям (Kling 2.5, Flux Pro, Google Veo) в одном дашборде. Это экономит деньги и упрощает рабочий процесс.',
                },
                {
                    question: '微鲤AI действительно бесплатен?',
                    answer: 'Да. Мы даём щедрые ежедневные бесплатные кредиты, чтобы вы могли протестировать Text-to-Video, Face Swap и генератор изображений. Банковская карта не нужна. Для интенсивного использования и скачивания без водяных знаков доступны гибкие платные планы.',
                },
                {
                    question: 'Могу ли я использовать Kling AI и Flux на платформе?',
                    answer: 'Конечно. 微鲤AI интегрирует последние версии Kling (реалистичное видео), Flux (высокая детализация изображений) и Google Veo. Мы регулярно обновляем библиотеку моделей, чтобы вы всегда были на передовой.',
                },
                {
                    question: 'Как улучшить видео низкого качества?',
                    answer: 'Используйте наш AI Video Upscaler. Он автоматически уменьшает шум/размытие и повышает разрешение до 4K. Отлично подходит для восстановления старых семейных видео и улучшения роликов для соцсетей.',
                },
                {
                    question: 'Принадлежат ли мне коммерческие права на мои работы?',
                    answer: 'Если у вас платный план — да. Вы получаете полные коммерческие права на все материалы, созданные в 微鲤AI, что безопасно для монетизации на YouTube, работы с клиентами и маркетинговых кампаний.',
                },
            ],
        },
        homePage: {
            title: 'Главная | 微鲤AI',
            description: 'Создавайте потрясающие видео и изображения с помощью ИИ. Превратите текст, фото или видео в качественный визуальный контент.',
            keywords: 'генератор видео с ИИ, генератор изображений с ИИ, текст в видео, изображение в видео, создание видео с ИИ, создание изображений с ИИ, генерация контента с ИИ, 微鲤AI',
        },
        aiTools: {
            title: 'Наборы инструментов редактора — коллекция лучших ИИ‑инструментов | 微鲤AI',
            description: 'Исследуйте все лучшие коллекции инструментов ИИ для генерации видео и изображений. Создавайте потрясающие видео и изображения с помощью передовой технологии ИИ.',
            keywords: 'AI инструменты, инструменты генерации видео, инструменты генерации изображений, инструменты ИИ для видео, инструменты ИИ для изображений, 微鲤AI',
        },
        myCreations: {
            title: 'Мои Creations | 微鲤AI',
            description: 'Посмотрите все свои Creations, включая видео и изображения. Управляйте своими Creations с помощью 微鲤AI, чтобы создавать высококачественный визуальный контент.',
            keywords: 'мои creations, creations видео, creations изображения, creations управление, 微鲤AI',
        },
        aiImage: {
            title: 'Генератор Изображений с ИИ - Создавайте Потрясающие Изображения с ИИ | 微鲤AI',
            description: 'Создавайте профессиональные изображения, сгенерированные ИИ, с 微鲤AI. Преобразуйте текст в изображение, генерируйте креативные визуальные эффекты и воплощайте свое воображение в жизнь с помощью передовой технологии ИИ.',
            keywords: 'генератор изображений ИИ, текст в изображение, искусство ИИ, создание изображений, фото ИИ, генератор цифрового искусства',
        },
        aiVideo: {
            title: 'Генератор Видео с ИИ - Создавайте Удивительные Видео с ИИ | 微鲤AI',
            description: 'Генерируйте потрясающие видео с ИИ с помощью 微鲤AI. Создавайте видео из текста, изображений или видео с помощью передовых моделей ИИ, таких как Sora, Veo и других.',
            keywords: 'генератор видео ИИ, текст в видео, создание видео, видео ИИ, генерация видео, Sora, Veo',
        },
        aiMusic: {
            title: 'Генератор Музыки с ИИ - Вокал и Инструментал | 微鲤AI',
            description: 'Создавайте музыку с ИИ за секунды на 微鲤AI: вокальные песни и инструменталы, стили поп, рок, электроника, джаз и ремиксы популярных работ сообщества в один клик.',
            keywords: 'генератор музыки ИИ, генератор музыки ИИ бесплатно, генератор музыки ИИ с вокалом, генератор вокальных песен, генератор инструментальной музыки, текст в музыку, создать похожую музыку, ремикс музыки ИИ, музыкальные стили, музыка без авторских прав, 微鲤AI',
        },
        pricing: {
            title: 'Цены и Планы - Доступное Создание Видео и Изображений с ИИ | 微鲤AI',
            description: 'Выберите идеальный план для ваших нужд. Гибкие цены на генерацию видео и изображений с ИИ с 微鲤AI. Доступна бесплатная пробная версия.',
            keywords: 'цены ИИ, цены генерации видео, цены генерации изображений, планы подписки',
        },
        faq: {
            title: 'Часто Задаваемые Вопросы - Центр Помощи 微鲤AI',
            description: 'Найдите ответы на распространенные вопросы о платформе генерации видео и изображений с ИИ 微鲤AI. Получите помощь по функциям, ценам и многому другому.',
            keywords: 'FAQ ИИ, помощь 微鲤AI, помощь генерации видео, руководство генерации изображений',
        },
        aboutUs: {
            title: 'О Нас - Платформа Создания с ИИ 微鲤AI',
            description: 'Узнайте о 微鲤AI, ведущей платформе создания видео и изображений с ИИ. Откройте для себя нашу миссию по демократизации создания контента с ИИ.',
            keywords: 'о 微鲤AI, платформа ИИ, информация о компании, технология ИИ',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'Модели Видео ИИ - Veo, Sora, Kling AI и Другие | 微鲤AI',
            description: 'Исследуйте нашу коллекцию передовых моделей генерации видео ИИ, включая Veo 3.1, Sora 2, Kling AI, Runway и другие. Создавайте потрясающие видео с помощью передовой технологии ИИ.',
            keywords: 'модели видео ИИ, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, модели генерации видео, технология видео ИИ',
        },
        imageModels: {
            title: 'Модели Изображений ИИ - FLUX, Nano Banana, Imagen и Другие | 微鲤AI',
            description: 'Исследуйте нашу коллекцию передовых моделей генерации изображений ИИ, включая FLUX, Nano Banana, Imagen, GPT-4o и другие. Создавайте профессиональные изображения с помощью современных моделей ИИ.',
            keywords: 'модели изображений ИИ, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, модели генерации изображений, технология изображений ИИ',
        },
        ugcDetailImage: {
            title: 'Бесплатный ИИ-генератор изображений | Создайте своё | 微鲤AI',
            description: 'Посмотрите это потрясающее изображение, созданное ИИ, и создайте своё бесплатно! Мощный ИИ-генератор 微鲤AI превращает ваши идеи в потрясающие визуалы за секунды. Попробуйте сейчас!',
            keywords: 'ИИ-генератор изображений, бесплатное ИИ-искусство, изображение созданное ИИ, текст в изображение, создать ИИ-изображения, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Бесплатный ИИ-генератор видео | Создайте своё | 微鲤AI',
            description: 'Посмотрите это потрясающее видео, созданное ИИ, и создайте своё бесплатно! Мощный ИИ-генератор 微鲤AI превращает ваши идеи в потрясающие видео за секунды. Попробуйте сейчас!',
            keywords: 'ИИ-генератор видео, бесплатное ИИ-видео, видео созданное ИИ, текст в видео, создать ИИ-видео, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Бесплатный ИИ-генератор музыки | Создайте свою | 微鲤AI',
            description: 'Послушайте эту потрясающую музыку, созданную ИИ, и создайте свою бесплатно! Мощный ИИ-генератор музыки 微鲤AI превращает ваши идеи в уникальные песни за секунды. Попробуйте сейчас!',
            keywords: 'ИИ-генератор музыки, бесплатная ИИ-музыка, музыка созданная ИИ, текст в музыку, создать ИИ-песни, бесплатная музыка, 微鲤AI',
            og_title: 'Бесплатный ИИ-генератор музыки | Создайте свою | 微鲤AI',
            og_description: 'Послушайте эту потрясающую музыку, созданную ИИ, и создайте свою бесплатно! Мощный ИИ-генератор музыки 微鲤AI превращает ваши идеи в уникальные песни за секунды.',
            twitter_title: 'Бесплатный ИИ-генератор музыки | 微鲤AI',
            twitter_description: 'Послушайте музыку, созданную ИИ, и создайте свою бесплатно!',
        },
        characters: {
            title: 'Персонажи ИИ - Общайтесь с Персонажами ИИ и Виртуальными Компаньонами | 微鲤AI',
            description: 'Общайтесь с тысячами персонажей ИИ на 微鲤AI. Откройте для себя аниме-персонажей, виртуальных компаньонов и интерактивные личности ИИ. Начните бесплатные разговоры с персонажами ИИ.',
            keywords: 'персонажи ИИ, чат ИИ, виртуальные компаньоны, аниме-персонажи, личность ИИ, чат персонажей, разговор ИИ, виртуальные друзья, 微鲤AI',
            og_title: 'Персонажи ИИ - Общайтесь с Персонажами ИИ и Виртуальными Компаньонами | 微鲤AI',
            og_description: 'Исследуйте тысячи персонажей ИИ и начинайте содержательные разговоры. Бесплатно общайтесь с аниме-персонажами, виртуальными компаньонами и интерактивными личностями ИИ.',
            twitter_title: 'Персонажи ИИ - Общайтесь с Персонажами ИИ | 微鲤AI',
            twitter_description: 'Откройте и общайтесь с тысячами персонажей ИИ. Аниме-персонажи, виртуальные компаньоны и интерактивные личности—все бесплатно на 微鲤AI.',
        },
        characterToImage: {
            title: 'ИИ-изображения персонажей — Создайте свои изображения персонажа | 微鲤AI',
            description: 'Выберите персонажа на 微鲤AI, введите промпт и нажмите «Сгенерировать», чтобы создать свои изображения персонажа.',
            keywords: 'ИИ изображения персонажей, ИИ персонаж, генератор изображений персонажа, изображения персонажа, 微鲤AI',
            og_title: 'ИИ-изображения персонажей — Создайте свои изображения персонажа | 微鲤AI',
            og_description: 'Выберите персонажа на 微鲤AI, введите промпт и нажмите «Сгенерировать», чтобы создать свои изображения персонажа.',
            twitter_title: 'ИИ-изображения персонажей — Создайте свои изображения персонажа | 微鲤AI',
            twitter_description: 'Выберите персонажа на 微鲤AI, введите промпт и нажмите «Сгенерировать», чтобы создать свои изображения персонажа.',
        },
        characterToVideo: {
            title: 'ИИ Персонаж в видео — Интерактивные видео с персонажами | 微鲤AI',
            description: 'Создавайте впечатляющие видео с любым ИИ‑персонажем. Загрузите фото персонажа или выберите его на 微鲤AI, чтобы сгенерировать интерактивное видео с вами и персонажем.',
            keywords: 'персонаж в видео ИИ, генератор видео с персонажем, интерактивное ИИ видео, консистентность персонажа, 微鲤AI',
            og_title: 'ИИ Персонаж в видео — Интерактивные видео с персонажами | 微鲤AI',
            og_description: 'Превратите идеи в интерактивные видео с персонажами. Загрузите или выберите персонажа и получите реалистичное движение.',
            twitter_title: 'ИИ Персонаж в видео — Создавайте интерактивные видео | 微鲤AI',
            twitter_description: 'Генерируйте высококачественные видео с любимыми персонажами. Загрузите или выберите персонажа на 微鲤AI и создавайте интерактивные сцены.',
            page: {
                title1: 'Бесплатный генератор «Персонаж→Видео»',
                title2: 'Оживите любимых персонажей! Загрузите фото или выберите персонажа из библиотеки 微鲤AI и создайте впечатляющее интерактивное видео. Опишите сцену в промпте — и смотрите результат.',
                consistency: 'Лидирующая консистентность персонажа: ИИ сохраняет уникальные черты и внешний вид на протяжении всей последовательности.',
                interactive: 'Создавайте осмысленные взаимодействия — прогулка, разговор и многое другое. Возможности сторителлинга безграничны.',
                faq: [
                    {
                        question: 'Как создать видео с конкретным персонажем?',
                        answer: 'Загрузите фото персонажа или выберите его на 微鲤AI, затем введите промпт со сценой/взаимодействием и запустите генерацию.',
                    },
                    {
                        question: 'Можно ли использовать любое фото персонажа?',
                        answer: 'Да, если у вас есть права на использование. ИИ анимирует персонажа по вашим указаниям.',
                    },
                    {
                        question: 'Есть ли ограничение по длительности?',
                        answer: 'Зависит от модели и тарифа, обычно 5–10 секунд.',
                    },
                    {
                        question: 'Как сохранить внешность персонажа стабильной?',
                        answer: 'Мы анализируем референс и поддерживаем стабильные визуальные признаки на всех кадрах.',
                    },
                    {
                        question: 'Можно попробовать бесплатно?',
                        answer: 'Да, используйте ежедневные бесплатные кредиты для генерации.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Что такое 微鲤AI «Персонаж в видео»?',
                    answer: 'Это продвинутый инструмент, который генерирует видео с конкретным персонажем. Загрузите фото или выберите из библиотеки и создавайте интерактивный контент.',
                },
                {
                    question: 'Как работает консистентность персонажа в видео?',
                    answer: 'ИИ использует референс‑изображение и отслеживает черты, чтобы персонаж оставался узнаваемым на протяжении всего клипа.',
                },
                {
                    question: 'Можно ли сделать видео, где я и персонаж вместе?',
                    answer: 'Да. Опишите взаимодействие в промпте, и ИИ создаст соответствующую сцену.',
                },
                {
                    question: 'Какие модели используются?',
                    answer: 'Мы используем мощные видео‑модели, такие как Kling и Google Veo, оптимизированные под реалистичное движение и консистентность.',
                },
                {
                    question: 'Какая максимальная длительность?',
                    answer: 'В зависимости от тарифа обычно 5–10 секунд в высоком качестве.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Поделитесь с друзьями | 微鲤AI',
            description: 'Поделитесь с друзьями, пригласите друзей зарегистрироваться в 微鲤AI, и вы, и ваши друзья получите награды.',
            keywords: 'social back, поделиться с друзьями, пригласить друзей в 微鲤AI, получить награды, 微鲤AI',
        },
    },
    pt: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI é uma plataforma completa de criação de vídeos e imagens com IA que permite transformar texto, imagens ou vídeos em conteúdo visual de alta qualidade, em segundos.',
        home: {
            title: '微鲤AI - Gerador de Vídeo com IA Gratuito e Ferramentas de Imagem (Kling, Flux, Veo)',
            description: 'Pare de alternar entre assinaturas. Acesse os melhores modelos de IA do mundo—Kling AI, Google Veo, Sora e Flux—em um painel gratuito. Crie vídeos profissionais, faça troca de rosto e aumente a qualidade instantaneamente.',
            ogDescription: 'Gere vídeos incríveis com Kling & Flux. Text-to-Video, Face Swap e Upscaling. Experimente grátis.',
            keywords: 'gerador de vídeos com IA, gerador de imagens com IA, texto para vídeo, imagem para vídeo, criação de vídeos com IA, criação de imagens com IA, IA generativa, conteúdo visual com IA, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'Plataforma criativa com IA que agrega modelos de ponta como Kling AI, Google Veo, Sora e Flux. Inclui Text-to-Video, Face Swap e Upscaling.',
            software_feature: 'Integração Kling AI, Texto para vídeo, Face Swap com IA, Upscaler de vídeo 4K, Imagem para vídeo, Lip Sync, Remoção de fundo',
            og_title: '微鲤AI - A Plataforma Criativa Tudo-em-Um',
            og_description: 'Gere vídeos incríveis com Kling & Flux. Text-to-Video, Face Swap e Upscaling. Experimente grátis.',
            twitter_title: '微鲤AI - Gerador de Vídeo com IA Gratuito',
            twitter_description: 'Acesse Kling, Veo e Flux em um só lugar. Gere vídeo e arte com IA instantaneamente.',
            faq: [
                {
                    question: 'Por que o 微鲤AI é melhor do que usar os modelos separadamente?',
                    answer: 'O 微鲤AI atua como um agregador. Em vez de pagar assinaturas separadas para Kling, Midjourney ou Runway, você acessa modelos de ponta (Kling 2.5, Flux Pro, Google Veo) em um único painel. Isso economiza dinheiro e simplifica seu fluxo de trabalho.',
                },
                {
                    question: 'O 微鲤AI é realmente gratuito?',
                    answer: 'Sim. Oferecemos créditos diários gratuitos generosos para você testar Text-to-Video, Face Swap e o Gerador de Imagens. Não é necessário cartão de crédito para começar. Para uso intenso e downloads sem marca d’água, há planos pagos flexíveis.',
                },
                {
                    question: 'Posso usar Kling AI e Flux nesta plataforma?',
                    answer: 'Com certeza. O 微鲤AI integra as versões mais recentes do Kling (vídeos realistas), Flux (imagens de alta fidelidade) e Google Veo. Atualizamos nossa biblioteca com frequência para manter você na vanguarda.',
                },
                {
                    question: 'Como melhorar vídeos de baixa qualidade?',
                    answer: 'Use nosso AI Video Upscaler. Ele remove ruído/desfoque e faz upscale automaticamente até 4K. Perfeito para restaurar vídeos antigos de família ou melhorar clipes para redes sociais.',
                },
                {
                    question: 'Eu possuo os direitos comerciais das minhas criações?',
                    answer: 'Se você estiver em um plano pago, sim. Você possui direitos comerciais completos sobre os ativos gerados no 微鲤AI, seguros para monetização no YouTube, trabalhos com clientes e campanhas de marketing.',
                },
            ],
        },
        homePage: {
            title: 'Página Inicial | 微鲤AI',
            description: 'Crie vídeos e imagens com IA de forma simples e gratuita. Transforme texto, imagens ou vídeos em conteúdo visual de alta resolução com 微鲤AI.',
            keywords: 'gerador de vídeos com IA, gerador de imagens com IA, texto para vídeo, imagem para vídeo, criação de vídeos com IA, criação de imagens com IA, IA generativa, conteúdo visual com IA, 微鲤AI',
        },
        aiTools: {
            title: 'Kits de edição - Coleção das melhores ferramentas de IA | 微鲤AI',
            description: 'Explore nossa coleção de ferramentas AI de alta qualidade para a geração de vídeos e imagens. Crie vídeos e imagens impressionantes com tecnologia AI de ponta.',
            keywords: 'ferramentas AI, ferramentas de geração de vídeos, ferramentas de geração de imagens, ferramentas AI para vídeos, ferramentas AI para imagens, 微鲤AI',
        },
        myCreations: {
            title: 'Minhas Creations | 微鲤AI',
            description: 'Veja todas suas Creations, incluindo vídeos e imagens. Gerencie suas Creations usando 微鲤AI para criar conteúdo visual de alta qualidade.',
            keywords: 'minhas creations, creations de vídeos, creations de imagens, gerenciamento de creations, 微鲤AI',
        },
        aiImage: {
            title: 'Gerador de Imagens com IA - Crie Imagens Deslumbrantes com IA | 微鲤AI',
            description: 'Crie imagens profissionais geradas por IA com 微鲤AI. Transforme texto em imagem, gere visuais criativos e dê vida à sua imaginação com tecnologia IA avançada.',
            keywords: 'gerador de imagens IA, texto para imagem, arte IA, criação de imagens, fotos IA, gerador de arte digital',
        },
        aiVideo: {
            title: 'Gerador de Vídeos com IA - Crie Vídeos Incríveis com IA | 微鲤AI',
            description: 'Gere vídeos impressionantes com IA usando 微鲤AI. Crie vídeos a partir de texto, imagens ou vídeos com modelos de IA de ponta como Sora, Veo e mais.',
            keywords: 'gerador de vídeos IA, texto para vídeo, criação de vídeos, vídeos IA, geração de vídeos, Sora, Veo',
        },
        aiMusic: {
            title: 'Gerador de Música com IA - Vocal e Instrumental | 微鲤AI',
            description: 'Crie música com IA em segundos na 微鲤AI: gere músicas com voz ou instrumentais, explore estilos como pop, rock, eletrônico e jazz, e faça remix de criações da comunidade com um clique.',
            keywords: 'gerador de música com IA, gerador de música com IA grátis, gerador de música com IA com voz, gerador de músicas vocais, gerador de música instrumental, texto para música, criar música similar, remix música IA, estilos musicais, música sem direitos autorais, 微鲤AI',
        },
        pricing: {
            title: 'Preços e Planos - Criação de Vídeos e Imagens com IA Acessível | 微鲤AI',
            description: 'Escolha o plano perfeito para suas necessidades. Preços flexíveis para geração de vídeos e imagens com IA com 微鲤AI. Teste gratuito disponível.',
            keywords: 'preços IA, preços geração vídeos, preços geração imagens, planos assinatura',
        },
        faq: {
            title: 'Perguntas Frequentes - Centro de Ajuda 微鲤AI',
            description: 'Encontre respostas para perguntas comuns sobre a plataforma de geração de vídeos e imagens com IA da 微鲤AI. Obtenha ajuda com recursos, preços e mais.',
            keywords: 'perguntas frequentes IA, ajuda 微鲤AI, ajuda geração vídeos, guia geração imagens',
        },
        aboutUs: {
            title: 'Sobre Nós - Plataforma de Criação com IA 微鲤AI',
            description: 'Conheça a 微鲤AI, a plataforma líder de criação de vídeos e imagens com IA. Descubra nossa missão de democratizar a criação de conteúdo com IA.',
            keywords: 'sobre 微鲤AI, plataforma IA, informações empresa, tecnologia IA',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'Modelos de Vídeo IA - Veo, Sora, Kling AI e Mais | 微鲤AI',
            description: 'Explore nossa coleção de modelos avançados de geração de vídeo IA, incluindo Veo 3.1, Sora 2, Kling AI, Runway e mais. Crie vídeos impressionantes com tecnologia IA de ponta.',
            keywords: 'modelos de vídeo IA, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, modelos geração vídeo, tecnologia vídeo IA',
        },
        imageModels: {
            title: 'Modelos de Imagem IA - FLUX, Nano Banana, Imagen e Mais | 微鲤AI',
            description: 'Explore nossa coleção de modelos avançados de geração de imagem IA, incluindo FLUX, Nano Banana, Imagen, GPT-4o e mais. Crie imagens profissionais com modelos IA de última geração.',
            keywords: 'modelos de imagem IA, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, modelos geração imagem, tecnologia imagem IA',
        },
        ugcDetailImage: {
            title: 'Gerador de Imagens IA Grátis | Crie a Sua Própria | 微鲤AI',
            description: 'Confira esta incrível imagem gerada por IA e crie a sua própria gratuitamente! O poderoso gerador de IA da 微鲤AI transforma suas ideias em visuais impressionantes em segundos. Experimente agora!',
            keywords: 'gerador de imagens IA, arte IA grátis, imagem gerada por IA, texto para imagem, criar imagens IA, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Gerador de Vídeos IA Grátis | Crie o Seu Próprio | 微鲤AI',
            description: 'Confira este incrível vídeo gerado por IA e crie o seu próprio gratuitamente! O poderoso gerador de IA da 微鲤AI transforma suas ideias em vídeos impressionantes em segundos. Experimente agora!',
            keywords: 'gerador de vídeos IA, vídeo IA grátis, vídeo gerado por IA, texto para vídeo, criar vídeos IA, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Gerador de Música IA Grátis | Crie a Sua Própria Música | 微鲤AI',
            description: 'Ouça esta incrível música gerada por IA e crie a sua própria gratuitamente! O poderoso gerador de música IA da 微鲤AI transforma suas ideias em canções únicas em segundos. Experimente agora!',
            keywords: 'gerador de música IA, música IA grátis, música gerada por IA, texto para música, criar canções IA, música livre de royalties, 微鲤AI',
            og_title: 'Gerador de Música IA Grátis | Crie a Sua Própria Música | 微鲤AI',
            og_description: 'Ouça esta incrível música gerada por IA e crie a sua própria gratuitamente! O poderoso gerador de música IA da 微鲤AI transforma suas ideias em canções únicas em segundos.',
            twitter_title: 'Gerador de Música IA Grátis | 微鲤AI',
            twitter_description: 'Ouça música gerada por IA e crie a sua própria gratuitamente!',
        },
        characters: {
            title: 'Personagens IA - Converse com Personagens IA e Companheiros Virtuais | 微鲤AI',
            description: 'Converse com milhares de personagens IA no 微鲤AI. Descubra personagens de anime, companheiros virtuais e personalidades IA interativas. Comece conversas com personagens IA gratuitamente.',
            keywords: 'personagens IA, chat IA, companheiros virtuais, personagens anime, personalidade IA, chat de personagens, conversa IA, amigos virtuais, 微鲤AI',
            og_title: 'Personagens IA - Converse com Personagens IA e Companheiros Virtuais | 微鲤AI',
            og_description: 'Explore milhares de personagens IA e comece conversas significativas. Converse com personagens de anime, companheiros virtuais e personalidades IA interativas gratuitamente.',
            twitter_title: 'Personagens IA - Converse com Personagens IA | 微鲤AI',
            twitter_description: 'Descubra e converse com milhares de personagens IA. Personagens de anime, companheiros virtuais e personalidades interativas—tudo grátis no 微鲤AI.',
        },
        characterToImage: {
            title: 'Imagem de Personagem com IA - Crie suas Imagens de Personagem | 微鲤AI',
            description: 'Escolha seu personagem na 微鲤AI, digite um prompt e clique em Gerar para criar suas próprias imagens de personagem.',
            keywords: 'imagem de personagem com IA, personagem com IA, gerador de imagens de personagem, imagens de personagem, 微鲤AI',
            og_title: 'Imagem de Personagem com IA - Crie suas Imagens de Personagem | 微鲤AI',
            og_description: 'Escolha seu personagem na 微鲤AI, digite un prompt e clique em Gerar para criar suas próprias imagens de personagem.',
            twitter_title: 'Imagem de Personagem com IA - Crie suas Imagens de Personagem | 微鲤AI',
            twitter_description: 'Escolha seu personagem na 微鲤AI, digite un prompt e clique em Gerar para criar suas próprias imagens de personagem.',
        },
        characterToVideo: {
            title: 'IA Personagem para Vídeo - Gere vídeos interativos | 微鲤AI',
            description: 'Crie vídeos incríveis com qualquer personagem de IA. Envie fotos do personagem ou selecione na 微鲤AI para gerar vídeos interativos com você e o personagem.',
            keywords: 'personagem para vídeo IA, gerador de vídeo de personagem, vídeo IA interativo, consistência de personagem, 微鲤AI',
            og_title: 'IA Personagem para Vídeo - Gere vídeos interativos | 微鲤AI',
            og_description: 'Transforme suas ideias em vídeos interativos com personagens. Envie ou escolha personagens na 微鲤AI e gere movimento realista.',
            twitter_title: 'IA Personagem para Vídeo - Vídeos interativos | 微鲤AI',
            twitter_description: 'Gere vídeos de alta qualidade com seus personagens favoritos. Envie ou selecione na 微鲤AI e crie vídeos interativos.',
            page: {
                title1: 'Gerador grátis de Personagem→Vídeo com IA',
                title2: 'Dê vida aos seus personagens favoritos! Envie uma foto ou escolha na biblioteca da 微鲤AI e gere vídeos interativos incríveis. Descreva a cena no prompt e veja o resultado cinematográfico.',
                consistency: 'Consistência de personagem líder: a IA mantém os traços e a aparência durante toda a sequência.',
                interactive: 'Crie interações significativas — caminhar juntos, conversar e muito mais. As possibilidades são infinitas.',
                faq: [
                    {
                        question: 'Como criar um vídeo com um personagem específico?',
                        answer: 'Envie uma foto do personagem ou selecione um na 微鲤AI. Depois, escreva um prompt descrevendo a cena/ interação e gere.',
                    },
                    {
                        question: 'Posso usar qualquer foto de personagem?',
                        answer: 'Sim, desde que você tenha os direitos de uso. A IA animará o personagem conforme suas instruções.',
                    },
                    {
                        question: 'Há limite de duração?',
                        answer: 'Depende do modelo e do plano, normalmente de 5 a 10 segundos.',
                    },
                    {
                        question: 'Como garantir que o personagem fique consistente?',
                        answer: 'Analisamos a imagem de referência e preservamos características visuais em todos os frames.',
                    },
                    {
                        question: 'Dá para testar grátis?',
                        answer: 'Sim, usando seus créditos diários gratuitos.',
                    },
                ],
            },
            faq: [
                {
                    question: 'O que é Personagem para Vídeo no 微鲤AI?',
                    answer: 'É uma ferramenta avançada que gera vídeos com um personagem específico. Envie uma foto ou escolha na biblioteca para criar conteúdo interativo.',
                },
                {
                    question: 'Como funciona a consistência no vídeo?',
                    answer: 'A IA mantém a aparência do personagem estável e reconhecível durante todo o clipe usando a imagem de referência.',
                },
                {
                    question: 'Posso criar um vídeo meu com um personagem?',
                    answer: 'Sim. Descreva a interação no prompt e a IA gera a cena correspondente.',
                },
                {
                    question: 'Quais modelos são usados?',
                    answer: 'Usamos modelos de vídeo como Kling e Google Veo, otimizados para movimento realista e consistência.',
                },
                {
                    question: 'Qual a duração máxima?',
                    answer: 'Dependendo do plano, normalmente 5 a 10 segundos em alta definição.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Compartilhe com amigos | 微鲤AI',
            description: 'Compartilhe com amigos, convide amigos para se registrarem no 微鲤AI, e você e seus amigos receberão recompensas.',
            keywords: 'social back, compartilhar com amigos, convidar amigos para o 微鲤AI, receber recompensas, 微鲤AI',
        },
    },
    it: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI è una piattaforma completa per la creazione di video e immagini con intelligenza artificiale. Genera contenuti visivi professionali da testo, immagini o video in pochi secondi.',
        home: {
            title: '微鲤AI - Generatore Video IA Gratuito e Strumenti Immagine (Kling, Flux, Veo)',
            description: 'Basta passare da un abbonamento all’altro. Accedi ai migliori modelli di IA—Kling AI, Google Veo, Sora e Flux—in un’unica dashboard gratuita. Crea video professionali, fai face swap e migliora la qualità in un attimo.',
            ogDescription: 'Genera video straordinari con Kling & Flux. Text-to-Video, Face Swap e Upscaling. Provalo gratis.',
            keywords: 'generatore video IA, generatore immagini IA, testo in video, immagine in video, creazione video con IA, creazione immagini con IA, generazione contenuti IA, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'Piattaforma creativa basata su IA che funge da aggregatore di modelli top come Kling AI, Google Veo, Sora e Flux. Include Text-to-Video, Face Swap e Upscaling.',
            software_feature: 'Integrazione Kling AI, Testo in video, Face Swap IA, Upscaler video 4K, Immagine in video, Lip Sync, Rimozione sfondo',
            og_title: '微鲤AI - La Piattaforma Creativa All-in-One',
            og_description: 'Genera video straordinari con Kling & Flux. Text-to-Video, Face Swap e Upscaling. Provalo gratis.',
            twitter_title: '微鲤AI - Generatore Video IA Gratuito',
            twitter_description: 'Accedi a Kling, Veo e Flux in un solo posto. Genera video e arte IA all’istante.',
            faq: [
                {
                    question: 'Perché 微鲤AI è meglio che usare i modelli separatamente?',
                    answer: '微鲤AI è un aggregatore. Invece di pagare abbonamenti separati per Kling, Midjourney o Runway, hai accesso ai migliori modelli (Kling 2.5, Flux Pro, Google Veo) in un’unica dashboard. Risparmi e semplifichi il flusso di lavoro.',
                },
                {
                    question: '微鲤AI è davvero gratuito?',
                    answer: 'Sì. Offriamo generosi crediti giornalieri gratuiti per provare Text-to-Video, Face Swap e il Generatore di Immagini. Non serve carta di credito per iniziare. Per un uso intensivo e download senza watermark, sono disponibili piani a pagamento flessibili.',
                },
                {
                    question: 'Posso usare Kling AI e Flux su questa piattaforma?',
                    answer: 'Assolutamente. 微鲤AI integra le ultime versioni di Kling (video realistici), Flux (immagini ad alta fedeltà) e Google Veo. Aggiorniamo spesso la libreria dei modelli per offrirti sempre il meglio.',
                },
                {
                    question: 'Come posso migliorare video di bassa qualità?',
                    answer: 'Usa il nostro AI Video Upscaler. Riduce automaticamente rumore/sfocatura e aumenta la risoluzione fino al 4K. Perfetto per restaurare vecchi video di famiglia o migliorare clip per i social.',
                },
                {
                    question: 'Possiedo i diritti commerciali sulle mie creazioni?',
                    answer: 'Se sei su un piano a pagamento, sì. Hai pieni diritti commerciali su tutti gli asset generati su 微鲤AI, sicuri per monetizzazione YouTube, lavori per clienti e campagne marketing.',
                },
            ],
        },
        homePage: {
            title: 'Home | 微鲤AI',
            description: 'Genera contenuti visivi professionali da testo, immagini o video in pochi secondi usando 微鲤AI. Trasforma le tue idee in contenuti visivi straordinari.',
            keywords: 'generatore video IA, generatore immagini IA, testo in video, immagine in video, creazione video con IA, creazione immagini con IA, generazione contenuti IA, 微鲤AI',
        },
        aiTools: {
            title: 'Kit di editing - Collezione dei migliori strumenti di IA | 微鲤AI',
            description: `Esplora tutte le migliori collezioni di strumenti AI per la generazione di video e immagini. Crea video e immagini straordinari con tecnologia AI all'avanguardia.`,
            keywords: 'strumenti AI, strumenti di generazione video, strumenti di generazione immagini, strumenti AI per video, strumenti AI per immagini, 微鲤AI',
        },
        myCreations: {
            title: 'Le mie Creations | 微鲤AI',
            description: 'Guarda tutte le tue Creations, incluse video e immagini. Gestisci le tue Creations usando 微鲤AI per creare contenuto visivo di alta qualità.',
            keywords: 'le mie creations, creations di video, creations di immagini, gestione di creations, 微鲤AI',
        },
        aiImage: {
            title: `Generatore di Immagini IA - Crea Immagini Straordinarie con l'IA | 微鲤AI`,
            description: 'Crea immagini professionali generate da IA con 微鲤AI. Trasforma testo in immagine, genera visuali creative e dai vita alla tua immaginazione con tecnologia IA avanzata.',
            keywords: 'generatore immagini IA, testo a immagine, arte IA, creazione immagini, foto IA, generatore arte digitale',
        },
        aiVideo: {
            title: `Generatore di Video IA - Crea Video Straordinari con l'IA | 微鲤AI`,
            description: `Genera video impressionanti con IA usando 微鲤AI. Crea video da testo, immagini o video con modelli IA all'avanguardia come Sora, Veo e altri.`,
            keywords: 'generatore video IA, testo a video, creazione video, video IA, generazione video, Sora, Veo',
        },
        aiMusic: {
            title: 'Generatore di Musica IA - Vocal e Strumentale | 微鲤AI',
            description: 'Crea musica con IA in pochi secondi su 微鲤AI: brani vocali o strumentali, esplora pop, rock, elettronica, jazz e fai remix delle creazioni della community con un clic.',
            keywords: 'generatore di musica IA, generatore di musica IA gratuito, generatore di musica IA con voce, generatore di brani vocali, generatore di musica strumentale, testo in musica, creare musica simile, remix musica IA, stili musicali, musica royalty-free, 微鲤AI',
        },
        pricing: {
            title: 'Prezzi e Piani - Creazione di Video e Immagini con IA Accessibile | 微鲤AI',
            description: 'Scegli il piano perfetto per le tue esigenze. Prezzi flessibili per la generazione di video e immagini con IA con 微鲤AI. Prova gratuita disponibile.',
            keywords: 'prezzi IA, prezzi generazione video, prezzi generazione immagini, piani abbonamento',
        },
        faq: {
            title: 'Domande Frequenti - Centro Assistenza 微鲤AI',
            description: 'Trova risposte alle domande comuni sulla piattaforma di generazione di video e immagini con IA di 微鲤AI. Ottieni aiuto con funzionalità, prezzi e altro.',
            keywords: 'FAQ IA, aiuto 微鲤AI, aiuto generazione video, guida generazione immagini',
        },
        aboutUs: {
            title: 'Chi Siamo - Piattaforma di Creazione IA 微鲤AI',
            description: 'Scopri 微鲤AI, la piattaforma leader per la creazione di video e immagini con IA. Scopri la nostra missione di democratizzare la creazione di contenuti con IA.',
            keywords: 'chi siamo 微鲤AI, piattaforma IA, informazioni azienda, tecnologia IA',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'Modelli Video IA - Veo, Sora, Kling AI e Altri | 微鲤AI',
            description: `Esplora la nostra collezione di modelli avanzati di generazione video IA, tra cui Veo 3.1, Sora 2, Kling AI, Runway e altri. Crea video straordinari con tecnologia IA all'avanguardia.`,
            keywords: 'modelli video IA, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, modelli generazione video, tecnologia video IA',
        },
        imageModels: {
            title: 'Modelli Immagine IA - FLUX, Nano Banana, Imagen e Altri | 微鲤AI',
            description: `Esplora la nostra collezione di modelli avanzati di generazione immagine IA, tra cui FLUX, Nano Banana, Imagen, GPT-4o e altri. Crea immagini professionali con modelli IA all'avanguardia.`,
            keywords: 'modelli immagine IA, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, modelli generazione immagine, tecnologia immagine IA',
        },
        ugcDetailImage: {
            title: 'Generatore di Immagini IA Gratuito | Crea la Tua Opera | 微鲤AI',
            description: `Scopri questa incredibile immagine generata dall'IA e crea la tua gratuitamente! Il potente generatore IA di 微鲤AI trasforma le tue idee in straordinari visual in pochi secondi. Provalo ora!`,
            keywords: 'generatore immagini IA, arte IA gratuita, immagine generata da IA, testo in immagine, creare immagini IA, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Generatore di Video IA Gratuito | Crea la Tua Opera | 微鲤AI',
            description: `Scopri questo incredibile video generato dall'IA e crea il tuo gratuitamente! Il potente generatore IA di 微鲤AI trasforma le tue idee in straordinari video in pochi secondi. Provalo ora!`,
            keywords: 'generatore video IA, video IA gratuito, video generato da IA, testo in video, creare video IA, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Generatore di Musica IA Gratuito | Crea la Tua Musica | 微鲤AI',
            description: `Ascolta questa incredibile musica generata dall'IA e crea la tua gratuitamente! Il potente generatore di musica IA di 微鲤AI trasforma le tue idee in canzoni uniche in pochi secondi. Provalo ora!`,
            keywords: 'generatore musica IA, musica IA gratuita, musica generata da IA, testo in musica, creare canzoni IA, musica libera da diritti, 微鲤AI',
            og_title: 'Generatore di Musica IA Gratuito | Crea la Tua Musica | 微鲤AI',
            og_description: `Ascolta questa incredibile musica generata dall'IA e crea la tua gratuitamente! Il potente generatore di musica IA di 微鲤AI trasforma le tue idee in canzoni uniche in pochi secondi.`,
            twitter_title: 'Generatore di Musica IA Gratuito | 微鲤AI',
            twitter_description: `Ascolta musica generata dall'IA e crea la tua gratuitamente!`,
        },
        characters: {
            title: 'Personaggi IA - Chatta con Personaggi IA e Compagni Virtuali | 微鲤AI',
            description: 'Chatta con migliaia di personaggi IA su 微鲤AI. Scopri personaggi anime, compagni virtuali e personalità IA interattive. Inizia conversazioni con personaggi IA gratuitamente.',
            keywords: 'personaggi IA, chat IA, compagni virtuali, personaggi anime, personalità IA, chat personaggi, conversazione IA, amici virtuali, 微鲤AI',
            og_title: 'Personaggi IA - Chatta con Personaggi IA e Compagni Virtuali | 微鲤AI',
            og_description: 'Esplora migliaia di personaggi IA e inizia conversazioni significative. Chatta gratuitamente con personaggi anime, compagni virtuali e personalità IA interattive.',
            twitter_title: 'Personaggi IA - Chatta con Personaggi IA | 微鲤AI',
            twitter_description: 'Scopri e chatta con migliaia di personaggi IA. Personaggi anime, compagni virtuali e personalità interattive—tutto gratuito su 微鲤AI.',
        },
        characterToImage: {
            title: 'Immagini Personaggio AI - Crea le tue immagini del personaggio | 微鲤AI',
            description: 'Scegli il tuo personaggio su 微鲤AI, inserisci un prompt e fai clic su Genera per creare le tue immagini del personaggio.',
            keywords: 'immagini personaggio AI, personaggio AI, generatore immagini del personaggio, immagini del personaggio, 微鲤AI',
            og_title: 'Immagini Personaggio AI - Crea le tue immagini del personaggio | 微鲤AI',
            og_description: 'Scegli il tuo personaggio su 微鲤AI, inserisci un prompt e fai clic su Genera per creare le tue immagini del personaggio.',
            twitter_title: 'Immagini Personaggio AI - Crea le tue immagini del personaggio | 微鲤AI',
            twitter_description: 'Scegli il tuo personaggio su 微鲤AI, inserisci un prompt e fai clic su Genera per creare le tue immagini del personaggio.',
        },
        characterToVideo: {
            title: 'IA Personaggio in Video - Crea video interattivi con personaggi | 微鲤AI',
            description: 'Crea video incredibili con qualsiasi personaggio IA. Carica foto del personaggio o selezionalo su 微鲤AI per generare video interattivi con te e il personaggio.',
            keywords: 'personaggio in video IA, generatore video personaggio, video IA interattivo, coerenza del personaggio, 微鲤AI',
            og_title: 'IA Personaggio in Video - Crea video interattivi con personaggi | 微鲤AI',
            og_description: 'Trasforma le tue idee in video interattivi con personaggi IA. Carica o scegli un personaggio su 微鲤AI e genera movimenti realistici.',
            twitter_title: 'IA Personaggio in Video - Video interattivi con personaggi | 微鲤AI',
            twitter_description: 'Genera video di alta qualità con i tuoi personaggi preferiti. Carica o scegli su 微鲤AI per creare video IA interattivi.',
            page: {
                title1: 'Generatore gratuito Personaggio→Video con IA',
                title2: 'Dai vita ai tuoi personaggi preferiti! Carica una foto o scegli dalla libreria 微鲤AI e genera video interattivi straordinari. Descrivi la scena nel prompt e guarda il risultato.',
                consistency: 'Coerenza del personaggio di livello top: la nostra IA mantiene tratti e aspetto durante l’intera sequenza.',
                interactive: 'Crea interazioni significative: passeggiare insieme, conversare e molto altro. Le possibilità sono infinite.',
                faq: [
                    {
                        question: 'Come creo un video con un personaggio specifico?',
                        answer: 'Carica una foto del personaggio o scegline uno su 微鲤AI. Poi inserisci un prompt che descriva la scena o l’interazione e genera.',
                    },
                    {
                        question: 'Posso usare qualsiasi foto di personaggio?',
                        answer: 'Sì, se hai i diritti di utilizzo. L’IA animerà il personaggio secondo le tue istruzioni.',
                    },
                    {
                        question: 'C’è un limite di durata?',
                        answer: 'Dipende dal modello e dal tuo piano, in genere 5–10 secondi.',
                    },
                    {
                        question: 'Come faccio a mantenere il personaggio coerente?',
                        answer: 'Analizziamo l’immagine di riferimento e manteniamo caratteristiche stabili in tutti i frame.',
                    },
                    {
                        question: 'Posso provarlo gratis?',
                        answer: 'Sì, usando i crediti gratuiti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Che cos’è Personaggio in Video su 微鲤AI?',
                    answer: 'È uno strumento avanzato che genera video con un personaggio specifico. Carica una foto o scegli dalla libreria per creare contenuti interattivi.',
                },
                {
                    question: 'Come funziona la coerenza del personaggio nel video?',
                    answer: 'L’IA usa l’immagine di riferimento per mantenere l’aspetto stabile e riconoscibile per tutta la durata del clip.',
                },
                {
                    question: 'Posso creare un video di me con un personaggio?',
                    answer: 'Sì. Descrivi l’interazione nel prompt e l’IA genererà la scena corrispondente.',
                },
                {
                    question: 'Quali modelli vengono usati?',
                    answer: 'Usiamo modelli video performanti come Kling e Google Veo, ottimizzati per movimento realistico e coerenza.',
                },
                {
                    question: 'Qual è la durata massima?',
                    answer: 'A seconda del piano, in genere 5–10 secondi in alta qualità.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Condividi con gli amici | 微鲤AI',
            description: 'Condividi con gli amici, invita gli amici a registrarsi su 微鲤AI, tu e i tuoi amici riceverete premi.',
            keywords: 'social back, condividi con gli amici, invita amici su 微鲤AI, ricevi premi, 微鲤AI',
        },
    },
    ar: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI هي منصة شاملة لإنشاء الفيديوهات والصور بالذكاء الاصطناعي. يمكنك توليد محتوى مرئي عالي الجودة من النصوص أو الصور أو الفيديوهات بسهولة وسرعة.',
        home: {
            title: '微鲤AI - مولد فيديو بالذكاء الاصطناعي مجانًا وأدوات صور (Kling, Flux, Veo)',
            description: 'توقف عن التنقل بين الاشتراكات. احصل على أفضل نماذج الذكاء الاصطناعي—Kling AI وGoogle Veo وSora وFlux—في لوحة تحكم مجانية واحدة. أنشئ فيديوهات احترافية وبدّل الوجوه وحسّن الجودة فورًا.',
            ogDescription: 'أنشئ فيديوهات مذهلة باستخدام Kling وFlux. تحويل نص إلى فيديو، تبديل الوجوه، ورفع الدقة. جرّبه مجانًا.',
            keywords: 'مولد فيديو بالذكاء الاصطناعي, مولد صور بالذكاء الاصطناعي, تحويل نص إلى فيديو, تحويل صورة إلى فيديو, إنشاء فيديوهات بالذكاء الاصطناعي, إنشاء صور بالذكاء الاصطناعي, محتوى مرئي بالذكاء الاصطناعي, Kling, Flux, Veo, 微鲤AI',
            software_desc: 'منصة إبداعية مدعومة بالذكاء الاصطناعي تعمل كمُجمِّع لأفضل النماذج مثل Kling AI وGoogle Veo وSora وFlux. تشمل: تحويل النص إلى فيديو، تبديل الوجوه، ورفع الدقة.',
            software_feature: 'تكامل Kling AI، تحويل النص إلى فيديو، تبديل الوجوه بالذكاء الاصطناعي، رافع دقة فيديو 4K، تحويل صورة إلى فيديو، مزامنة الشفاه، إزالة الخلفية',
            og_title: '微鲤AI - منصة إبداعية شاملة',
            og_description: 'أنشئ فيديوهات مذهلة باستخدام Kling وFlux. تحويل نص إلى فيديو، تبديل الوجوه، ورفع الدقة. جرّبه مجانًا.',
            twitter_title: '微鲤AI - مولد فيديو بالذكاء الاصطناعي مجانًا',
            twitter_description: 'ادخل إلى Kling وVeo وFlux في مكان واحد. أنشئ فيديو وفنًا بالذكاء الاصطناعي فورًا.',
            faq: [
                {
                    question: 'لماذا 微鲤AI أفضل من استخدام النماذج بشكل منفصل؟',
                    answer: '微鲤AI يعمل كمنصة مُجمِّعة. بدلًا من دفع اشتراكات منفصلة لـ Kling أو Midjourney أو Runway، ستحصل على أفضل النماذج (Kling 2.5 وFlux Pro وGoogle Veo) في لوحة تحكم واحدة. هذا يوفر المال ويبسّط سير عملك.',
                },
                {
                    question: 'هل 微鲤AI مجاني فعلًا؟',
                    answer: 'نعم. نقدم رصيدًا مجانيًا يوميًا سخيًا لتجربة أدوات مثل تحويل النص إلى فيديو وتبديل الوجوه ومولد الصور. لا تحتاج بطاقة ائتمان للبدء. للاستخدام المكثف والتنزيل بدون علامة مائية، تتوفر خطط مدفوعة مرنة.',
                },
                {
                    question: 'هل يمكنني استخدام Kling AI وFlux على هذه المنصة؟',
                    answer: 'بالتأكيد. يدمج 微鲤AI أحدث إصدارات Kling (للفيديو الواقعي) وFlux (للصور عالية الدقة) وGoogle Veo. نقوم بتحديث مكتبة النماذج باستمرار لتبقى دائمًا على أحدث التقنيات.',
                },
                {
                    question: 'كيف يمكنني تحسين الفيديوهات منخفضة الجودة؟',
                    answer: 'استخدم أداة AI Video Upscaler. تقوم تلقائيًا بإزالة الضوضاء/الضبابية ورفع الدقة حتى 4K. مثالية لترميم فيديوهات العائلة القديمة أو تحسين مقاطع وسائل التواصل الاجتماعي.',
                },
                {
                    question: 'هل أمتلك الحقوق التجارية لأعمالي؟',
                    answer: 'إذا كنت على خطة مدفوعة، نعم. تمتلك حقوقًا تجارية كاملة لكل ما يتم إنشاؤه على WeryAI، مما يجعله آمنًا لتحقيق الدخل على YouTube وأعمال العملاء والحملات التسويقية.',
                },
            ],
        },
        homePage: {
            title: 'الرئيسية | 微鲤AI',
            description: 'أنشئ فيديوهات وصورًا مذهلة باستخدام 微鲤AI — المنصة المجانية والشاملة المدعومة بالذكاء الاصطناعي. حوّل النصوص أو الصور أو الفيديوهات إلى محتوى مرئي عالي الجودة.',
            keywords: 'مولد فيديو بالذكاء الاصطناعي, مولد صور بالذكاء الاصطناعي, تحويل نص إلى فيديو, تحويل صورة إلى فيديو, إنشاء فيديوهات بالذكاء الاصطناعي, إنشاء صور بالذكاء الاصطناعي, محتوى مرئي بالذكاء الاصطناعي, 微鲤AI',
        },
        aiTools: {
            title: 'حزم أدوات التحرير - مجموعة أفضل أدوات الذكاء الاصطناعي | 微鲤AI',
            description: 'استكشف جميع أفضل مجموعات أدوات الذكاء الاصطناعي لتوليد الفيديو والصور. أنشئ فيديوهات وصور مذهلة بتقنية الذكاء الاصطناعي المتقدمة.',
            keywords: 'أدوات الذكاء الاصطناعي, أدوات توليد الفيديو, أدوات توليد الصور, أدوات الذكاء الاصطناعي للفيديو, أدوات الذكاء الاصطناعي للصور, 微鲤AI',
        },
        myCreations: {
            title: 'منشئاتي | 微鲤AI',
            description: 'اعرض جميع منشئاتك، بما في ذلك الفيديوهات والصور. قم بإدارة منشئاتك باستخدام 微鲤AI لإنشاء محتوى مرئي عالي الجودة.',
            keywords: 'منشئاتي, منشئات فيديو, منشئات صور, إدارة منشئات, 微鲤AI',
        },
        aiImage: {
            title: 'مولد الصور بالذكاء الاصطناعي - أنشئ صورًا مذهلة بالذكاء الاصطناعي | 微鲤AI',
            description: 'أنشئ صورًا احترافية مولدة بالذكاء الاصطناعي مع 微鲤AI. حول النص إلى صورة، وأنشئ مرئيات إبداعية، وأحيِ خيالك بتقنية الذكاء الاصطناعي المتقدمة.',
            keywords: 'مولد صور بالذكاء الاصطناعي, نص إلى صورة, فن بالذكاء الاصطناعي, إنشاء صور, صور بالذكاء الاصطناعي, مولد فن رقمي',
        },
        aiVideo: {
            title: 'مولد الفيديو بالذكاء الاصطناعي - أنشئ فيديوهات رائعة بالذكاء الاصطناعي | 微鲤AI',
            description: 'أنشئ فيديوهات مذهلة بالذكاء الاصطناعي باستخدام 微鲤AI. أنشئ فيديوهات من نص أو صور أو فيديوهات بنماذج ذكاء اصطناعي متطورة مثل Sora و Veo والمزيد.',
            keywords: 'مولد فيديو بالذكاء الاصطناعي, نص إلى فيديو, إنشاء فيديو, فيديوهات بالذكاء الاصطناعي, توليد فيديو, Sora, Veo',
        },
        aiMusic: {
            title: 'مولد الموسيقى بالذكاء الاصطناعي - غناء وآلات | 微鲤AI',
            description: 'أنشئ موسيقى بالذكاء الاصطناعي خلال ثوانٍ على 微鲤AI: أغانٍ بصوت أو موسيقى آلية، استكشف أنماطًا مثل البوب والروك والإلكترونية والجاز، وأعد مزج إبداعات المجتمع بنقرة واحدة.',
            keywords: 'مولد موسيقى بالذكاء الاصطناعي, مولد موسيقى بالذكاء الاصطناعي مجاني, مولد موسيقى بالذكاء الاصطناعي بصوت, مولد أغانٍ بصوت, مولد موسيقى آلية, نص إلى موسيقى, إنشاء موسيقى مشابهة, إعادة مزج موسيقى بالذكاء الاصطناعي, أنماط موسيقية, موسيقى خالية من حقوق الملكية, 微鲤AI',
        },
        pricing: {
            title: 'التسعير والخطط - إنشاء فيديو وصور بالذكاء الاصطناعي بأسعار معقولة | 微鲤AI',
            description: 'اختر الخطة المثالية لاحتياجاتك. أسعار مرنة لتوليد الفيديو والصور بالذكاء الاصطناعي مع 微鲤AI. تجربة مجانية متاحة.',
            keywords: 'أسعار الذكاء الاصطناعي, أسعار توليد الفيديو, أسعار توليد الصور, خطط الاشتراك',
        },
        faq: {
            title: 'الأسئلة الشائعة - مركز مساعدة 微鲤AI',
            description: 'ابحث عن إجابات للأسئلة الشائعة حول منصة توليد الفيديو والصور بالذكاء الاصطناعي من 微鲤AI. احصل على مساعدة بشأن الميزات والأسعار والمزيد.',
            keywords: 'أسئلة شائعة عن الذكاء الاصطناعي, مساعدة 微鲤AI, مساعدة توليد الفيديو, دليل توليد الصور',
        },
        aboutUs: {
            title: 'من نحن - منصة الإنشاء بالذكاء الاصطناعي 微鲤AI',
            description: 'تعرف على WeryAI، المنصة الرائدة لإنشاء الفيديو والصور بالذكاء الاصطناعي. اكتشف مهمتنا لإضفاء الطابع الديمقراطي على إنشاء المحتوى بالذكاء الاصطناعي.',
            keywords: 'عن 微鲤AI, منصة الذكاء الاصطناعي, معلومات الشركة, تقنية الذكاء الاصطناعي',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'نماذج الفيديو بالذكاء الاصطناعي - Veo, Sora, Kling AI والمزيد | 微鲤AI',
            description: 'استكشف مجموعتنا من نماذج توليد الفيديو بالذكاء الاصطناعي المتقدمة بما في ذلك Veo 3.1 و Sora 2 و Kling AI و Runway والمزيد. أنشئ فيديوهات مذهلة بتقنية ذكاء اصطناعي متطورة.',
            keywords: 'نماذج فيديو بالذكاء الاصطناعي, Veo 3.1, Sora 2, Kling AI, Runway, Hailuo AI, نماذج توليد الفيديو, تقنية فيديو بالذكاء الاصطناعي',
        },
        imageModels: {
            title: 'نماذج الصور بالذكاء الاصطناعي - FLUX, Nano Banana, Imagen والمزيد | 微鲤AI',
            description: 'استكشف مجموعتنا من نماذج توليد الصور بالذكاء الاصطناعي المتقدمة بما في ذلك FLUX و Nano Banana و Imagen و GPT-4o والمزيد. أنشئ صورًا احترافية بنماذج ذكاء اصطناعي حديثة.',
            keywords: 'نماذج صور بالذكاء الاصطناعي, FLUX, Nano Banana, Imagen, GPT-4o, Flux Kontext, نماذج توليد الصور, تقنية صور بالذكاء الاصطناعي',
        },
        ugcDetailImage: {
            title: 'مولد صور ذكاء اصطناعي مجاني | أنشئ عملك الخاص | 微鲤AI',
            description: 'شاهد هذه الصورة المذهلة المُنشأة بالذكاء الاصطناعي وأنشئ صورتك الخاصة مجاناً! مولد الذكاء الاصطناعي القوي من 微鲤AI يحول أفكارك إلى صور مذهلة في ثوانٍ. جربه الآن!',
            keywords: 'مولد صور ذكاء اصطناعي, فن ذكاء اصطناعي مجاني, صورة مُنشأة بالذكاء الاصطناعي, نص إلى صورة, إنشاء صور ذكاء اصطناعي, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'مولد فيديو ذكاء اصطناعي مجاني | أنشئ عملك الخاص | 微鲤AI',
            description: 'شاهد هذا الفيديو المذهل المُنشأ بالذكاء الاصطناعي وأنشئ فيديوك الخاص مجاناً! مولد الذكاء الاصطناعي القوي من 微鲤AI يحول أفكارك إلى فيديوهات مذهلة في ثوانٍ. جربه الآن!',
            keywords: 'مولد فيديو ذكاء اصطناعي, فيديو ذكاء اصطناعي مجاني, فيديو مُنشأ بالذكاء الاصطناعي, نص إلى فيديو, إنشاء فيديو ذكاء اصطناعي, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'مولد موسيقى ذكاء اصطناعي مجاني | أنشئ موسيقاك الخاصة | 微鲤AI',
            description: 'استمع إلى هذه الموسيقى المذهلة المُنشأة بالذكاء الاصطناعي وأنشئ موسيقاك الخاصة مجاناً! مولد الموسيقى بالذكاء الاصطناعي القوي من 微鲤AI يحول أفكارك إلى أغانٍ فريدة في ثوانٍ. جربه الآن!',
            keywords: 'مولد موسيقى ذكاء اصطناعي, موسيقى ذكاء اصطناعي مجانية, موسيقى مُنشأة بالذكاء الاصطناعي, نص إلى موسيقى, إنشاء أغانٍ ذكاء اصطناعي, موسيقى خالية من حقوق الملكية, 微鲤AI',
            og_title: 'مولد موسيقى ذكاء اصطناعي مجاني | أنشئ موسيقاك الخاصة | 微鲤AI',
            og_description: 'استمع إلى هذه الموسيقى المذهلة المُنشأة بالذكاء الاصطناعي وأنشئ موسيقاك الخاصة مجاناً! مولد الموسيقى بالذكاء الاصطناعي القوي من 微鲤AI يحول أفكارك إلى أغانٍ فريدة في ثوانٍ.',
            twitter_title: 'مولد موسيقى ذكاء اصطناعي مجاني | 微鲤AI',
            twitter_description: 'استمع إلى موسيقى مُنشأة بالذكاء الاصطناعي وأنشئ موسيقاك الخاصة مجاناً!',
        },
        characters: {
            title: 'شخصيات الذكاء الاصطناعي - دردش مع شخصيات الذكاء الاصطناعي والرفاق الافتراضيين | 微鲤AI',
            description: 'دردش مع آلاف شخصيات الذكاء الاصطناعي على 微鲤AI. اكتشف شخصيات الأنمي والرفاق الافتراضيين والشخصيات التفاعلية للذكاء الاصطناعي. ابدأ محادثات مع شخصيات الذكاء الاصطناعي مجاناً.',
            keywords: 'شخصيات الذكاء الاصطناعي, دردشة الذكاء الاصطناعي, الرفاق الافتراضيون, شخصيات الأنمي, شخصية الذكاء الاصطناعي, دردشة الشخصيات, محادثة الذكاء الاصطناعي, الأصدقاء الافتراضيون, 微鲤AI',
            og_title: 'شخصيات الذكاء الاصطناعي - دردش مع شخصيات الذكاء الاصطناعي والرفاق الافتراضيين | 微鲤AI',
            og_description: 'استكشف آلاف شخصيات الذكاء الاصطناعي وابدأ محادثات ذات معنى. دردش مجاناً مع شخصيات الأنمي والرفاق الافتراضيين والشخصيات التفاعلية للذكاء الاصطناعي.',
            twitter_title: 'شخصيات الذكاء الاصطناعي - دردش مع شخصيات الذكاء الاصطناعي | 微鲤AI',
            twitter_description: 'اكتشف وتحدث مع آلاف شخصيات الذكاء الاصطناعي. شخصيات الأنمي والرفاق الافتراضيون والشخصيات التفاعلية—كلها مجانية على 微鲤AI.',
        },
        characterToImage: {
            title: 'صور شخصية بالذكاء الاصطناعي - أنشئ صور شخصيتك الخاصة | 微鲤AI',
            description: 'اختر شخصيتك على WeryAI، أدخل الوصف (Prompt)، ثم اضغط على "إنشاء" لإنشاء صور شخصيتك الخاصة.',
            keywords: 'صور شخصية بالذكاء الاصطناعي, شخصية بالذكاء الاصطناعي, توليد صور الشخصيات, صور الشخصيات, 微鲤AI',
            og_title: 'صور شخصية بالذكاء الاصطناعي - أنشئ صور شخصيتك الخاصة | 微鲤AI',
            og_description: 'اختر شخصيتك على WeryAI، أدخل الوصف (Prompt)، ثم اضغط على "إنشاء" لإنشاء صور شخصيتك الخاصة.',
            twitter_title: 'صور شخصية بالذكاء الاصطناعي - أنشئ صور شخصيتك الخاصة | 微鲤AI',
            twitter_description: 'اختر شخصيتك على WeryAI، أدخل الوصف (Prompt)، ثم اضغط على "إنشاء" لإنشاء صور شخصيتك الخاصة.',
        },
        characterToVideo: {
            title: 'تحويل الشخصية إلى فيديو بالذكاء الاصطناعي - أنشئ فيديوهات تفاعلية | 微鲤AI',
            description: 'أنشئ فيديوهات مذهلة مع أي شخصية بالذكاء الاصطناعي. ارفع صور الشخصية أو اخترها من 微鲤AI لتوليد فيديوهات تفاعلية تجمعك مع الشخصية.',
            keywords: 'شخصية إلى فيديو, مولد فيديو شخصيات بالذكاء الاصطناعي, فيديو تفاعلي, ثبات الشخصية, 微鲤AI',
            og_title: 'تحويل الشخصية إلى فيديو بالذكاء الاصطناعي - أنشئ فيديوهات تفاعلية | 微鲤AI',
            og_description: 'حوّل أفكارك إلى فيديوهات تفاعلية مع الشخصيات. ارفع أو اختر شخصية على 微鲤AI لتوليد حركة واقعية.',
            twitter_title: 'تحويل الشخصية إلى فيديو بالذكاء الاصطناعي - فيديوهات تفاعلية | 微鲤AI',
            twitter_description: 'أنشئ فيديوهات عالية الجودة مع شخصياتك المفضلة. ارفع أو اختر شخصية على 微鲤AI لتوليد فيديو تفاعلي.',
            page: {
                title1: 'مولد مجاني لتحويل الشخصية إلى فيديو بالذكاء الاصطناعي',
                title2: 'اجعل شخصياتك المفضلة تنبض بالحياة! ارفع صورة أي شخصية أو اختر من مكتبة 微鲤AI المتنوعة لتوليد فيديو تفاعلي مذهل. صف المشهد والتفاعل في الـ Prompt وشاهد النتيجة.',
                consistency: 'ثبات شخصية رائد في المجال: يحافظ الذكاء الاصطناعي على ملامح ومظهر الشخصية طوال تسلسل الفيديو.',
                interactive: 'اصنع تفاعلات ذات معنى: من المشي معًا إلى الحوار. إمكانيات السرد لا حدود لها.',
                faq: [
                    {
                        question: 'كيف أنشئ فيديو مع شخصية محددة؟',
                        answer: 'ارفع صورة الشخصية أو اخترها من WeryAI، ثم اكتب Prompt يصف المشهد أو التفاعل واضغط إنشاء.',
                    },
                    {
                        question: 'هل يمكنني استخدام أي صورة شخصية؟',
                        answer: 'نعم، إذا كانت لديك حقوق استخدامها. سيقوم الذكاء الاصطناعي بتحريك الشخصية وفق تعليماتك.',
                    },
                    {
                        question: 'هل هناك حد لمدة الفيديو؟',
                        answer: 'يعتمد ذلك على النموذج وخطتك، وغالبًا ما تكون المدة بين 5 و10 ثوانٍ.',
                    },
                    {
                        question: 'كيف أضمن ثبات مظهر الشخصية؟',
                        answer: 'نحلّل الصورة المرجعية للحفاظ على السمات البصرية ثابتة عبر جميع الإطارات.',
                    },
                    {
                        question: 'هل يمكنني التجربة مجانًا؟',
                        answer: 'نعم، يمكنك استخدام الأرصدة المجانية اليومية لتوليد فيديوهات الشخصيات.',
                    },
                ],
            },
            faq: [
                {
                    question: 'ما هو "شخصية إلى فيديو" في WeryAI؟',
                    answer: 'أداة متقدمة لتوليد فيديوهات تتضمن شخصية محددة. يمكنك رفع صورة أو اختيار شخصية من المكتبة لصنع فيديو تفاعلي.',
                },
                {
                    question: 'كيف يعمل ثبات الشخصية في الفيديو؟',
                    answer: 'يستخدم الذكاء الاصطناعي الصورة المرجعية للحفاظ على مظهر الشخصية ثابتًا وقابلًا للتعرّف طوال المقطع.',
                },
                {
                    question: 'هل يمكنني إنشاء فيديو يجمعني مع الشخصية؟',
                    answer: 'نعم. صف التفاعل في الـ Prompt وسيقوم الذكاء الاصطناعي بتوليد فيديو يعكس ذلك.',
                },
                {
                    question: 'ما النماذج المستخدمة؟',
                    answer: 'نستخدم نماذج فيديو قوية مثل Kling وGoogle Veo مع تحسينات لثبات الشخصية والحركة الواقعية.',
                },
                {
                    question: 'ما أقصى مدة للفيديو؟',
                    answer: 'وفقًا لخطة الاشتراك، عادةً بين 5 و10 ثوانٍ بجودة عالية.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - شارك مع الأصدقاء | 微鲤AI',
            description: 'شارك مع الأصدقاء، وادعُ أصدقاءك للتسجيل في WeryAI، وستحصل أنت وأصدقاؤك على مكافآت.',
            keywords: 'social back، شارك مع الأصدقاء، ادعُ الأصدقاء للتسجيل في WeryAI، احصل على مكافآت، 微鲤AI',
        },
    },
    tw: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI 讓你透過文字、照片或影片即刻生成 AI 影片與圖片，立即免費體驗。',
        home: {
            h1: '微鲤AI - 免費 AI 影片與圖片生成平台',
            title: '微鲤AI - 免費 AI 影片生成器與圖片工具（Kling、Flux、Veo）',
            description: '無需多重訂閱，一站式使用 Kling AI、Google Veo、Sora 與 Flux。立即生成專業影片、換臉與圖片放大。',
            keywords: 'AI 影片生成器, AI 圖片生成器, 文生影片, 圖生影片, AI 影片製作, AI 圖片製作, 影片生成, 圖片生成, AI 內容創作, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - 一站式 AI 創作平台',
            og_description: '用 Kling 與 Flux 生成精彩影片與影像，支援文生影片、換臉與升級放大。立即免費體驗。',
            twitter_title: '微鲤AI - 免費 AI 影片生成器',
            twitter_description: '在同一平台使用 Kling、Veo 與 Flux，立即生成 AI 影片與影像。',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: '以 AI 驅動的一站式創作平台，整合 Kling AI、Google Veo、Sora、Flux 等頂尖模型，提供文生影片、換臉與升級放大等功能。',
            software_feature: 'Kling AI 整合、文字轉影片、AI 換臉、4K 影片升級、圖片轉影片、口型同步、背景移除',
        },
        homePage: {
            title: '首頁 - 一站式 AI 影片與圖片創作平台 | 微鲤AI',
            description: '使用微鲤AI 以文字、照片或影片快速生成精彩影片與圖片，立即免費體驗。',
            keywords: 'AI 影片產生器, AI 圖片產生器, 文生影片, 圖生影片, AI 內容創作, 微鲤AI',
        },
        aiTools: {
            title: '編輯工具箱 - 頂尖 AI 工具集合 | 微鲤AI',
            description: '探索所有頂尖的 AI 影片與圖片工具集合。',
            keywords: 'AI 工具, 影片工具, 圖片工具, 微鲤AI',
        },
        myCreations: {
            title: '我的創作 | 微鲤AI',
            description: '查看您的所有創作，包括影片和圖片。使用微鲤AI 管理您的高品質視覺內容。',
            keywords: '我的創作, 影片創作, 圖片創作, 創作管理, 微鲤AI',
        },
        aiImage: {
            title: 'AI 圖像產生器 - 用 AI 創作精美圖片 | 微鲤AI',
            description: '使用微鲤AI 創作專業的 AI 生成圖像。將文本轉換為圖像，實現您的想象。',
            keywords: 'AI 圖像產生器, 文本轉圖像, AI 藝術, 微鲤AI',
        },
        aiVideo: {
            title: 'AI 影片產生器 - 用 AI 創作驚艷影片 | 微鲤AI',
            description: '使用微鲤AI生成令人驚嘆的 AI 影片。支援文生影片、圖生影片，完美呈現創意。',
            keywords: 'AI 影片產生器, 文本轉影片, 影片創作, 微鲤AI',
        },
        aiMusic: {
            title: 'AI 音樂產生 - 人聲/純音樂一鍵創作 | 微鲤AI',
            description: '在微鲤AI快速生成 AI 音樂：支持人聲歌曲與純音乐，探索多種風格。',
            keywords: 'AI 音樂產生器, 文生音樂, 做同款音樂, 微鲤AI',
        },
        pricing: {
            title: '方案與價格 | 微鲤AI – AI 圖片與影片生成訂閱',
            description: '探索 微鲤AI 彈性的價格方案，獲得更多每月點數、優先處理與進階模型存取。比較 Basic、Standard 與 Pro 計畫。',
            keywords: '微鲤AI 價格, AI 生成器 價格, AI 訂閱方案, AI 點數, 圖片生成 價格, 影片生成 價格',
            og_title: '微鲤AI 價格 – AI 圖片與影片生成方案',
            og_description: '選擇最適合的 AI 圖片與影片生成方案，包含免費點數、Pro 功能與優先使用權。',
            twitter_title: '微鲤AI 價格 – 彈性 AI 方案與點數',
            twitter_description: '選擇合適的 AI 方案與點數配額，滿足你的創作需求。',
        },
        faq: {
            title: '常見問題 | 微鲤AI',
            description: '尋找關於 微鲤AI 影片與圖片工具的常見問題解答。',
            keywords: 'FAQ, 幫助中心, 微鲤AI',
        },
        aboutUs: {
            title: '關於我們 | 微鲤AI 創意平台',
            description: '了解 微鲤AI的使命，致力於為全球創作者提供頂尖 AI 工具。',
            keywords: '關於 微鲤AI, 公司信息, 微鲤AI',
        },
        refund: {
            title: '退款政策 | 微鲤AI',
            description: '查閱 微鲤AI的官方退款政策。',
            keywords: '退款政策, 微鲤AI',
        },
        privacy: {
            title: '隱私權政策 | 微鲤AI',
            description: '閱讀 微鲤AI的官方隱私權政策。',
            keywords: '隱私權政策, 微鲤AI',
        },
        terms: {
            title: '服務條款 | 微鲤AI',
            description: '閱讀 微鲤AI的官方服務條款與條件。',
            keywords: '服務條款, 條款與條件, 微鲤AI',
        },
        videoModels: {
            title: 'AI 影片模型 - Veo, Sora, Kling AI 等熱門模型集合 | 微鲤AI',
            description: '探索全球頂尖的 AI 影片模型，包括 Kling, Sora, Google Veo 等。',
            keywords: 'AI 影片模型, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'AI 圖像模型 - FLUX, Nano Banana, Imagen 等頂尖模型集合 | 微鲤AI',
            description: '存取頂尖的 AI 圖像模型，如 FLUX, Nano Banana 和 Imagen，創作高畫質藝術作品。',
            keywords: 'AI 圖像模型, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'AI 產生圖片詳情 | 微鲤AI',
            description: '查看 AI 生成圖片的詳細信息、提示詞與參數。',
            keywords: 'AI 圖片詳情, 圖像參數, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'AI 產生影片詳情 | 微鲤AI',
            description: '查看 AI 生成影片的詳細信息、提示詞與製作參數。',
            keywords: 'AI 影片詳情, 影片參數, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'AI 產生音樂詳情 | 微鲤AI',
            description: '查看 AI 生成音樂的風格、歌詞與創作細節。',
            keywords: 'AI 音樂詳情, 音樂參數, 微鲤AI',
        },
        characters: {
            title: 'AI 角色創作 - 打造一致性虛擬角色 | 微鲤AI',
            description: '使用 AI 創建具有一致性的虛擬角色，適用於故事創作與影片製作。',
            keywords: 'AI 角色, 虛擬角色, 角色一致性, 微鲤AI',
        },
        characterToImage: {
            title: 'AI 角色生圖 - 生成你與角色的合影圖片 | 微鲤AI',
            description: '上傳你自己的角色照片或從 微鲤AI平台選擇角色，透過提示詞生成你與角色的合影、互動圖片。保持角色視覺一致性，開啟創意互動。',
            keywords: 'AI角色生圖, 角色一致性, AI角色生成器, 角色互動合影, WeryAI角色',
            og_title: 'AI 角色生圖 - 生成你與角色的合影圖片 | 微鲤AI',
            og_description: '使用 AI 生成與任意角色的互動合影。上傳角色或在微鲤AI 庫中選擇，透過提示詞創作高保真角色互動圖片。',
            twitter_title: 'AI 角色生圖 - 生成你與角色的合影圖片 | 微鲤AI',
            twitter_description: '創作你與喜愛角色的專屬合影。在微鲤AI上上傳或選擇角色，即刻生成極具創意互動的 AI 角色圖片。',
            faq: [
                {
                    question: '什麼是微鲤AI角色生圖？',
                    answer: '微鲤AI角色生圖是一款 AI 驅動的工具，允許你在保持角色視覺特徵一致的前提下，生成包含特定角色的圖像。你可以上傳自己的角色照片，也可以從我們的預設角色庫中選擇。',
                },
                {
                    question: '我可以生成我與角色的合影嗎？',
                    answer: '當然可以！透過提供關於你和角色的互動描述（提示詞），AI 可以生成你與所選角色互動的寫實或藝術風格合影。',
                },
                {
                    question: '我可以選擇多少種角色？',
                    answer: '微鲤AI 擁有海量的角色庫，涵蓋動漫、遊戲及原創設計。你也可以上傳任意角色的照片，開啟獨一無二的創意互動。',
                },
                {
                    question: '它支援高解析度嗎？',
                    answer: '是的。我們支援高達 4K 的高解析度圖像生成，確保你的角色合影細節豐富、畫質清晰。',
                },
                {
                    question: '如何保持角色的視覺一致性？',
                    answer: '我們先進的 AI 模型經過專門訓練，能夠識別並保留角色的核心特徵，確保生成的圖像與你提供或選擇的參考角色保持一致。',
                },
            ],
        },
        characterToVideo: {
            title: 'AI 角色生影片 - 創作你與角色的互動影片 | 微鲤AI',
            description: '讓靜態角色動起來！上傳照片或選擇 微鲤AI角色，生成你與角色共同互動的驚豔影片。支援角色視覺一致性，帶來沉浸式互動體驗。',
            keywords: 'AI角色生影片, 角色影片生成器, AI互動影片, 角色一致性影片, 微鲤AI',
            og_title: 'AI 角色生影片 - 創作你與角色的互動影片 | 微鲤AI',
            og_description: '將你的創意轉化為與 AI 角色的互動影片。在微鲤AI上上傳或選擇角色，生成具備真實動作的角色影片。',
            twitter_title: 'AI 角色生影片 - 創作你與角色的互動影片 | 微鲤AI',
            twitter_description: '生成包含你喜愛角色的高品質互動影片。在微鲤AI上開啟你的 AI 角色創意影片之旅。',
            page: {
                title1: '免費 AI 角色生影片生成器',
                title2: '讓你喜愛的角色動起來！上傳任意角色的照片或從 微鲤AI 豐富的角色庫中選擇，生成驚豔的互動影片。只需在提示詞中描述你想要的互動場景，就能看到你與角色在電影級 AI 影片中共同演繹。',
                consistency: '體驗產業領先的角色一致性。我們先進的 AI 確保角色在整個影片序列中保持其獨特的特徵與外觀。',
                interactive: '創造有意義的互動。從在公園一起散步到分享對話，角色驅動的故事創作可能性無窮無盡。',
                faq: [
                    {
                        question: '如何建立包含特定角色的影片？',
                        answer: '上傳角色照片或從 微鲤AI平台選擇角色，然後輸入描述你想要生成的互動或場景的提示詞。',
                    },
                    {
                        question: '我可以使用任何角色照片嗎？',
                        answer: '可以，你可以上傳任何你有權使用的角色照片，我們的 AI 會依照你的指令為其製作動畫。',
                    },
                    {
                        question: '影片時長有限制嗎？',
                        answer: '角色影片目前支援 5 到 10 秒的時長，具體取決於 AI 模型與你的訂閱方案。',
                    },
                    {
                        question: '如何確保角色看起來一致？',
                        answer: '微鲤AI使用專門的角色一致性演算法，分析參考影像以在所有影片幀中保持穩定的視覺特徵。',
                    },
                    {
                        question: '可以免費試用嗎？',
                        answer: '可以，你可以使用微鲤AI的每日免費點數生成角色影片。',
                    },
                ],
            },
            faq: [
                {
                    question: '什麼是微鲤AI角色生影片？',
                    answer: '這是一款先進的 AI 工具，可以生成包含特定角色的動態影片。你可以上傳角色照片或從角色庫中選擇，創作你與角色共同互動的精彩影片內容。',
                },
                {
                    question: '影片中的角色一致性是如何實現的？',
                    answer: '我們的 AI 使用針對角色特徵最佳化的訓練技術，確保角色的外觀在整段影片中保持穩定、可辨識。',
                },
                {
                    question: '我可以製作我與角色在一起的影片嗎？',
                    answer: '可以。你只需在提示詞中描述你與角色的互動情境，AI 就會生成展現這些互動過程的連貫影片。',
                },
                {
                    question: '角色生影片使用了哪些 AI 模型？',
                    answer: '我們使用了目前最先進的高性能影片模型（如 Kling、Google Veo），並針對角色一致性與真實動作進行深度最佳化。',
                },
                {
                    question: '生成的角色影片最長是多少秒？',
                    answer: '依據你的方案，你可以生成時長在 5 到 10 秒之間的高畫質角色影片。',
                },
            ],
        },
        social_back: {
            title: '福利中心 - 與好友分享 | 微鲤AI',
            description: '與好友分享，邀請好友註冊 WeryAI，你和你的好友都將獲得獎勵。',
            keywords: '福利中心, 與好友分享, 邀請好友註冊 微鲤AI, 獲得獎勵, 微鲤AI',
        },
    },
    pl: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI pozwala tworzyć filmy i obrazy AI z tekstu, zdjęć lub klipów. Wypróbuj za darmo.',
        home: {
            h1: '微鲤AI - Darmowa platforma do generowania wideo i obrazów AI',
            title: '微鲤AI - Darmowy generator wideo AI i narzędzia do obrazów (Kling, Flux, Veo)',
            description: 'Koniec z wieloma subskrypcjami. Korzystaj z Kling AI, Google Veo, Sora i Flux w jednym miejscu. Twórz profesjonalne wideo, zamieniaj twarze i skaluj obrazy.',
            keywords: 'generator wideo AI, generator obrazów AI, tekst na wideo, obraz na wideo, tworzenie wideo AI, tworzenie obrazów AI, generowanie wideo, generowanie obrazów, tworzenie treści AI, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - kompleksowa platforma kreatywna AI',
            og_description: 'Twórz zachwycające wideo z Kling i Flux. Tekst na wideo, zamiana twarzy i skalowanie. Wypróbuj za darmo.',
            twitter_title: '微鲤AI - darmowy generator wideo AI',
            twitter_description: 'Korzystaj z Kling, Veo i Flux w jednym miejscu. Twórz wideo i obrazy AI natychmiast.',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'Platforma kreatywna oparta na AI, która agreguje najlepsze modele, takie jak Kling AI, Google Veo, Sora i Flux. Funkcje: Text-to-Video, Face Swap i Upscaling.',
            software_feature: 'Integracja Kling AI, tekst na wideo, podmiana twarzy AI, upscaler wideo 4K, obraz na wideo, lip sync, usuwanie tła',
        },
        homePage: {
            title: 'Strona główna | 微鲤AI',
            description: 'Twórz wideo i obrazy AI z tekstu, zdjęć lub klipów dzięki 微鲤AI — wypróbuj za darmo.',
            keywords: 'generator wideo AI, generator obrazów AI, tekst na wideo, obraz na wideo, treści AI, 微鲤AI',
        },
        aiTools: {
            title: 'Zestaw narzędzi edycyjnych - Wszystkie najlepsze narzędzia AI | 微鲤AI',
            description: 'Odkryj kolekcję wszystkich najlepszych narzędzi AI do wideo i obrazów.',
            keywords: 'narzędzia AI, narzędzia wideo, narzędzia obrazu, 微鲤AI',
        },
        myCreations: {
            title: 'Moje kreacje | 微鲤AI',
            description: 'Przeglądaj wszystkie swoje kreacje, w tym filmy i obrazy. Zarządzaj treściami wysokiej jakości.',
            keywords: 'moje kreacje, tworzenie wideo, tworzenie obrazów, zarządzanie, 微鲤AI',
        },
        aiImage: {
            title: 'Generator obrazów AI - Twórz piękne obrazy z AI | 微鲤AI',
            description: 'Twórz profesjonalne obrazy generowane przez AI. Przekształć tekst w sztukę.',
            keywords: 'generator obrazów AI, tekst na obraz, sztuka AI, 微鲤AI',
        },
        aiVideo: {
            title: 'Generator wideo AI - Twórz niesamowite filmy z AI | 微鲤AI',
            description: 'Generuj zachwycające filmy AI. Wspiera tekst na wideo i obraz na wideo.',
            keywords: 'generator wideo AI, tekst na wideo, tworzenie wideo, 微鲤AI',
        },
        aiMusic: {
            title: 'Generowanie muzyki AI - Utwory wokalne i instrumentalne | 微鲤AI',
            description: 'Szybko generuj muzykę AI: wspiera piosenki wokalne i muzykę instrumentalną.',
            keywords: 'generator muzyki AI, tekst na muzykę, 微鲤AI',
        },
        pricing: {
            title: 'Plany i ceny | 微鲤AI – subskrypcje generowania obrazów i wideo AI',
            description: 'Poznaj elastyczne plany cenowe 微鲤AI: więcej miesięcznych kredytów, priorytetowe przetwarzanie i dostęp do zaawansowanych modeli. Porównaj Basic, Standard i Pro.',
            keywords: 'cennik 微鲤AI, ceny generatora AI, plany subskrypcji AI, kredyty AI, ceny generowania obrazów, ceny generowania wideo',
            og_title: '微鲤AI Ceny – plany generowania obrazów i wideo AI',
            og_description: 'Wybierz najlepszy plan generowania obrazów i wideo AI. Darmowe kredyty, funkcje Pro i priorytetowy dostęp.',
            twitter_title: '微鲤AI Ceny – elastyczne plany i kredyty AI',
            twitter_description: 'Wybierz plan dopasowany do potrzeb tworzenia wideo i obrazów AI.',
        },
        faq: {
            title: 'Często zadawane pytania | 微鲤AI',
            description: 'Znajdź odpowiedzi na najczęstsze pytania dotyczące narzędzi wideo i obrazów 微鲤AI.',
            keywords: 'FAQ, pomoc, 微鲤AI',
        },
        aboutUs: {
            title: 'O nas | Platforma kreatywna 微鲤AI',
            description: 'Poznaj misję 微鲤AI, polegającą na dostarczaniu najlepszych narzędzi AI twórcom na całym świecie.',
            keywords: 'o 微鲤AI, informacje o firmie, 微鲤AI',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'Modele wideo AI - Kolekcja Veo, Sora, Kling AI | 微鲤AI',
            description: 'Poznaj najlepsze modele wideo AI, w tym Kling, Sora, Google Veo i inne.',
            keywords: 'modele wideo AI, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'Modele obrazów AI - Kolekcja FLUX, Nano Banana, Imagen | 微鲤AI',
            description: 'Dostęp do najlepszych modele obrazów AI, takich jak FLUX, Nano Banana i Imagen.',
            keywords: 'modele obrazów AI, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'Szczegóły obrazu wygenerowanego przez AI | 微鲤AI',
            description: 'Zobacz szczegóły, prompty i parametry obrazu AI.',
            keywords: 'szczegóły obrazu AI, parametry obrazu, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Szczegóły wideo wygenerowanego przez AI | 微鲤AI',
            description: 'Zobacz szczegóły, prompty i parametry produkcji wideo AI.',
            keywords: 'szczegóły wideo AI, parametry wideo, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Szczegóły muzyki wygenerowanej przez AI | 微鲤AI',
            description: 'Zobacz styl, tekst i szczegóły kreacji muzyki AI.',
            keywords: 'szczegóły muzyki AI, parametry muzyki, 微鲤AI',
        },
        characters: {
            title: 'Tworzenie postaci AI - Buduj spójne wirtualne postacie | 微鲤AI',
            description: 'Użyj AI do tworzenia spójnych postaci do historii i filmów.',
            keywords: 'postacie AI, postacie wirtualne, spójność postaci, 微鲤AI',
        },
        characterToImage: {
            title: 'AI Postać na Obraz - Twórz zdjęcia z dowolną postacią | 微鲤AI',
            description: 'Prześlij własne zdjęcia postaci lub wybierz je na platformie 微鲤AI, aby generować wysokiej jakości obrazy Ciebie i postaci razem przy zachowaniu spójności wyglądu.',
            keywords: 'AI postać na obraz, spójność postaci, generator postaci AI, interaktywne zdjęcia z postaciami, 微鲤AI',
            og_title: 'AI Postać na Obraz - Twórz zdjęcia z dowolną postacią | 微鲤AI',
            og_description: 'Twórz wysokiej jakości obrazy z dowolną postacią AI. Prześlij własną postać lub wybierz ją w 微鲤AI, aby generować zachwycające grafiki z postaciami.',
            twitter_title: 'AI Postać na Obraz - Twórz zdjęcia z dowolną postacią | 微鲤AI',
            twitter_description: 'Generuj zdjęcia Ciebie i ulubionych postaci. Prześlij lub wybierz postacie w 微鲤AI i twórz interaktywne grafiki.',
            faq: [
                {
                    question: 'Czym jest 微鲤AI Postać na Obraz?',
                    answer: '微鲤AI Postać na Obraz to narzędzie oparte na AI, które pozwala generować obrazy z konkretną postacią, zachowując jej spójny wygląd. Możesz przesłać własne zdjęcia postaci lub wybrać ją z naszej biblioteki.',
                },
                {
                    question: 'Czy mogę wygenerować zdjęcie siebie z postacią?',
                    answer: 'Tak. Opisz w promptcie siebie i postać oraz ich interakcję, a AI wygeneruje realistyczne lub artystyczne ujęcia.',
                },
                {
                    question: 'Ile postaci mogę wybrać?',
                    answer: '微鲤AI oferuje dużą bibliotekę postaci z anime, gier i oryginalnych projektów. Możesz też przesłać własne zdjęcia postaci, aby tworzyć unikalne interakcje.',
                },
                {
                    question: 'Czy obsługuje wysoką rozdzielczość?',
                    answer: 'Tak. Obsługujemy generowanie obrazów do 4K, aby Twoje grafiki wyglądały profesjonalnie i szczegółowo.',
                },
                {
                    question: 'Jak utrzymać spójność postaci?',
                    answer: 'Nasze modele AI analizują cechy postaci i zachowują je w generowanych obrazach, aby wyglądała tak samo jak postać referencyjna, którą wybierzesz lub prześlesz.',
                },
            ],
        },
        characterToVideo: {
            title: 'AI Postać na Wideo - Generuj interaktywne filmy z postaciami | 微鲤AI',
            description: 'Twórz niesamowite filmy z dowolną postacią AI. Prześlij zdjęcia postaci lub wybierz ją w 微鲤AI, aby generować interaktywne wideo z Tobą i postacią.',
            keywords: 'postać na wideo AI, generator wideo postaci, interaktywne wideo AI, spójność postaci, 微鲤AI',
            og_title: 'AI Postać na Wideo - Generuj interaktywne filmy z postaciami | 微鲤AI',
            og_description: 'Zamień pomysły w interaktywne filmy z postaciami AI. Prześlij lub wybierz postać w 微鲤AI i generuj realistyczny ruch.',
            twitter_title: 'AI Postać na Wideo - Interaktywne filmy z postaciami | 微鲤AI',
            twitter_description: 'Generuj wysokiej jakości filmy z ulubionymi postaciami. Prześlij lub wybierz postać w 微鲤AI i twórz interaktywne wideo.',
            page: {
                title1: 'Darmowy generator AI postać→wideo',
                title2: 'Ożyw swoje ulubione postacie! Prześlij zdjęcie postaci lub wybierz ją z biblioteki 微鲤AI, aby stworzyć interaktywne wideo. Opisz scenę w promptcie i zobacz efekt w stylu kinowym.',
                consistency: 'Wiodąca spójność postaci: nasza AI utrzymuje cechy i wygląd postaci w całej sekwencji wideo.',
                interactive: 'Twórz znaczące interakcje — od spaceru po rozmowę. Możliwości opowiadania historii są nieograniczone.',
                faq: [
                    {
                        question: 'Jak stworzyć wideo z konkretną postacią?',
                        answer: 'Prześlij zdjęcie postaci lub wybierz ją w 微鲤AI, a następnie wpisz prompt opisujący scenę lub interakcję i kliknij Utwórz.',
                    },
                    {
                        question: 'Czy mogę użyć dowolnego zdjęcia postaci?',
                        answer: 'Tak, jeśli masz prawo do użycia zdjęcia. AI animuje postać zgodnie z Twoimi instrukcjami.',
                    },
                    {
                        question: 'Czy jest limit długości wideo?',
                        answer: 'Zależy od modelu i planu, zwykle 5–10 sekund.',
                    },
                    {
                        question: 'Jak zapewnić spójny wygląd postaci?',
                        answer: 'Analizujemy obraz referencyjny i utrzymujemy stabilne cechy wizualne we wszystkich klatkach.',
                    },
                    {
                        question: 'Czy można spróbować za darmo?',
                        answer: 'Tak, możesz generować filmy z postaciami dzięki dziennym darmowym kredytom.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Czym jest 微鲤AI Postać na Wideo?',
                    answer: 'To zaawansowane narzędzie, które generuje wideo z konkretną postacią. Prześlij zdjęcie lub wybierz postać z biblioteki, aby stworzyć interaktywne treści.',
                },
                {
                    question: 'Jak działa spójność postaci w wideo?',
                    answer: 'AI wykorzystuje obraz referencyjny, aby postać pozostała rozpoznawalna i spójna przez cały klip.',
                },
                {
                    question: 'Czy mogę stworzyć wideo ze mną i postacią razem?',
                    answer: 'Tak. Opisz interakcję w promptcie, a AI wygeneruje odpowiednią scenę.',
                },
                {
                    question: 'Jakie modele są używane?',
                    answer: 'Używamy wydajnych modeli wideo, takich jak Kling i Google Veo, zoptymalizowanych pod ruch i spójność postaci.',
                },
                {
                    question: 'Jaka jest maksymalna długość?',
                    answer: 'W zależności od planu zwykle 5–10 sekund w wysokiej jakości.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Udostępnij znajomym | 微鲤AI',
            description: 'Udostępnij znajomym, zaproś znajomych do rejestracji w 微鲤AI, a Ty i Twoi znajomi otrzymacie nagrody.',
            keywords: 'social back, udostępnij znajomym, zaproś znajomych do 微鲤AI, otrzymaj nagrody, 微鲤AI',
        },
    },
    th: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI ช่วยให้คุณสร้างวิดีโอและภาพ AI จากข้อความ รูปภาพ หรือคลิปได้ทันที ทดลองใช้ฟรีวันนี้',
        home: {
            h1: '微鲤AI - แพลตฟอร์มสร้างวิดีโอและภาพ AI ฟรี',
            title: '微鲤AI - เครื่องมือสร้างวิดีโอ AI ฟรี และเครื่องมือภาพ (Kling, Flux, Veo)',
            description: 'เลิกจัดการหลายการสมัครสมาชิก เข้าถึงโมเดล AI ที่ดีที่สุดในโลก—Kling AI, Google Veo, Sora และ Flux—ทั้งหมดในแดชบอร์ดเดียว สร้างวิดีโอระดับมืออาชีพ สลับใบหน้า และอัปสเกลภาพได้ทันที',
            keywords: 'เครื่องสร้างวิดีโอ AI, เครื่องสร้างภาพ AI, ข้อความเป็นวิดีโอ, ภาพเป็นวิดีโอ, การสร้างวิดีโอ AI, การสร้างภาพ AI, สร้างวิดีโอ, สร้างภาพ, สร้างเนื้อหา AI, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - แพลตฟอร์มสร้างสรรค์ AI ครบวงจร',
            og_description: 'สร้างวิดีโอที่น่าทึ่งด้วย Kling และ Flux ข้อความเป็นวิดีโอ สลับใบหน้า และอัปสเกล ทดลองใช้ฟรี',
            twitter_title: '微鲤AI - เครื่องสร้างวิดีโอ AI ฟรี',
            twitter_description: 'เข้าถึง Kling, Veo และ Flux ในที่เดียว สร้างวิดีโอและงานศิลปะ AI ได้ทันที',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'แพลตฟอร์มสร้างสรรค์ที่ขับเคลื่อนด้วย AI ซึ่งรวมโมเดลชั้นนำอย่าง Kling AI, Google Veo, Sora และ Flux ไว้ในที่เดียว ฟีเจอร์เด่น: ข้อความเป็นวิดีโอ, สลับใบหน้า และอัปสเกล.',
            software_feature: 'เชื่อมต่อ Kling AI, ข้อความเป็นวิดีโอ, สลับใบหน้า AI, อัปสเกลวิดีโอ 4K, ภาพเป็นวิดีโอ, ซิงก์ปาก, ลบพื้นหลัง',
        },
        homePage: {
            title: 'หน้าแรก | 微鲤AI',
            description: 'สร้างวิดีโอและภาพ AI จากข้อความ รูปภาพ หรือคลิปด้วย 微鲤AI — ลองใช้ฟรีวันนี้',
            keywords: 'AI วิดีโอ, AI ภาพ, 微鲤AI',
        },
        aiTools: {
            title: 'ชุดเครื่องมือแก้ไข - รวมเครื่องมือ AI ชั้นนำทั้งหมด | 微鲤AI',
            description: 'สำรวจเครื่องมือ AI ชั้นนำสำหรับวิดีโอและภาพทั้งหมดในที่เดียว',
            keywords: 'เครื่องมือ AI, เครื่องมือวิดีโอ, เครื่องมือภาพ, 微鲤AI',
        },
        myCreations: {
            title: 'ผลงานของฉัน | 微鲤AI',
            description: 'ดูผลงานทั้งหมดของคุณ ทั้งวิดีโอและภาพ จัดการผลงานด้วย 微鲤AI',
            keywords: 'ผลงานของฉัน, 微鲤AI',
        },
        aiImage: {
            title: 'เครื่องมือสร้างภาพ AI - สร้างภาพสวยด้วย AI | 微鲤AI',
            description: 'สร้างภาพ AI คุณภาพระดับมืออาชีพด้วย 微鲤AI แปลงข้อความเป็นภาพ สร้างภาพสร้างสรรค์ และปลดล็อกจินตนาการด้วยเทคโนโลยี AI ขั้นสูง',
            keywords: 'เครื่องมือสร้างภาพ AI, ข้อความเป็นภาพ, ศิลปะ AI, การสร้างภาพ, ภาพถ่าย AI, เครื่องมือสร้างงานศิลป์ดิจิทัล',
        },
        aiVideo: {
            title: 'เครื่องมือสร้างวิดีโอ AI - สร้างวิดีโอที่น่าทึ่งด้วย AI | 微鲤AI',
            description: 'สร้างวิดีโอ AI ที่น่าทึ่งด้วย 微鲤AI สร้างวิดีโอจากข้อความ ภาพ หรือวิดีโอ',
            keywords: 'เครื่องมือสร้างวิดีโอ AI, ข้อความเป็นวิดีโอ, การสร้างวิดีโอ, 微鲤AI',
        },
        aiMusic: {
            title: 'สร้างเพลง AI - เพลงร้อง/ดนตรีประกอบได้ทันที | 微鲤AI',
            description: 'สร้างเพลง AI อย่างรวดเร็วที่ 微鲤AI: รองรับเพลงร้องและดนตรีบรรเลง ค้นพบหลากหลายสไตล์',
            keywords: 'เครื่องมือสร้างเพลง AI, ข้อความเป็นเพลง, 微鲤AI',
        },
        pricing: {
            title: 'แผนและราคา | 微鲤AI – การสมัครสมาชิกสร้างภาพและวิดีโอ AI',
            description: 'สำรวจแผนราคาที่ยืดหยุ่นของ 微鲤AI สำหรับการสร้างภาพและวิดีโอ AI รับเครดิตรายเดือนเพิ่มขึ้น การประมวลผลลำดับความสำคัญ และการเข้าถึงโมเดล AI ขั้นสูง',
            keywords: 'ราคา 微鲤AI, ราคาเครื่องสร้าง AI, แผนการสมัครสมาชิก AI, เครดิต AI, ราคาสร้างภาพ, ราคาสร้างวิดีโอ',
            og_title: 'ราคา 微鲤AI – แผนสร้างภาพและวิดีโอ AI',
            og_description: 'เลือกแผนสร้างภาพและวิดีโอ AI ที่ดีที่สุด เครดิตฟรี ฟีเจอร์ Pro และการเข้าถึงลำดับความสำคัญ',
            twitter_title: 'ราคา 微鲤AI – แผน AI ที่ยืดหยุ่นและเครดิต',
            twitter_description: 'เลือกแผนที่เหมาะสมสำหรับการสร้างภาพและวิดีโอ AI',
        },
        faq: {
            title: 'คำถามที่พบบ่อย | 微鲤AI',
            description: 'ค้นหาคำตอบสำหรับคำถามที่พบบ่อยเกี่ยวกับเครื่องมือวิดีโอและภาพของ 微鲤AI',
            keywords: 'FAQ, ศูนย์ช่วยเหลือ, 微鲤AI',
        },
        aboutUs: {
            title: 'เกี่ยวกับเรา | แพลตฟอร์มสร้างสรรค์ 微鲤AI',
            description: 'เรียนรู้เกี่ยวกับภารกิจของ 微鲤AI ในการมอบเครื่องมือ AI ชั้นนำให้กับนักสร้างสรรค์ทั่วโลก',
            keywords: 'เกี่ยวกับ 微鲤AI, ข้อมูลบริษัท, 微鲤AI',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'โมเดลวิดีโอ AI - รวมโมเดลยอดนิยม Veo, Sora, Kling AI | 微鲤AI',
            description: 'สำรวจโมเดลวิดีโอ AI ชั้นนำของโลก รวมถึง Kling, Sora, Google Veo และอื่นๆ',
            keywords: 'โมเดลวิดีโอ AI, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'โมเดลภาพ AI - รวมโมเดลชั้นนำ FLUX, Nano Banana, Imagen | 微鲤AI',
            description: 'เข้าถึงโมเดลภาพ AI ชั้นนำ เช่น FLUX, Nano Banana และ Imagen เพื่อสร้างงานศิลปะคุณภาพสูง',
            keywords: 'โมเดลภาพ AI, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'รายละเอียดภาพที่สร้างโดย AI | 微鲤AI',
            description: 'ดูรายละเอียด พรอมต์ และพารามิเตอร์ของภาพที่สร้างโดย AI',
            keywords: 'รายละเอียดภาพ AI, พารามิเตอร์ภาพ, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'รายละเอียดวิดีโอที่สร้างโดย AI | 微鲤AI',
            description: 'ดูรายละเอียด พรอมต์ และพารามิเตอร์การผลิตของวิดีโอที่สร้างโดย AI',
            keywords: 'รายละเอียดวิดีโอ AI, พารามิเตอร์วิดีโอ, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'รายละเอียดเพลงที่สร้างโดย AI | 微鲤AI',
            description: 'ดูสไตล์ เนื้อเพลง และรายละเอียดการสร้างของเพลงที่สร้างโดย AI',
            keywords: 'รายละเอียดเพลง AI, พารามิเตอร์เพลง, 微鲤AI',
        },
        characters: {
            title: 'การสร้างตัวละคร AI - สร้างตัวละครเสมือนที่มีความสม่ำเสมอ | 微鲤AI',
            description: 'ใช้ AI สร้างตัวละครเสมือนที่มีความสม่ำเสมอสำหรับการเล่าเรื่องและการสร้างวิดีโอ',
            keywords: 'ตัวละคร AI, ตัวละครเสมือน, ความสม่ำเสมอของตัวละคร, 微鲤AI',
        },
        characterToImage: {
            title: 'AI ตัวละครเป็นภาพ - สร้างรูปกับตัวละครใดก็ได้ | 微鲤AI',
            description: 'อัปโหลดรูปตัวละครของคุณหรือเลือกจากแพลตฟอร์ม 微鲤AI เพื่อสร้างภาพคุณและตัวละครร่วมกันคุณภาพสูงด้วย AI พร้อมรักษาความสม่ำเสมอของตัวละคร',
            keywords: 'ตัวละครเป็นภาพ ai, ความสม่ำเสมอตัวละคร, เครื่องมือสร้างตัวละคร ai, ภาพโต้ตอบกับตัวละคร, 微鲤AI',
            og_title: 'AI ตัวละครเป็นภาพ - สร้างรูปกับตัวละครใดก็ได้ | 微鲤AI',
            og_description: 'สร้างภาพโต้ตอบคุณภาพสูงกับตัวละคร AI ใดก็ได้ อัปโหลดตัวละครของคุณหรือเลือกจาก 微鲤AI เพื่อสร้างภาพตัวละครที่น่าทึ่ง',
            twitter_title: 'AI ตัวละครเป็นภาพ - สร้างรูปกับตัวละครใดก็ได้ | 微鲤AI',
            twitter_description: 'สร้างภาพคุณกับตัวละครโปรดของคุณ อัปโหลดหรือเลือกตัวละครบน 微鲤AI เพื่อสร้างงานศิลป์ตัวละครแบบอินเทอร์แอคทีฟ',
            faq: [
                {
                    question: '微鲤AI ตัวละครเป็นภาพคืออะไร?',
                    answer: '微鲤AI ตัวละครเป็นภาพคือเครื่องมือที่ขับเคลื่อนด้วย AI ซึ่งช่วยให้คุณสร้างภาพที่มีตัวละครเฉพาะโดยคงความสม่ำเสมอของรูปลักษณ์ คุณสามารถอัปโหลดรูปตัวละครของคุณเองหรือเลือกจากไลบรารีของเราได้',
                },
                {
                    question: 'ฉันสามารถสร้างรูปฉันกับตัวละครได้ไหม?',
                    answer: 'ได้ เพียงอธิบายตัวคุณและตัวละคร รวมถึงการโต้ตอบในพรอมต์ AI จะสร้างภาพแบบสมจริงหรือแนวศิลป์ให้คุณ',
                },
                {
                    question: 'มีตัวละครให้เลือกกี่แบบ?',
                    answer: '微鲤AI มีไลบรารีตัวละครจำนวนมากจากอนิเมะ เกม และงานออกแบบต้นฉบับ คุณยังสามารถอัปโหลดรูปตัวละครของคุณเองเพื่อสร้างการโต้ตอบที่ไม่ซ้ำใคร',
                },
                {
                    question: 'รองรับความละเอียดสูงไหม?',
                    answer: 'รองรับ เราสนับสนุนการสร้างภาพความละเอียดสูงถึง 4K เพื่อให้ภาพตัวละครของคุณคมชัดและมีรายละเอียด',
                },
                {
                    question: 'ทำอย่างไรให้ตัวละครคงความสม่ำเสมอ?',
                    answer: 'โมเดล AI ของเราได้รับการฝึกให้จดจำและรักษาเอกลักษณ์ของตัวละคร เพื่อให้ภาพที่สร้างขึ้นสอดคล้องกับตัวละครอ้างอิงที่คุณเลือกหรืออัปโหลด',
                },
            ],
        },
        characterToVideo: {
            title: 'AI ตัวละครเป็นวิดีโอ - สร้างวิดีโอแบบอินเทอร์แอคทีฟ | 微鲤AI',
            description: 'สร้างวิดีโอสุดน่าทึ่งกับตัวละคร AI ได้ทุกแบบ อัปโหลดรูปตัวละครหรือเลือกจาก 微鲤AI เพื่อสร้างวิดีโออินเทอร์แอคทีฟที่คุณและตัวละครอยู่ด้วยกัน',
            keywords: 'ตัวละครเป็นวิดีโอ ai, เครื่องมือสร้างวิดีโอตัวละคร, วิดีโอ AI อินเทอร์แอคทีฟ, ความสม่ำเสมอตัวละคร, 微鲤AI',
            og_title: 'AI ตัวละครเป็นวิดีโอ - สร้างวิดีโอแบบอินเทอร์แอคทีฟ | 微鲤AI',
            og_description: 'เปลี่ยนไอเดียให้เป็นวิดีโออินเทอร์แอคทีฟกับตัวละคร AI อัปโหลดหรือเลือกตัวละครบน 微鲤AI แล้วสร้างการเคลื่อนไหวที่สมจริง',
            twitter_title: 'AI ตัวละครเป็นวิดีโอ - สร้างวิดีโอแบบอินเทอร์แอคทีฟ | 微鲤AI',
            twitter_description: 'สร้างวิดีโอคุณภาพสูงกับตัวละครโปรดของคุณ อัปโหลดหรือเลือกตัวละครบน 微鲤AI เพื่อสร้างวิดีโอ AI แบบอินเทอร์แอคทีฟ',
            page: {
                title1: 'เครื่องมือสร้าง “ตัวละคร→วิดีโอ” ด้วย AI ฟรี',
                title2: 'ทำให้ตัวละครโปรดของคุณมีชีวิต! อัปโหลดรูปตัวละครหรือเลือกจากไลบรารี 微鲤AI เพื่อสร้างวิดีโออินเทอร์แอคทีฟสุดอลังการ เพียงอธิบายฉากและการโต้ตอบในพรอมต์ แล้วดูผลลัพธ์แบบภาพยนตร์',
                consistency: 'ความสม่ำเสมอตัวละครระดับแนวหน้า: AI ของเรารักษาเอกลักษณ์และรูปลักษณ์ของตัวละครตลอดทั้งวิดีโอ',
                interactive: 'สร้างการโต้ตอบที่มีความหมาย ตั้งแต่เดินเล่นด้วยกันไปจนถึงบทสนทนา ความเป็นไปได้ในการเล่าเรื่องไม่มีที่สิ้นสุด',
                faq: [
                    {
                        question: 'จะสร้างวิดีโอกับตัวละครเฉพาะได้อย่างไร?',
                        answer: 'อัปโหลดรูปตัวละครหรือเลือกจาก 微鲤AI จากนั้นพิมพ์พรอมต์อธิบายฉาก/การโต้ตอบ แล้วกดสร้าง',
                    },
                    {
                        question: 'ใช้รูปตัวละครอะไรก็ได้ไหม?',
                        answer: 'ได้ หากคุณมีสิทธิ์ใช้งานรูปนั้น AI จะทำให้ตัวละครเคลื่อนไหวตามคำสั่งของคุณ',
                    },
                    {
                        question: 'มีข้อจำกัดเรื่องความยาววิดีโอไหม?',
                        answer: 'ขึ้นอยู่กับโมเดลและแพ็กเกจ โดยทั่วไปอยู่ที่ประมาณ 5–10 วินาที',
                    },
                    {
                        question: 'ทำอย่างไรให้ตัวละครดูคงที่สม่ำเสมอ?',
                        answer: 'เราใช้ภาพอ้างอิงเพื่อคงลักษณะเด่นของตัวละครให้เสถียรในทุกเฟรม',
                    },
                    {
                        question: 'ทดลองฟรีได้ไหม?',
                        answer: 'ได้ คุณสามารถใช้เครดิตฟรีรายวันเพื่อสร้างวิดีโอตัวละครได้',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI ตัวละครเป็นวิดีโอคืออะไร?',
                    answer: 'เป็นเครื่องมือ AI ขั้นสูงที่สร้างวิดีโอโดยมีตัวละครเฉพาะ คุณสามารถอัปโหลดรูปหรือเลือกจากไลบรารีเพื่อสร้างวิดีโอแบบอินเทอร์แอคทีฟได้',
                },
                {
                    question: 'ความสม่ำเสมอตัวละครในวิดีโอทำงานอย่างไร?',
                    answer: 'AI ใช้ภาพอ้างอิงเพื่อติดตามลักษณะเด่น ทำให้ตัวละครดูเหมือนเดิมและจดจำได้ตลอดคลิป',
                },
                {
                    question: 'ทำวิดีโอที่มีฉันกับตัวละครอยู่ด้วยกันได้ไหม?',
                    answer: 'ได้ เพียงอธิบายการโต้ตอบในพรอมต์ แล้ว AI จะสร้างฉากตามนั้น',
                },
                {
                    question: 'ใช้โมเดลอะไรในการสร้างวิดีโอ?',
                    answer: 'เราใช้โมเดลวิดีโอประสิทธิภาพสูง เช่น Kling และ Google Veo พร้อมการปรับแต่งเพื่อความสมจริงและความสม่ำเสมอของตัวละคร',
                },
                {
                    question: 'สร้างได้ยาวสุดกี่วินาที?',
                    answer: 'ขึ้นอยู่กับแพ็กเกจ โดยทั่วไปประมาณ 5–10 วินาทีในคุณภาพสูง',
                },
            ],
        },
        social_back: {
            title: 'Social Back - แชร์กับเพื่อน | 微鲤AI',
            description: 'แชร์กับเพื่อน ชวนเพื่อนมาสมัคร 微鲤AI คุณและเพื่อนจะได้รับรางวัล',
            keywords: 'social back, แชร์กับเพื่อน, ชวนเพื่อนสมัคร 微鲤AI, รับรางวัล, 微鲤AI',
        },
    },
    da: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI lader dig skabe AI-videoer og billeder øjeblikkeligt fra tekst, fotos eller klip. Prøv det gratis i dag.',
        home: {
            h1: '微鲤AI - Gratis AI Video & Billede Generator Platform',
            title: '微鲤AI - Gratis AI Video Generator & Billedværktøjer (Kling, Flux, Veo)',
            description: 'Stop med at jonglere med abonnementer. Få adgang til verdens bedste AI-modeller—Kling AI, Google Veo, Sora og Flux—alt i ét gratis dashboard. Opret professionelle videoer, skift ansigter og opskaler billeder øjeblikkeligt.',
            keywords: 'AI video generator, AI billede generator, tekst til video, billede til video, AI video oprettelse, AI billede oprettelse, video generering, billede generering, AI indhold oprettelse, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - Den alt-i-én AI kreative platform',
            og_description: 'Generer fantastiske videoer med Kling & Flux. Tekst-til-Video, Face Swap og Upscaling værktøjer. Prøv det gratis.',
            twitter_title: '微鲤AI - Gratis AI Video Generator',
            twitter_description: 'Få adgang til Kling, Veo og Flux ét sted. Generer AI video & kunst øjeblikkeligt.',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'En AI-drevet kreativ platform, der fungerer som en aggregator for topmodeller som Kling AI, Google Veo, Sora og Flux. Funktioner inkluderer Text-to-Video, Face Swap og Upscaling.',
            software_feature: 'Kling AI-integration, tekst til video, AI Face Swap, 4K video upscaler, billede til video, lip sync, baggrundsfjerner',
        },
        homePage: {
            title: 'Hjem - Alt-i-en AI-video- og billedplatform | 微鲤AI',
            description: 'Brug 微鲤AI til at skabe fantastiske AI-videoer og billeder fra tekst, fotos eller klip.',
            keywords: 'homePage, AI, 微鲤AI',
        },
        aiTools: {
            title: 'Redigeringsværktøjer - Samling af alle top AI-værktøjer | 微鲤AI',
            description: 'Udforsk samlingen af de bedste AI-værktøjer til video- og billedgenerering. Skab imponerende videoer og billeder med avanceret AI-teknologi.',
            keywords: 'AI værktøjer, video genereringsværktøjer, billede genereringsværktøjer, AI video værktøjer, AI billede værktøjer, 微鲤AI',
        },
        myCreations: {
            title: 'Mine kreationer | 微鲤AI',
            description: 'Se alle dine kreationer, inklusive videoer og billeder. Administrer dine kreationer med 微鲤AI.',
            keywords: 'mine kreationer, video creation, billed creation, 微鲤AI',
        },
        aiImage: {
            title: 'AI Billedgenerator - Skab flotte billeder med AI | 微鲤AI',
            description: 'Skab professionelle AI-genererede billeder med 微鲤AI. Forvandl tekst til kunst.',
            keywords: 'AI billedgenerator, tekst til billede, AI kunst, 微鲤AI',
        },
        aiVideo: {
            title: 'AI Videogenerator - Skab fantastiske videoer med AI | 微鲤AI',
            description: 'Generer fantastiske AI-videoer med 微鲤AI. Understøtter tekst til video og billede til video.',
            keywords: 'AI videogenerator, tekst til video, video creation, 微鲤AI',
        },
        aiMusic: {
            title: 'AI Musikgenerator - Vokal- og instrumentale tracks | 微鲤AI',
            description: 'Generer hurtigt AI-musik på 微鲤AI: understøtter vokale sange og instrumental musik.',
            keywords: 'AI musikgenerator, tekst til musik, 微鲤AI',
        },
        pricing: {
            title: 'Planer & Priser | 微鲤AI – AI Billede & Video Generering Abonnement',
            description: 'Udforsk WeryAIs fleksible prisplaner for AI billede og video generering. Få flere månedlige kreditter, prioriteret behandling og adgang til avancerede AI-modeller.',
            keywords: '微鲤AI priser, AI generator priser, AI abonnementsplaner, AI kreditter, billede generering priser, video generering priser',
            og_title: '微鲤AI Priser – AI Billede & Video Generering Planer',
            og_description: 'Vælg den bedste AI billede og video generering plan. Gratis kreditter, Pro funktioner og prioriteret adgang.',
            twitter_title: '微鲤AI Priser – Fleksible AI Planer & Kreditter',
            twitter_description: 'Vælg den rigtige plan til AI billede og video generering.',
        },
        faq: {
            title: 'Ofte stillede spørgsmål | 微鲤AI',
            description: 'Find svar på ofte stillede spørgsmål om WeryAIs video- og billedværktøjer.',
            keywords: 'FAQ, hjælp, 微鲤AI',
        },
        aboutUs: {
            title: 'Om os | 微鲤AI kreativ platform',
            description: 'Lær om WeryAIs mission om at levere top AI-værktøjer til kreative over hele verden.',
            keywords: 'om 微鲤AI, virksomhedsinformation, 微鲤AI',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'AI Videomodeller - Samling af Veo, Sora, Kling AI & mere | 微鲤AI',
            description: 'Udforsk verdens førende AI-videomodeller, herunder Kling, Sora, Google Veo osv.',
            keywords: 'AI videomodeller, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'AI Billedmodeller - Samling af FLUX, Nano Banana, Imagen | 微鲤AI',
            description: 'Adgang til førende AI-billedmodeller som FLUX, Nano Banana og Imagen.',
            keywords: 'AI billedmodeller, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'Detaljer for AI-genereret billede | 微鲤AI',
            description: 'Se detaljer, prompts og parametre for AI-genererede billeder.',
            keywords: 'AI billeddetaljer, billedparametre, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Detaljer for AI-genereret video | 微鲤AI',
            description: 'Se detaljer, prompts og produktionsparametre for AI-genererede videoer.',
            keywords: 'AI videodetaljer, videoparametre, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Detaljer for AI-genereret musik | 微鲤AI',
            description: 'Se stil, tekst og kreationsdetaljer for AI-genereret musik.',
            keywords: 'AI musikdetaljer, musikparametre, 微鲤AI',
        },
        characters: {
            title: 'AI Karakter skabelse - Byg konsistente virtuelle karakterer | 微鲤AI',
            description: 'Brug AI til at skabe konsistente virtuelle karakterer til historier og videoer.',
            keywords: 'AI karakterer, virtuelle karakterer, karakterkonsistens, 微鲤AI',
        },
        characterToImage: {
            title: 'AI Karakter til Billede - Skab fotos med enhver karakter | 微鲤AI',
            description: 'Upload dine egne karakterfotos eller vælg fra 微鲤AI-platformen for at generere billeder i høj kvalitet af dig og karakteren sammen med AI—med stabil karakterkonsistens.',
            keywords: 'AI karakter til billede, karakterkonsistens, AI karaktergenerator, interaktive karakterfotos, 微鲤AI karakter',
            og_title: 'AI Karakter til Billede - Skab fotos med enhver karakter | 微鲤AI',
            og_description: 'Skab interaktive fotos i høj kvalitet med enhver AI-karakter. Upload din egen karakter eller vælg fra 微鲤AI for at generere imponerende karakterbilleder.',
            twitter_title: 'AI Karakter til Billede - Skab fotos med enhver karakter | 微鲤AI',
            twitter_description: 'Generér fotos af dig og dine yndlingskarakterer. Upload eller vælg karakterer på 微鲤AI og skab interaktiv karakterkunst.',
            faq: [
                {
                    question: 'Hvad er 微鲤AI Karakter til Billede?',
                    answer: '微鲤AI Karakter til Billede er et AI-værktøj, der lader dig generere billeder med bestemte karakterer og bevare deres visuelle konsistens. Du kan uploade dine egne karakterfotos eller vælge fra vores bibliotek.',
                },
                {
                    question: 'Kan jeg lave billeder af mig selv med en karakter?',
                    answer: 'Ja. Beskriv dig selv og karakteren i prompten, så kan AI generere realistiske eller kunstneriske billeder af jer sammen.',
                },
                {
                    question: 'Hvor mange karakterer kan jeg vælge imellem?',
                    answer: '微鲤AI tilbyder et stort bibliotek af karakterer fra anime, spil og originale designs. Du kan også uploade dine egne for unikke interaktioner.',
                },
                {
                    question: 'Understøtter det høj opløsning?',
                    answer: 'Ja. Vi understøtter op til 4K billedgenerering, så dine karakterbilleder bliver skarpe og detaljerede.',
                },
                {
                    question: 'Hvordan bevarer jeg karakterkonsistens?',
                    answer: 'Vores AI-modeller er trænet til at genkende og bevare karaktertræk, så de genererede billeder matcher referencekarakteren, du valgte eller uploadede.',
                },
            ],
        },
        characterToVideo: {
            title: 'AI Karakter til Video - Skab interaktive karaktervideoer | 微鲤AI',
            description: 'Skab fantastiske videoer med enhver AI-karakter. Upload karakterfotos eller vælg en på 微鲤AI for at generere interaktive videoer af dig og karakteren sammen.',
            keywords: 'AI karakter til video, karaktervideo generator, interaktiv AI video, karakterkonsistens, 微鲤AI',
            og_title: 'AI Karakter til Video - Skab interaktive karaktervideoer | 微鲤AI',
            og_description: 'Gør dine idéer til interaktive videoer med AI-karakterer. Upload eller vælg karakterer på 微鲤AI og generér realistisk bevægelse.',
            twitter_title: 'AI Karakter til Video - Skab interaktive karaktervideoer | 微鲤AI',
            twitter_description: 'Generér videoer i høj kvalitet med dine yndlingskarakterer. Upload eller vælg på 微鲤AI og skab interaktive AI-videoer.',
            page: {
                title1: 'Gratis AI karakter→video generator',
                title2: 'Gør dine yndlingskarakterer levende! Upload et foto af en karakter eller vælg fra WeryAI’s bibliotek for at skabe imponerende interaktive videoer. Beskriv scenen i din prompt og se et filmisk resultat.',
                consistency: 'Brancheførende karakterkonsistens: Vores AI bevarer karakterens unikke træk og udseende gennem hele videoen.',
                interactive: 'Skab meningsfulde interaktioner – fra en gåtur i parken til en samtale. Mulighederne for historiefortælling er uendelige.',
                faq: [
                    {
                        question: 'Hvordan laver jeg en video med en specifik karakter?',
                        answer: 'Upload et foto af karakteren eller vælg en på 微鲤AI. Skriv derefter en prompt, der beskriver scenen eller interaktionen, og generér.',
                    },
                    {
                        question: 'Kan jeg bruge ethvert karakterfoto?',
                        answer: 'Ja, hvis du har rettighederne til at bruge det. AI animerer karakteren efter dine instruktioner.',
                    },
                    {
                        question: 'Er der en grænse for videolængden?',
                        answer: 'Det afhænger af modellen og din plan, typisk 5–10 sekunder.',
                    },
                    {
                        question: 'Hvordan sikrer jeg karakterkonsistens?',
                        answer: 'Vi analyserer referencebilledet og holder visuelle træk stabile på tværs af alle frames.',
                    },
                    {
                        question: 'Kan jeg prøve det gratis?',
                        answer: 'Ja, du kan generere karaktervideoer med dine daglige gratis credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvad er 微鲤AI Karakter til Video?',
                    answer: 'Det er et avanceret værktøj, der genererer videoer med en specifik karakter. Upload et foto eller vælg fra biblioteket for at skabe interaktivt indhold.',
                },
                {
                    question: 'Hvordan fungerer karakterkonsistens i video?',
                    answer: 'AI bruger referencebilledet til at holde karakterens udseende stabilt og genkendeligt gennem hele klippet.',
                },
                {
                    question: 'Kan jeg lave en video af mig og en karakter sammen?',
                    answer: 'Ja. Beskriv interaktionen i prompten, og AI genererer scenen derefter.',
                },
                {
                    question: 'Hvilke modeller bruges?',
                    answer: 'Vi bruger højtydende videomodeller som Kling og Google Veo, optimeret til realistisk bevægelse og konsistens.',
                },
                {
                    question: 'Hvad er den maksimale varighed?',
                    answer: 'Afhænger af din plan, typisk 5–10 sekunder i høj kvalitet.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Del med venner | 微鲤AI',
            description: 'Del med venner, inviter venner til at registrere sig på 微鲤AI, og du og dine venner vil modtage belønninger.',
            keywords: 'social back, del med venner, inviter venner til 微鲤AI, modtag belønninger, 微鲤AI',
        },
    },
    no: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI lar deg lage AI-videoer og bilder umiddelbart fra tekst, bilder eller klipp. Prøv det gratis i dag.',
        home: {
            h1: '微鲤AI - Gratis AI Video & Bilde Generator Plattform',
            title: '微鲤AI - Gratis AI Video Generator & Bildeverktøy (Kling, Flux, Veo)',
            description: 'Slutt å sjonglere med abonnementer. Få tilgang til verdens beste AI-modeller—Kling AI, Google Veo, Sora og Flux—alt i ett gratis dashbord. Lag profesjonelle videoer, bytt ansikter og oppskaler bilder umiddelbart.',
            keywords: 'AI video generator, AI bilde generator, tekst til video, bilde til video, AI video opprettelse, AI bilde opprettelse, video generering, bilde generering, AI innhold opprettelse, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - Den alt-i-ett AI kreative plattformen',
            og_description: 'Generer fantastiske videoer med Kling & Flux. Tekst-til-Video, Face Swap og Upscaling verktøy. Prøv det gratis.',
            twitter_title: '微鲤AI - Gratis AI Video Generator',
            twitter_description: 'Få tilgang til Kling, Veo og Flux på ett sted. Generer AI video & kunst umiddelbart.',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'En AI-drevet kreativ plattform som samler toppmodeller som Kling AI, Google Veo, Sora og Flux. Funksjoner inkluderer tekst-til-video, Face Swap og oppskalering.',
            software_feature: 'Kling AI-integrasjon, tekst til video, AI Face Swap, 4K videooppskalering, bilde til video, lip sync, bakgrunnsfjerner',
        },
        homePage: {
            title: 'Hjem - Alt-i-en AI-video- og bildeplattform | 微鲤AI',
            description: 'Bruk 微鲤AI for å lage fantastiske AI-videoer og bilder fra tekst, bilder eller klipp.',
            keywords: 'homePage, AI, 微鲤AI',
        },
        aiTools: {
            title: 'Redigeringsverktøy - Samling av alle topp AI-verktøy | 微鲤AI',
            description: 'Utforsk alle de beste AI-verktøyene for video og bilde på ett sted.',
            keywords: 'AI verktøy, video verktøy, bilde verktøy, 微鲤AI',
        },
        myCreations: {
            title: 'Mine kreasjoner | 微鲤AI',
            description: 'Se alle kreasjonene dine, inkludert videoer og bilder. Administrer kreasjonene dine med 微鲤AI.',
            keywords: 'mine kreasjoner, video creation, bilde creation, 微鲤AI',
        },
        aiImage: {
            title: 'AI Bildegenerator - Lag flotte bilder med AI | 微鲤AI',
            description: 'Lag profesjonelle AI-genererte bilder med 微鲤AI. Forvandle tekst til kunst.',
            keywords: 'AI bildegenerator, tekst til bilde, AI kunst, 微鲤AI',
        },
        aiVideo: {
            title: 'AI Videogenerator - Lag fantastiske videoer med AI | 微鲤AI',
            description: 'Generer fantastiske AI-videoer med 微鲤AI. Støtter tekst til video og bilde til video.',
            keywords: 'AI videogenerator, tekst til video, video creation, 微鲤AI',
        },
        aiMusic: {
            title: 'AI Musikkgenerator - Vokal- og instrumentale spor | 微鲤AI',
            description: 'Generer raskt AI-musikk på 微鲤AI: støtter vokale sanger og instrumental musikk.',
            keywords: 'AI musikkgenerator, tekst til musikk, 微鲤AI',
        },
        pricing: {
            title: 'Planer & Priser | 微鲤AI – AI Bilde & Video Generering Abonnement',
            description: 'Utforsk WeryAIs fleksible prisplaner for AI bilde og video generering. Få flere månedlige kreditter, prioritert behandling og tilgang til avanserte AI-modeller.',
            keywords: '微鲤AI priser, AI generator priser, AI abonnementsplaner, AI kreditter, bilde generering priser, video generering priser',
            og_title: '微鲤AI Priser – AI Bilde & Video Generering Planer',
            og_description: 'Velg den beste AI bilde og video generering planen. Gratis kreditter, Pro funksjoner og prioritert tilgang.',
            twitter_title: '微鲤AI Priser – Fleksible AI Planer & Kreditter',
            twitter_description: 'Velg riktig plan for AI bilde og video generering.',
        },
        faq: {
            title: 'Ofte stilte spørsmål | 微鲤AI',
            description: 'Finn svar på ofte stilte spørsmål om WeryAIs video- og bildeverktøy.',
            keywords: 'FAQ, hjelp, 微鲤AI',
        },
        aboutUs: {
            title: 'Om oss | 微鲤AI kreativ plattform',
            description: 'Lær om WeryAIs misjon om å levere de beste AI-verktøyene til skapere over hele verden.',
            keywords: 'om 微鲤AI, bedriftsinformasjon, 微鲤AI',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'AI Videomodeller - Samling av Veo, Sora, Kling AI og mer | 微鲤AI',
            description: 'Utforsk verdens ledende AI-videomodeller, inkludert Kling, Sora, Google Veo osv.',
            keywords: 'AI videomodeller, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'AI Bildemodeller - Samling av FLUX, Nano Banana, Imagen og mer | 微鲤AI',
            description: 'Tilgang til ledende AI-bildemodeller som FLUX, Nano Banana og Imagen.',
            keywords: 'AI bildemodeller, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'Detaljer for AI-generert bilde | 微鲤AI',
            description: 'Se detaljer, ledetekster og parametere for AI-genererte bilder.',
            keywords: 'AI bildedetaljer, bildeparametere, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Detaljer for AI-generert video | 微鲤AI',
            description: 'Se detaljer, ledetekster og produksjonsparametere for AI-genererte videoer.',
            keywords: 'AI videodetaljer, videoparametere, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Detaljer for AI-generert musikk | 微鲤AI',
            description: 'Se stil, tekst og kreasjonsdetaljer for AI-generert musikk.',
            keywords: 'AI musikkdetaljer, musikkparametere, 微鲤AI',
        },
        characters: {
            title: 'AI Karakter skapelse - Bygg konsistente virtuelle karakterer | 微鲤AI',
            description: 'Bruk AI til å skape konsistente virtuelle karakterer for historier og videoer.',
            keywords: 'AI karakterer, virtuelle karakterer, karakterkonsistens, 微鲤AI',
        },
        characterToImage: {
            title: 'AI Karakter til Bilde - Lag bilder med hvilken som helst karakter | 微鲤AI',
            description: 'Last opp dine egne karakterbilder eller velg fra 微鲤AI-plattformen for å generere bilder i høy kvalitet av deg og karakteren sammen med AI—med stabil karakterkonsistens.',
            keywords: 'AI karakter til bilde, karakterkonsistens, AI karaktergenerator, interaktive karakterbilder, 微鲤AI karakter',
            og_title: 'AI Karakter til Bilde - Lag bilder med hvilken som helst karakter | 微鲤AI',
            og_description: 'Lag interaktive bilder i høy kvalitet med hvilken som helst AI-karakter. Last opp din egen karakter eller velg fra 微鲤AI for å generere imponerende karakterbilder.',
            twitter_title: 'AI Karakter til Bilde - Lag bilder med hvilken som helst karakter | 微鲤AI',
            twitter_description: 'Generer bilder av deg og favorittkarakterene dine. Last opp eller velg karakterer på 微鲤AI og lag interaktiv karakterkunst.',
            faq: [
                {
                    question: 'Hva er 微鲤AI Karakter til Bilde?',
                    answer: '微鲤AI Karakter til Bilde er et AI-verktøy som lar deg generere bilder med bestemte karakterer samtidig som du bevarer deres visuelle konsistens. Du kan laste opp egne karakterbilder eller velge fra biblioteket vårt.',
                },
                {
                    question: 'Kan jeg generere bilder av meg selv med en karakter?',
                    answer: 'Ja. Beskriv deg selv og karakteren i prompten, så kan AI generere realistiske eller kunstneriske bilder av dere sammen.',
                },
                {
                    question: 'Hvor mange karakterer kan jeg velge mellom?',
                    answer: '微鲤AI har et stort bibliotek med karakterer fra anime, spill og originale design. Du kan også laste opp egne karakterbilder for unike interaksjoner.',
                },
                {
                    question: 'Støtter det høy oppløsning?',
                    answer: 'Ja. Vi støtter opptil 4K bildegenerering for profesjonelle og detaljerte resultater.',
                },
                {
                    question: 'Hvordan opprettholder jeg karakterkonsistens?',
                    answer: 'Våre AI-modeller er trent til å gjenkjenne og bevare karaktertrekk, slik at de genererte bildene matcher referansekarakteren du valgte eller lastet opp.',
                },
            ],
        },
        characterToVideo: {
            title: 'AI Karakter til Video - Lag interaktive karaktervideoer | 微鲤AI',
            description: 'Lag fantastiske videoer med hvilken som helst AI-karakter. Last opp karakterbilder eller velg fra 微鲤AI for å generere interaktive videoer av deg og karakteren sammen.',
            keywords: 'AI karakter til video, karaktervideo generator, interaktiv AI video, karakterkonsistens, 微鲤AI',
            og_title: 'AI Karakter til Video - Lag interaktive karaktervideoer | 微鲤AI',
            og_description: 'Gjør idéene dine om til interaktive videoer med AI-karakterer. Last opp eller velg karakterer på 微鲤AI og generer realistisk bevegelse.',
            twitter_title: 'AI Karakter til Video - Lag interaktive karaktervideoer | 微鲤AI',
            twitter_description: 'Generer videoer i høy kvalitet med favorittkarakterene dine. Last opp eller velg på 微鲤AI og lag interaktive AI-videoer.',
            page: {
                title1: 'Gratis AI karakter→video generator',
                title2: 'Gi liv til favorittkarakterene dine! Last opp et bilde av en karakter eller velg fra 微鲤AI-biblioteket for å lage imponerende interaktive videoer. Beskriv scenen i prompten og se et filmatisk resultat.',
                consistency: 'Bransjeledende karakterkonsistens: Vår AI bevarer karakterens unike trekk og utseende gjennom hele videoen.',
                interactive: 'Skap meningsfulle interaksjoner – fra å gå sammen i en park til en samtale. Mulighetene er uendelige.',
                faq: [
                    {
                        question: 'Hvordan lager jeg en video med en spesifikk karakter?',
                        answer: 'Last opp et bilde av karakteren eller velg en på 微鲤AI. Skriv deretter en prompt som beskriver scenen eller interaksjonen og generer.',
                    },
                    {
                        question: 'Kan jeg bruke hvilket som helst karakterbilde?',
                        answer: 'Ja, hvis du har rettigheter til å bruke det. AI animerer karakteren etter instruksjonene dine.',
                    },
                    {
                        question: 'Er det en grense for videolengden?',
                        answer: 'Avhenger av modellen og planen din, vanligvis 5–10 sekunder.',
                    },
                    {
                        question: 'Hvordan sikrer jeg at karakteren er konsistent?',
                        answer: 'Vi analyserer referansebildet og holder visuelle trekk stabile på tvers av alle frames.',
                    },
                    {
                        question: 'Kan jeg prøve gratis?',
                        answer: 'Ja, du kan generere karaktervideoer med daglige gratis kreditter.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hva er 微鲤AI Karakter til Video?',
                    answer: 'Et avansert verktøy som genererer videoer med en spesifikk karakter. Last opp et bilde eller velg fra biblioteket for å lage interaktivt innhold.',
                },
                {
                    question: 'Hvordan fungerer karakterkonsistens i video?',
                    answer: 'AI bruker referansebildet for å holde karakterens utseende stabilt og gjenkjennelig gjennom hele klippet.',
                },
                {
                    question: 'Kan jeg lage en video av meg og en karakter sammen?',
                    answer: 'Ja. Beskriv interaksjonen i prompten, så genererer AI scenen deretter.',
                },
                {
                    question: 'Hvilke modeller brukes?',
                    answer: 'Vi bruker kraftige videomodeller som Kling og Google Veo, optimalisert for realistisk bevegelse og konsistens.',
                },
                {
                    question: 'Hva er maksimal varighet?',
                    answer: 'Avhenger av planen din, vanligvis 5–10 sekunder i høy kvalitet.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Del med venner | 微鲤AI',
            description: 'Del med venner, inviter venner til å registrere seg på 微鲤AI, og du og vennene dine vil motta belønninger.',
            keywords: 'social back, del med venner, inviter venner til 微鲤AI, motta belønninger, 微鲤AI',
        },
    },
    nl: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI laat je direct AI-videos en afbeeldingen maken van tekst, fotos of clips. Probeer het vandaag gratis.',
        home: {
            h1: '微鲤AI - Gratis AI Video & Afbeelding Generator Platform',
            title: '微鲤AI - Gratis AI Video Generator & Afbeeldingstools (Kling, Flux, Veo)',
            description: 'Stop met jongleren met abonnementen. Krijg toegang tot de beste AI-modellen ter wereld—Kling AI, Google Veo, Sora en Flux—allemaal in één gratis dashboard. Maak professionele videos, verwissel gezichten en schaal afbeeldingen direct op.',
            keywords: 'AI video generator, AI afbeelding generator, tekst naar video, afbeelding naar video, AI video creatie, AI afbeelding creatie, video generatie, afbeelding generatie, AI content creatie, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - Het alles-in-één AI creatieve platform',
            og_description: 'Genereer verbluffende videos met Kling & Flux. Tekst-naar-Video, Face Swap en Upscaling tools. Probeer het gratis.',
            twitter_title: '微鲤AI - Gratis AI Video Generator',
            twitter_description: 'Krijg toegang tot Kling, Veo en Flux op één plek. Genereer direct AI video & kunst.',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'Een AI-aangedreven creatief platform dat fungeert als aggregator voor topmodellen zoals Kling AI, Google Veo, Sora en Flux. Functies: tekst-naar-video, Face Swap en Upscaling.',
            software_feature: 'Kling AI-integratie, tekst naar video, AI Face Swap, 4K video upscaler, afbeelding naar video, lip sync, achtergrond verwijderen',
        },
        homePage: {
            title: 'Home - Alles-in-één AI-video- en beeldplatform | 微鲤AI',
            description: `Gebruik 微鲤AI om geweldige AI-video's en afbeeldingen te maken van tekst, foto's of clips.`,
            keywords: 'homePage, AI, 微鲤AI',
        },
        aiTools: {
            title: 'Bewerktools - Collectie van alle top AI-tools | 微鲤AI',
            description: 'Ontdek de verzameling van alle beste AI-video- en beeldtools op één plek.',
            keywords: 'AI tools, video tools, beeld tools, 微鲤AI',
        },
        myCreations: {
            title: 'Mijn creaties | 微鲤AI',
            description: 'Bekijk al je creaties, inclusief videos en afbeeldingen. Beheer je creaties met 微鲤AI.',
            keywords: 'mijn creaties, video creation, beeld creation, 微鲤AI',
        },
        aiImage: {
            title: 'AI-beeldgenerator - Maak prachtige beelden met AI | 微鲤AI',
            description: 'Maak professionele AI-gegenereerde beelden met 微鲤AI. Transformeer tekst naar kunst.',
            keywords: 'AI-beeldgenerator, tekst naar beeld, AI kunst, 微鲤AI',
        },
        aiVideo: {
            title: 'AI-videogenerator - Maak geweldige videos met AI | 微鲤AI',
            description: 'Genereer geweldige AI-videos met 微鲤AI. Ondersteunt tekst naar video en beeld naar video.',
            keywords: 'AI-videogenerator, tekst naar video, video creation, 微鲤AI',
        },
        aiMusic: {
            title: 'AI-muziekgenerator - Vocale en instrumentale tracks | 微鲤AI',
            description: 'Genereer snel AI-muziek op 微鲤AI: ondersteunt vocale sange en instrumentale muziek.',
            keywords: 'AI-muziekgenerator, tekst naar muziek, 微鲤AI',
        },
        pricing: {
            title: 'Plannen & Prijzen | 微鲤AI – AI Afbeelding & Video Generatie Abonnement',
            description: 'Ontdek WeryAIs flexibele prijsplannen voor AI afbeelding en video generatie. Krijg meer maandelijkse credits, prioriteitsverwerking en toegang tot geavanceerde AI-modellen.',
            keywords: '微鲤AI prijzen, AI generator prijzen, AI abonnementsplannen, AI credits, afbeelding generatie prijzen, video generatie prijzen',
            og_title: '微鲤AI Prijzen – AI Afbeelding & Video Generatie Plannen',
            og_description: 'Kies het beste AI afbeelding en video generatie plan. Gratis credits, Pro functies en prioriteitstoegang.',
            twitter_title: '微鲤AI Prijzen – Flexibele AI Plannen & Credits',
            twitter_description: 'Selecteer het juiste plan voor AI afbeelding en video generatie.',
        },
        faq: {
            title: 'Veelgestelde vragen | 微鲤AI',
            description: 'Vind antwoorden på veelgestelde vragen over de video- en beeldtools van 微鲤AI.',
            keywords: 'FAQ, help, 微鲤AI',
        },
        aboutUs: {
            title: 'Over ons | 微鲤AI creatief platform',
            description: 'Lees meer over de missie van 微鲤AI om de beste AI-tools te leveren aan makers wereldwijd.',
            keywords: 'over 微鲤AI, bedrijfsinformatie, 微鲤AI',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'AI-videomodellen - Collectie van Veo, Sora, Kling AI & meer | 微鲤AI',
            description: 'Ontdek de wereldleiders op het gebied van AI-videomodellen, waaronder Kling, Sora, Google Veo enz.',
            keywords: 'AI-videomodellen, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'AI-beeldmodellen - Collectie van FLUX, Nano Banana, Imagen & meer | 微鲤AI',
            description: 'Toegang tot toonaangevende AI-beeldmodellen zoals FLUX, Nano Banana en Imagen.',
            keywords: 'AI-beeldmodellen, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'Details van AI-gegenereerd beeld | 微鲤AI',
            description: 'Bekijk details, prompts en parameters van AI-gegenereerde beelden.',
            keywords: 'AI-beelddetails, beeldparameters, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Details van AI-gegenereerde video | 微鲤AI',
            description: 'Bekijk details, prompts en productieparameters van AI-gegenereerde videos.',
            keywords: 'AI-videodetails, videoparameters, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Details van AI-gegenereerde muziek | 微鲤AI',
            description: 'Bekijk stijl, songtekst en creatiedetails van AI-gegenereerde muziek.',
            keywords: 'AI-muziekdetails, muziekparameters, 微鲤AI',
        },
        characters: {
            title: 'AI-personage creatie - Bouw consistente virtuele personages | 微鲤AI',
            description: 'Gebruik AI om consistente virtuele personages te creëren voor verhalen en videos.',
            keywords: 'AI-personages, virtuele personages, personageconsistentie, 微鲤AI',
        },
        characterToImage: {
            title: 'AI Karakter naar Afbeelding - Maak foto’s met elk karakter | 微鲤AI',
            description: 'Upload je eigen karakterfoto’s of kies uit het WeryAI‑platform om met AI hoogwaardige afbeeldingen van jou en het karakter samen te genereren—met consistente karakteruitstraling.',
            keywords: 'AI karakter naar afbeelding, karakterconsistentie, AI karaktergenerator, interactieve karakterfoto’s, 微鲤AI karakter',
            og_title: 'AI Karakter naar Afbeelding - Maak foto’s met elk karakter | 微鲤AI',
            og_description: 'Maak hoogwaardige interactieve foto’s met elk AI‑karakter. Upload je eigen karakter of kies uit 微鲤AI om indrukwekkende karakterafbeeldingen te genereren.',
            twitter_title: 'AI Karakter naar Afbeelding - Maak foto’s met elk karakter | 微鲤AI',
            twitter_description: 'Genereer foto’s van jou en je favoriete karakters. Upload of kies karakters op 微鲤AI en maak interactieve karakterkunst.',
            faq: [
                {
                    question: 'Wat is 微鲤AI Karakter naar Afbeelding?',
                    answer: '微鲤AI Karakter naar Afbeelding is een AI‑tool waarmee je afbeeldingen met specifieke karakters kunt genereren terwijl hun uitstraling consistent blijft. Je kunt eigen karakterfoto’s uploaden of uit onze bibliotheek kiezen.',
                },
                {
                    question: 'Kan ik foto’s van mezelf met een karakter genereren?',
                    answer: 'Ja. Beschrijf jezelf en het karakter (en de interactie) in de prompt, en de AI genereert realistische of artistieke beelden van jullie samen.',
                },
                {
                    question: 'Hoeveel karakters kan ik kiezen?',
                    answer: '微鲤AI heeft een grote bibliotheek met karakters uit anime, games en originele ontwerpen. Je kunt ook eigen karakterfoto’s uploaden voor unieke interacties.',
                },
                {
                    question: 'Ondersteunt het hoge resolutie?',
                    answer: 'Zeker. We ondersteunen tot 4K‑beeldgeneratie zodat je karakterbeelden professioneel en gedetailleerd zijn.',
                },
                {
                    question: 'Hoe behoud ik karakterconsistentie?',
                    answer: 'Onze AI‑modellen zijn getraind om karakterkenmerken te herkennen en te behouden, zodat de gegenereerde beelden overeenkomen met het referentie‑karakter dat je kiest of uploadt.',
                },
            ],
        },
        characterToVideo: {
            title: 'AI Karakter naar Video - Maak interactieve karaktervideo’s | 微鲤AI',
            description: 'Maak geweldige video’s met elk AI‑karakter. Upload karakterfoto’s of kies een karakter op 微鲤AI om interactieve video’s van jou en het karakter samen te genereren.',
            keywords: 'AI karakter naar video, karaktervideo generator, interactieve AI video, karakterconsistentie, 微鲤AI',
            og_title: 'AI Karakter naar Video - Maak interactieve karaktervideo’s | 微鲤AI',
            og_description: 'Zet je ideeën om in interactieve video’s met AI‑karakters. Upload of kies een karakter op 微鲤AI en genereer realistische beweging.',
            twitter_title: 'AI Karakter naar Video - Maak interactieve karaktervideo’s | 微鲤AI',
            twitter_description: 'Genereer hoogwaardige video’s met je favoriete karakters. Upload of kies op 微鲤AI en maak interactieve AI‑video’s.',
            page: {
                title1: 'Gratis AI karakter→video generator',
                title2: 'Breng je favoriete karakters tot leven! Upload een foto van een karakter of kies uit de WeryAI‑bibliotheek om indrukwekkende interactieve video’s te maken. Beschrijf de scène in je prompt en bekijk het filmische resultaat.',
                consistency: 'Toonaangevende karakterconsistentie: onze AI behoudt unieke kenmerken en uiterlijk gedurende de hele video.',
                interactive: 'Maak betekenisvolle interacties — van samen wandelen tot een gesprek. De mogelijkheden zijn eindeloos.',
                faq: [
                    {
                        question: 'Hoe maak ik een video met een specifiek karakter?',
                        answer: 'Upload een foto van het karakter of kies er één op 微鲤AI. Schrijf vervolgens een prompt die de scène of interactie beschrijft en genereer.',
                    },
                    {
                        question: 'Kan ik elke karakterfoto gebruiken?',
                        answer: 'Ja, als je de rechten hebt om die te gebruiken. De AI animeert het karakter volgens jouw instructies.',
                    },
                    {
                        question: 'Is er een limiet voor de videoduur?',
                        answer: 'Dit hangt af van het model en je plan, meestal 5–10 seconden.',
                    },
                    {
                        question: 'Hoe zorg ik voor consistente uitstraling?',
                        answer: 'We analyseren de referentie‑afbeelding en houden visuele kenmerken stabiel over alle frames.',
                    },
                    {
                        question: 'Kan ik het gratis proberen?',
                        answer: 'Ja, je kunt karaktervideo’s genereren met je dagelijkse gratis credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wat is 微鲤AI Karakter naar Video?',
                    answer: 'Een geavanceerde tool die video’s genereert met een specifiek karakter. Upload een foto of kies uit de bibliotheek om interactieve content te maken.',
                },
                {
                    question: 'Hoe werkt karakterconsistentie in video?',
                    answer: 'De AI gebruikt de referentie‑afbeelding om het uiterlijk van het karakter stabiel en herkenbaar te houden gedurende de hele clip.',
                },
                {
                    question: 'Kan ik een video maken van mij en een karakter samen?',
                    answer: 'Ja. Beschrijf de interactie in de prompt en de AI genereert de scène.',
                },
                {
                    question: 'Welke modellen worden gebruikt?',
                    answer: 'We gebruiken krachtige videomodellen zoals Kling en Google Veo, geoptimaliseerd voor realistische beweging en consistentie.',
                },
                {
                    question: 'Wat is de maximale duur?',
                    answer: 'Afhankelijk van je plan meestal 5–10 seconden in hoge kwaliteit.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Deel met vrienden | 微鲤AI',
            description: 'Deel met vrienden, nodig vrienden uit om zich te registreren bij 微鲤AI, jij en je vrienden ontvangen beloningen.',
            keywords: 'social back, deel met vrienden, nodig vrienden uit voor 微鲤AI, ontvang beloningen, 微鲤AI',
        },
    },
    id: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI memungkinkan Anda membuat video dan gambar AI secara instan dari teks, foto, atau klip. Coba gratis hari ini.',
        home: {
            h1: '微鲤AI - Platform Generator Video & Gambar AI Gratis',
            title: '微鲤AI - Generator Video AI Gratis & Alat Gambar (Kling, Flux, Veo)',
            description: 'Berhenti mengelola banyak langganan. Akses model AI terbaik di dunia—Kling AI, Google Veo, Sora, dan Flux—semuanya dalam satu dasbor gratis. Buat video profesional, tukar wajah, dan tingkatkan gambar secara instan.',
            keywords: 'generator video AI, generator gambar AI, teks ke video, gambar ke video, pembuatan video AI, pembuatan gambar AI, generasi video, generasi gambar, pembuatan konten AI, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - Platform Kreatif AI Lengkap',
            og_description: 'Hasilkan video menakjubkan dengan Kling & Flux. Alat Teks-ke-Video, Face Swap, dan Upscaling. Coba gratis.',
            twitter_title: '微鲤AI - Generator Video AI Gratis',
            twitter_description: 'Akses Kling, Veo, dan Flux di satu tempat. Hasilkan video & seni AI secara instan.',
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'Platform kreatif berbasis AI yang berfungsi sebagai agregator untuk model-model teratas seperti Kling AI, Google Veo, Sora, dan Flux. Fitur termasuk Text-to-Video, Face Swap, dan Upscaling.',
            software_feature: 'Integrasi Kling AI, teks ke video, face swap AI, upscaler video 4K, gambar ke video, lip sync, penghapus latar belakang',
        },
        homePage: {
            title: 'Beranda - Platform Video & Gambar AI All-in-one | 微鲤AI',
            description: 'Gunakan 微鲤AI untuk membuat video dan gambar AI yang luar biasa dari teks, foto, atau klip.',
            keywords: 'homePage, AI, 微鲤AI',
        },
        aiTools: {
            title: 'Toolkit Editor - Koleksi semua alat AI teratas | 微鲤AI',
            description: 'Jelajahi koleksi semua alat AI video dan gambar terbaik di satu tempat.',
            keywords: 'alat AI, alat video, alat gambar, 微鲤AI',
        },
        myCreations: {
            title: 'Kreasi Saya | 微鲤AI',
            description: 'Lihat semua kreasi Anda di 微鲤AI. Hasil berkualitas tinggi.',
            keywords: 'myCreations, AI, 微鲤AI',
        },
        aiImage: {
            title: 'Generator Gambar AI - Buat gambar menakjubkan dengan AI | 微鲤AI',
            description: 'Buat gambar buatan AI profesional dengan 微鲤AI. Ubah teks menjadi seni.',
            keywords: 'generator gambar AI, teks ke gambar, seni AI, 微鲤AI',
        },
        aiVideo: {
            title: 'Generator Video AI - Buat video menakjubkan dengan AI | 微鲤AI',
            description: 'Hasilkan video AI yang menakjubkan dengan 微鲤AI. Mendukung teks ke video dan gambar ke video.',
            keywords: 'generator video AI, teks ke video, pembuatan video, 微鲤AI',
        },
        aiMusic: {
            title: 'Generator Musik AI - Lagu vokal & instrumental | 微鲤AI',
            description: 'Hasilkan musik AI dengan cepat di 微鲤AI: mendukung lagu vokal dan musik instrumental.',
            keywords: 'generator musik AI, teks ke musik, 微鲤AI',
        },
        pricing: {
            title: 'Paket & Harga | 微鲤AI – Langganan Generasi Gambar & Video AI',
            description: 'Jelajahi paket harga fleksibel 微鲤AI untuk generasi gambar dan video AI. Dapatkan lebih banyak kredit bulanan, pemrosesan prioritas, dan akses ke model AI canggih.',
            keywords: 'harga 微鲤AI, harga generator AI, paket langganan AI, kredit AI, harga generasi gambar, harga generasi video',
            og_title: 'Harga 微鲤AI – Paket Generasi Gambar & Video AI',
            og_description: 'Pilih paket generasi gambar dan video AI terbaik. Kredit gratis, fitur Pro, dan akses prioritas.',
            twitter_title: 'Harga 微鲤AI – Paket AI Fleksibel & Kredit',
            twitter_description: 'Pilih paket yang tepat untuk generasi gambar dan video AI.',
        },
        faq: {
            title: 'Pertanyaan Umum | 微鲤AI',
            description: 'Temukan jawaban atas pertanyaan umum tentang alat video dan gambar 微鲤AI.',
            keywords: 'FAQ, bantuan, 微鲤AI',
        },
        aboutUs: {
            title: 'Tentang Kami | Platform Kreatif 微鲤AI',
            description: 'Pelajari tentang misi 微鲤AI untuk memberikan alat AI terbaik bagi kreator di seluruh dunia.',
            keywords: 'tentang 微鲤AI, informasi perusahaan, 微鲤AI',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'Model Video AI - Koleksi Veo, Sora, Kling AI & lainnya | 微鲤AI',
            description: 'Jelajahi model video AI terkemuka di dunia, termasuk Kling, Sora, Google Veo, dll.',
            keywords: 'model video AI, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'Model Gambar AI - Koleksi FLUX, Nano Banana, Imagen & lainnya | 微鲤AI',
            description: 'Akses model gambar AI terkemuka seperti FLUX, Nano Banana, dan Imagen.',
            keywords: 'model gambar AI, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'Detail gambar yang dihasilkan AI | 微鲤AI',
            description: 'Lihat detail, prompt, dan parameter gambar yang dihasilkan AI.',
            keywords: 'detail gambar AI, parameter gambar, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'Detail video yang dihasilkan AI | 微鲤AI',
            description: 'Lihat detail, prompt, dan parameter produksi video yang dihasilkan AI.',
            keywords: 'detail video AI, parameter video, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'Detail musik yang dihasilkan AI | 微鲤AI',
            description: 'Lihat gaya, lirik, dan detail kreasi musik yang dihasilkan AI.',
            keywords: 'detail musik AI, parameter musik, 微鲤AI',
        },
        characters: {
            title: 'Pembuatan Karakter AI - Bangun karakter virtual yang konsisten | 微鲤AI',
            description: 'Gunakan AI untuk membuat karakter virtual yang konsisten untuk cerita dan video.',
            keywords: 'karakter AI, karakter virtual, konsistensi karakter, 微鲤AI',
        },
        characterToImage: {
            title: 'AI Karakter ke Gambar - Buat foto dengan karakter apa pun | 微鲤AI',
            description: 'Unggah foto karakter Anda sendiri atau pilih dari platform 微鲤AI untuk menghasilkan gambar berkualitas tinggi Anda dan karakter bersama dengan AI, sambil menjaga konsistensi karakter.',
            keywords: 'AI karakter ke gambar, konsistensi karakter, generator karakter AI, foto karakter interaktif, karakter 微鲤AI',
            og_title: 'AI Karakter ke Gambar - Buat foto dengan karakter apa pun | 微鲤AI',
            og_description: 'Buat foto interaktif berkualitas tinggi dengan karakter AI apa pun. Unggah karakter Anda sendiri atau pilih dari 微鲤AI untuk menghasilkan gambar karakter yang menakjubkan.',
            twitter_title: 'AI Karakter ke Gambar - Buat foto dengan karakter apa pun | 微鲤AI',
            twitter_description: 'Hasilkan foto Anda dan karakter favorit Anda. Unggah atau pilih karakter di 微鲤AI untuk membuat seni karakter interaktif.',
            faq: [
                {
                    question: 'Apa itu 微鲤AI Karakter ke Gambar?',
                    answer: '微鲤AI Karakter ke Gambar adalah alat bertenaga AI yang memungkinkan Anda menghasilkan gambar dengan karakter tertentu sambil menjaga konsistensi visualnya. Anda dapat mengunggah foto karakter sendiri atau memilih dari library karakter kami.',
                },
                {
                    question: 'Bisakah saya membuat foto saya bersama karakter?',
                    answer: 'Bisa. Dengan mendeskripsikan Anda dan karakter (serta interaksinya) di prompt, AI dapat menghasilkan foto realistis atau bergaya seni.',
                },
                {
                    question: 'Berapa banyak karakter yang bisa saya pilih?',
                    answer: '微鲤AI memiliki library karakter yang besar dari anime, game, dan desain orisinal. Anda juga bisa mengunggah foto karakter sendiri untuk interaksi yang unik.',
                },
                {
                    question: 'Apakah mendukung resolusi tinggi?',
                    answer: 'Ya. Kami mendukung hingga 4K untuk memastikan gambar karakter Anda terlihat profesional dan detail.',
                },
                {
                    question: 'Bagaimana menjaga konsistensi karakter?',
                    answer: 'Model AI kami dilatih untuk mengenali dan mempertahankan ciri khas karakter, sehingga gambar yang dihasilkan tetap sesuai dengan karakter referensi yang Anda pilih atau unggah.',
                },
            ],
        },
        characterToVideo: {
            title: 'AI Karakter ke Video - Buat video karakter interaktif | 微鲤AI',
            description: 'Buat video menakjubkan dengan karakter AI apa pun. Unggah foto karakter atau pilih dari 微鲤AI untuk menghasilkan video interaktif Anda dan karakter bersama.',
            keywords: 'karakter ke video AI, generator video karakter, video AI interaktif, konsistensi karakter, 微鲤AI',
            og_title: 'AI Karakter ke Video - Buat video karakter interaktif | 微鲤AI',
            og_description: 'Ubah ide menjadi video interaktif dengan karakter AI. Unggah atau pilih karakter di 微鲤AI dan hasilkan gerakan yang realistis.',
            twitter_title: 'AI Karakter ke Video - Buat video karakter interaktif | 微鲤AI',
            twitter_description: 'Hasilkan video berkualitas tinggi dengan karakter favorit Anda. Unggah atau pilih di 微鲤AI untuk membuat video AI interaktif.',
            page: {
                title1: 'Generator AI karakter→video gratis',
                title2: 'Hidupkan karakter favorit Anda! Unggah foto karakter atau pilih dari library 微鲤AI untuk membuat video interaktif yang menakjubkan. Cukup jelaskan adegan dan interaksi di prompt, lalu lihat hasil sinematiknya.',
                consistency: 'Konsistensi karakter terdepan: AI kami menjaga ciri khas dan penampilan karakter sepanjang video.',
                interactive: 'Buat interaksi yang bermakna — dari berjalan bersama hingga percakapan. Kemungkinan storytelling tidak terbatas.',
                faq: [
                    {
                        question: 'Bagaimana membuat video dengan karakter tertentu?',
                        answer: 'Unggah foto karakter atau pilih karakter di 微鲤AI. Lalu tulis prompt yang menjelaskan adegan atau interaksi dan buat videonya.',
                    },
                    {
                        question: 'Apakah saya bisa memakai foto karakter apa pun?',
                        answer: 'Ya, selama Anda memiliki hak untuk menggunakannya. AI akan menganimasikan karakter sesuai instruksi Anda.',
                    },
                    {
                        question: 'Apakah ada batas durasi video?',
                        answer: 'Tergantung model dan paket Anda, biasanya 5–10 detik.',
                    },
                    {
                        question: 'Bagaimana memastikan karakter tetap konsisten?',
                        answer: 'Kami menganalisis gambar referensi dan menjaga ciri visual tetap stabil di semua frame.',
                    },
                    {
                        question: 'Bisa coba gratis?',
                        answer: 'Ya, Anda dapat membuat video karakter dengan kredit gratis harian.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Apa itu Karakter ke Video di 微鲤AI?',
                    answer: 'Ini adalah alat canggih yang menghasilkan video dengan karakter tertentu. Unggah foto atau pilih dari library untuk membuat konten interaktif.',
                },
                {
                    question: 'Bagaimana konsistensi karakter bekerja di video?',
                    answer: 'AI menggunakan gambar referensi untuk menjaga penampilan karakter tetap stabil dan mudah dikenali sepanjang klip.',
                },
                {
                    question: 'Bisakah saya membuat video saya dan karakter bersama?',
                    answer: 'Bisa. Jelaskan interaksinya di prompt, dan AI akan menghasilkan adegan yang sesuai.',
                },
                {
                    question: 'Model apa yang digunakan?',
                    answer: 'Kami menggunakan model video berperforma tinggi seperti Kling dan Google Veo, dioptimalkan untuk gerakan realistis dan konsistensi karakter.',
                },
                {
                    question: 'Berapa durasi maksimalnya?',
                    answer: 'Tergantung paket, umumnya 5–10 detik dalam kualitas tinggi.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Bagikan dengan teman | 微鲤AI',
            description: 'Bagikan dengan teman, undang teman untuk mendaftar di 微鲤AI, Anda dan teman Anda akan mendapatkan hadiah.',
            keywords: 'social back, bagikan dengan teman, undang teman ke 微鲤AI, dapatkan hadiah, 微鲤AI',
        },
    },
    tr: {
        siteName: '微鲤AI',
        siteUrl: 'https://www.weryai.com.cn',
        websiteDescription: '微鲤AI, metin, fotoğraf veya kliplerden anında AI videoları ve görseller oluşturmanızı sağlar. Bugün ücretsiz deneyin.',
        home: {
            h1: '微鲤AI - Ücretsiz AI Video & Görsel Oluşturucu Platform',
            title: '微鲤AI - Ücretsiz AI Video Oluşturucu & Görsel Araçları (Kling, Flux, Veo)',
            description: 'Abonelikleri yönetmeyi bırakın. Dünyanın en iyi AI modellerine erişin—Kling AI, Google Veo, Sora ve Flux—hepsi tek bir ücretsiz panoda. Profesyonel videolar oluşturun, yüz değiştirin ve görselleri anında yükseltin.',
            keywords: 'AI video oluşturucu, AI görsel oluşturucu, metinden videoya, görselden videoya, AI video oluşturma, AI görsel oluşturma, video üretimi, görsel üretimi, AI içerik oluşturma, Kling, Flux, Veo, 微鲤AI',
            og_title: '微鲤AI - Hepsi Bir Arada AI Yaratıcı Platform',
            og_description: 'Kling & Flux ile çarpıcı videolar oluşturun. Metinden Videoya, Yüz Değiştirme ve Yükseltme araçları. Ücretsiz deneyin.',
            twitter_title: '微鲤AI - Ücretsiz AI Video Oluşturucu',
            twitter_description: `Kling, Veo ve Flux'a tek yerden erişin. Anında AI video ve sanat oluşturun.`,
            ogImage: 'https://www.weryai.com.cn/weryai_512.png',
            twitterImage: 'https://www.weryai.com.cn/weryai_512.png',
            software_desc: 'Kling AI, Google Veo, Sora ve Flux gibi en iyi modelleri bir araya getiren, yapay zekâ destekli yaratıcı bir platform. Özellikler: Metinden Videoya, Face Swap ve Yükseltme.',
            software_feature: 'Kling AI entegrasyonu, metinden videoya, AI yüz değiştirme, 4K video yükseltici, görselden videoya, dudak senkronu, arka plan kaldırıcı',
        },
        homePage: {
            title: 'Ana Sayfa | 微鲤AI',
            description: '微鲤AI ile metin, fotoğraf veya kliplerden çarpıcı videolar ve görseller oluşturun — bugün ücretsiz deneyin.',
            keywords: 'AI video oluşturucu, AI görsel oluşturucu, metinden videoya, görselden videoya, AI içerik, 微鲤AI',
        },
        aiTools: {
            title: 'Düzenleme Araçları - Tüm en iyi AI araçları koleksiyonu | 微鲤AI',
            description: 'Tüm en iyi AI video ve görsel araçları koleksiyonunu tek bir yerde keşfedin.',
            keywords: 'AI araçları, video araçları, görsel araçları, 微鲤AI',
        },
        myCreations: {
            title: 'Çalışmalarım | 微鲤AI',
            description: 'Tüm çalışmalarınızı, videolarınızı ve görsellerinizi görüntüleyin. 微鲤AI ile çalışmalarınızı yönetin.',
            keywords: 'çalışmalarım, AI videoları, AI görselleri, 微鲤AI',
        },
        aiImage: {
            title: 'AI Görsel Oluşturucu - AI ile etkileyici görseller oluşturun | 微鲤AI',
            description: '微鲤AI ile profesyonel AI yapımı görseller oluşturun. Metni sanata dönüştürün.',
            keywords: 'AI görsel oluşturucu, metinden görsele, AI sanatı, 微鲤AI',
        },
        aiVideo: {
            title: 'AI Video Oluşturucu - AI ile harika videolar oluşturun | 微鲤AI',
            description: '微鲤AI ile etkileyici AI videoları oluşturun. Metinden videoya ve görselden videoya destekler.',
            keywords: 'AI video oluşturucu, metinden videoya, video üretimi, 微鲤AI',
        },
        aiMusic: {
            title: 'AI Müzik Oluşturucu - Vokal ve enstrümantal parçalar | 微鲤AI',
            description: `微鲤AI'da hızlıca AI müziği oluşturun: vokal şarkıları ve enstrümantal müziği destekler.`,
            keywords: 'AI müzik oluşturucu, metinden müziğe, 微鲤AI',
        },
        pricing: {
            title: 'Planlar & Fiyatlandırma | 微鲤AI – AI Görsel & Video Oluşturma Aboneliği',
            description: `AI görsel ve video oluşturma için 微鲤AI'nin esnek fiyat planlarını keşfedin. Daha fazla aylık kredi, öncelikli işleme ve gelişmiş AI modellerine erişim elde edin.`,
            keywords: '微鲤AI fiyatları, AI oluşturucu fiyatları, AI abonelik planları, AI kredileri, görsel oluşturma fiyatları, video oluşturma fiyatları',
            og_title: '微鲤AI Fiyatları – AI Görsel & Video Oluşturma Planları',
            og_description: 'En iyi AI görsel ve video oluşturma planını seçin. Ücretsiz krediler, Pro özellikler ve öncelikli erişim.',
            twitter_title: '微鲤AI Fiyatları – Esnek AI Planları & Krediler',
            twitter_description: 'AI görsel ve video oluşturma için doğru planı seçin.',
        },
        faq: {
            title: 'Sıkça Sorulan Sorular | 微鲤AI',
            description: '微鲤AI video ve görsel araçları hakkında sıkça sorulan soruların yanıtlarını bulun.',
            keywords: 'SSS, yardım merkezi, 微鲤AI',
        },
        aboutUs: {
            title: 'Hakkımızda | 微鲤AI Yaratıcı Platformu',
            description: `微鲤AI'nın dünya çapındaki yaratıcılara en iyi AI araçlarını sunma misyonu hakkında bilgi edinin.`,
            keywords: '微鲤AI hakkında, şirket bilgileri, 微鲤AI',
        },
        refund: {
            title: 'Refund Policy | 微鲤AI',
            description: 'Review the official 微鲤AI Refund Policy.',
            keywords: 'refund policy, 微鲤AI',
        },
        privacy: {
            title: 'Privacy Policy | 微鲤AI',
            description: 'Read the official 微鲤AI Privacy Policy.',
            keywords: 'privacy policy, 微鲤AI',
        },
        terms: {
            title: 'Terms and Conditions | 微鲤AI',
            description: 'Read the official 微鲤AI Terms and Conditions.',
            keywords: 'terms, conditions, 微鲤AI',
        },
        videoModels: {
            title: 'AI Video Modelleri - Veo, Sora, Kling AI ve daha fazlası | 微鲤AI',
            description: 'Kling, Sora, Google Veo ve daha fazlası dahil olmak üzere dünyanın önde gelen AI video modellerini keşfedin.',
            keywords: 'AI video modelleri, Kling, Sora, Veo, 微鲤AI',
        },
        imageModels: {
            title: 'AI Görsel Modelleri - FLUX, Nano Banana, Imagen ve daha fazlası | 微鲤AI',
            description: 'FLUX, Nano Banana ve Imagen gibi önde gelen AI görsel modellerine erişin.',
            keywords: 'AI görsel modelleri, FLUX, Nano Banana, Imagen, 微鲤AI',
        },
        ugcDetailImage: {
            title: 'AI tarafından oluşturulan görselin detayları | 微鲤AI',
            description: 'AI tarafından oluşturulan görsellerin detaylarını, promptlarını ve parametrelerini görüntüleyin.',
            keywords: 'AI görsel detayları, görsel parametreleri, 微鲤AI',
        },
        ugcDetailVideo: {
            title: 'AI tarafından oluşturulan videonun detayları | 微鲤AI',
            description: 'AI tarafından oluşturulan videoların detaylarını, promptlarını ve üretim parametrelerini görüntüleyin.',
            keywords: 'AI video detayları, video parametreleri, 微鲤AI',
        },
        ugcDetailMusic: {
            title: 'AI tarafından oluşturulan müziğin detayları | 微鲤AI',
            description: 'AI tarafından oluşturulan müziğin stilini, şarkı sözlerini ve oluşturma detaylarını görüntüleyin.',
            keywords: 'AI müzik detayları, müzik parametreleri, 微鲤AI',
        },
        characters: {
            title: 'AI Karakter Oluşturma - Tutarlı sanal karakterler oluşturun | 微鲤AI',
            description: `Hikayeler ve videolar için tutarlı sanal karakterler oluşturmak üzere AI'yı kullanın.`,
            keywords: 'AI karakterleri, sanal karakterler, karakter tutarlılığı, 微鲤AI',
        },
        characterToImage: {
            title: 'AI Karakterden Görsele - Herhangi bir karakterle fotoğraf oluşturun | 微鲤AI',
            description: 'Kendi karakter fotoğraflarınızı yükleyin veya 微鲤AI platformundan seçin; AI ile sizin ve karakterin birlikte olduğu yüksek kaliteli görseller üretin ve karakter tutarlılığını koruyun.',
            keywords: 'AI karakterden görsele, karakter tutarlılığı, AI karakter oluşturucu, etkileşimli karakter fotoğrafları, 微鲤AI karakter',
            og_title: 'AI Karakterden Görsele - Herhangi bir karakterle fotoğraf oluşturun | 微鲤AI',
            og_description: 'Herhangi bir AI karakterle yüksek kaliteli etkileşimli fotoğraflar oluşturun. Kendi karakterinizi yükleyin veya WeryAI’dan seçin ve etkileyici karakter görselleri üretin.',
            twitter_title: 'AI Karakterden Görsele - Herhangi bir karakterle fotoğraf oluşturun | 微鲤AI',
            twitter_description: 'Sizin ve favori karakterlerinizin birlikte olduğu görseller üretin. WeryAI’da karakter yükleyin veya seçin ve etkileşimli karakter sanatı oluşturun.',
            faq: [
                {
                    question: '微鲤AI Karakterden Görsele nedir?',
                    answer: '微鲤AI Karakterden Görsele, belirli karakterleri görsellerde kullanırken görsel tutarlılığı koruyan AI destekli bir araçtır. Kendi karakter fotoğraflarınızı yükleyebilir veya kütüphanemizden seçebilirsiniz.',
                },
                {
                    question: 'Benimle bir karakterin birlikte olduğu görseller üretebilir miyim?',
                    answer: 'Evet. Promptta kendinizi ve karakteri (ve etkileşimi) tarif ederek gerçekçi ya da sanatsal görseller oluşturabilirsiniz.',
                },
                {
                    question: 'Kaç karakter arasından seçim yapabilirim?',
                    answer: '微鲤AI; anime, oyun ve özgün tasarımlardan oluşan geniş bir karakter kütüphanesi sunar. Ayrıca kendi karakter fotoğraflarınızı yükleyerek benzersiz etkileşimler oluşturabilirsiniz.',
                },
                {
                    question: 'Yüksek çözünürlüğü destekliyor mu?',
                    answer: 'Kesinlikle. 4K’ya kadar yüksek çözünürlüklü görsel üretimini destekliyoruz.',
                },
                {
                    question: 'Karakter tutarlılığını nasıl korurum?',
                    answer: 'Gelişmiş AI modellerimiz karakter özelliklerini tanır ve korur; böylece üretilen görseller seçtiğiniz veya yüklediğiniz referans karakterle uyumlu kalır.',
                },
            ],
        },
        characterToVideo: {
            title: 'AI Karakterden Videoya - Etkileşimli karakter videoları oluştur | 微鲤AI',
            description: 'Herhangi bir AI karakterle etkileyici videolar oluşturun. Karakter fotoğraflarını yükleyin veya WeryAI’dan seçin; sizin ve karakterin birlikte olduğu etkileşimli videolar üretin.',
            keywords: 'karakterden videoya AI, karakter video oluşturucu, etkileşimli AI video, karakter tutarlılığı, 微鲤AI',
            og_title: 'AI Karakterden Videoya - Etkileşimli karakter videoları oluştur | 微鲤AI',
            og_description: 'Fikirlerinizi AI karakterlerle etkileşimli videolara dönüştürün. WeryAI’da karakter yükleyin veya seçin ve gerçekçi hareket üretin.',
            twitter_title: 'AI Karakterden Videoya - Etkileşimli karakter videoları oluştur | 微鲤AI',
            twitter_description: 'Favori karakterlerinizle yüksek kaliteli videolar üretin. WeryAI’da yükleyin veya seçin ve etkileşimli AI videoları oluşturun.',
            page: {
                title1: 'Ücretsiz AI karakter→video oluşturucu',
                title2: 'Favori karakterlerinizi hayata geçirin! Bir karakter fotoğrafı yükleyin veya 微鲤AI kütüphanesinden seçin ve etkileyici etkileşimli videolar üretin. İstediğiniz sahneyi promptta tarif edin, sinematik sonucu izleyin.',
                consistency: 'Sektör lideri karakter tutarlılığı: Gelişmiş AI, video boyunca karakterin benzersiz özelliklerini ve görünümünü korur.',
                interactive: 'Anlamlı etkileşimler oluşturun — birlikte yürümekten sohbet etmeye kadar. Hikâye anlatımı olasılıkları sınırsız.',
                faq: [
                    {
                        question: 'Belirli bir karakterle nasıl video oluştururum?',
                        answer: 'Karakter fotoğrafını yükleyin veya WeryAI’da bir karakter seçin. Ardından sahneyi/etkileşimi anlatan bir prompt yazın ve oluşturun.',
                    },
                    {
                        question: 'Herhangi bir karakter fotoğrafını kullanabilir miyim?',
                        answer: 'Evet, kullanma hakkınız varsa. AI, talimatlarınıza göre karakteri animasyonlaştırır.',
                    },
                    {
                        question: 'Video süresi için bir sınır var mı?',
                        answer: 'Model ve planınıza bağlıdır; genellikle 5–10 saniye.',
                    },
                    {
                        question: 'Karakterin tutarlı görünmesini nasıl sağlarım?',
                        answer: 'Referans görseli analiz ederek tüm karelerde görsel özellikleri stabil tutarız.',
                    },
                    {
                        question: 'Ücretsiz deneyebilir miyim?',
                        answer: 'Evet, günlük ücretsiz kredilerinizle karakter videoları oluşturabilirsiniz.',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI Karakterden Videoya nedir?',
                    answer: 'Belirli bir karakterin yer aldığı videolar üreten gelişmiş bir AI aracıdır. Fotoğraf yükleyin veya kütüphaneden seçin ve etkileşimli içerik oluşturun.',
                },
                {
                    question: 'Videoda karakter tutarlılığı nasıl çalışır?',
                    answer: 'AI, referans görseli kullanarak karakterin görünümünü klip boyunca stabil ve tanınabilir tutar.',
                },
                {
                    question: 'Benim ve karakterin birlikte olduğu bir video yapabilir miyim?',
                    answer: 'Evet. Etkileşimi promptta anlatın; AI buna uygun sahneyi oluşturur.',
                },
                {
                    question: 'Hangi modeller kullanılıyor?',
                    answer: 'Kling ve Google Veo gibi yüksek performanslı video modelleri kullanıyoruz; gerçekçi hareket ve karakter tutarlılığı için optimize edilmiştir.',
                },
                {
                    question: 'Maksimum süre nedir?',
                    answer: 'Planınıza bağlı olarak genellikle yüksek kalitede 5–10 saniye.',
                },
            ],
        },
        social_back: {
            title: 'Social Back - Arkadaşlarınla paylaş | 微鲤AI',
            description: `Arkadaşlarınla paylaş, arkadaşlarını 微鲤AI'ye kayıt olmaya davet et, sen ve arkadaşların ödüller kazanın.`,
            keywords: `social back, arkadaşlarınla paylaş, arkadaşları 微鲤AI'ye davet et, ödül kazan, 微鲤AI`,
        },
    },
}
